import { format } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { DateTime } from 'luxon';
import { CookieService, CookieModule } from 'ngx-cookie';
import { ChartsModule } from 'ng2-charts';
import { RouterModule, Router } from '@angular/router';
import * as momentNs from 'moment-timezone';
import { __extends, __assign } from 'tslib';
import { NgbModule, NgbModal, NgbModalModule, NgbDatepickerConfig, NgbDatepickerModule, NgbDateParserFormatter, NgbTooltip, NgbTooltipConfig, NgbTooltipModule, NgbDropdownModule, NgbTimepickerConfig, NgbTimepickerModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { number } from 'card-validator';
import { animate, keyframes, state, style, transition, trigger, query, stagger } from '@angular/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Subject, BehaviorSubject, fromEvent, merge, from, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, mergeMap, takeUntil, tap, switchMap, pairwise } from 'rxjs/operators';
import { isNumeric } from 'rxjs/internal-compatibility';
import { NG_VALUE_ACCESSOR, FormsModule, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, isPlatformBrowser, CurrencyPipe, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, Pipe, ChangeDetectorRef, forwardRef, EventEmitter, Output, ElementRef, ViewChild, ContentChildren, Injectable, Inject, PLATFORM_ID, TemplateRef, Directive, HostListener, ViewEncapsulation, Optional, APP_INITIALIZER } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BadgeSharedComponent = /** @class */ (function () {
    function BadgeSharedComponent() {
    }
    BadgeSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-badge',
                    template: "<span class=\"badge badge--{{ badge.type }}\">{{ badge.name }}</span>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.badge{padding:.25rem .35rem .2rem;text-transform:uppercase;font-family:\"Frank New\",sans-serif;font-weight:400;font-size:.625rem;color:#fff;border-radius:.1875rem}.badge:hover{color:#fff}@media (min-width:768px){.badge{font-size:.75rem;padding:.25rem .5rem .2rem}}.badge--success{background-color:#56e07b;color:#2f285a}.badge--success:hover{color:#2f285a}.badge--warning{background-color:#ffa400;color:#2f285a}.badge--warning:hover{color:#2f285a}.badge--alert{background-color:#c80a0a}.badge--info{background-color:#2f285a}.badge--disabled{background-color:#c8c8c8;color:#fff}.badge--disabled:hover{color:#2f285a}.badge--default{background-color:#737373;color:#fff}.badge--default:hover{color:#fff}"]
                }] }
    ];
    BadgeSharedComponent.propDecorators = {
        badge: [{ type: Input }]
    };
    return BadgeSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BadgeSharedModule = /** @class */ (function () {
    function BadgeSharedModule() {
    }
    BadgeSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        BadgeSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        BadgeSharedComponent
                    ]
                },] }
    ];
    return BadgeSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonSharedComponent = /** @class */ (function () {
    function ButtonSharedComponent() {
        this.disabled = false;
        this.btnSize = 'medium';
        this.btnShadow = false;
        this.btnType = 'button';
        this.fullWidth = false;
        this.loading = false;
    }
    Object.defineProperty(ButtonSharedComponent.prototype, "type", {
        get: /**
         * @return {?}
         */
        function () { return (this.button && this.button.type) ? this.button.type : 'button'; },
        enumerable: true,
        configurable: true
    });
    ButtonSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-button',
                    template: "<button [type]=\"btnType\" [disabled]=\"disabled\" class=\"sg-btn\"\n    [class.sg-btn--secondary]=\"btnStyle === 'secondary'\"\n    [class.sg-btn--tertiary]=\"btnStyle === 'tertiary'\"\n    [class.sg-btn--small]=\"btnSize === 'small'\"\n    [class.sg-btn--xsmall]=\"btnSize === 'xsmall'\"\n    [class.sg-btn--large]=\"btnSize === 'large'\"\n    [class.sg-btn--shadow]=\"btnShadow\"\n    [class.w-100]=\"fullWidth\"\n >\n    <span *ngIf=\"button && button.iconBefore\">\n        <mlp-ng-icon [name]=\"button.iconBefore\"\n            [class.sg-color]=\"button.iconStyle\"\n            [class.-primary]=\"button.iconStyle === 'primary'\"\n            [class.-secondary]=\"button.iconStyle === 'info'\"\n            [class.-danger]=\"button.iconStyle === 'danger'\"\n        ></mlp-ng-icon>\n    </span>\n    <span *ngIf=\"loading\">\n        <mlp-ng-spinner></mlp-ng-spinner>\n    </span>{{ label ? label : button.label }}<span *ngIf=\"button && button.labelSecondary || labelSecondary\" class=\"sg-btn--label\">\n        {{button && button.labelSecondary ? button.labelSecondary : labelSecondary}}\n    </span>\n</button>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    ButtonSharedComponent.propDecorators = {
        button: [{ type: Input }],
        disabled: [{ type: Input }],
        btnSize: [{ type: Input }],
        btnStyle: [{ type: Input }],
        btnShadow: [{ type: Input }],
        btnType: [{ type: Input }],
        fullWidth: [{ type: Input }],
        label: [{ type: Input }],
        labelSecondary: [{ type: Input }],
        loading: [{ type: Input }]
    };
    return ButtonSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonAtomSharedComponent = /** @class */ (function () {
    function ButtonAtomSharedComponent() {
        this.btnShadow = false;
        this.btnSize = 'medium';
        this.btnType = 'button';
        this.disabled = false;
        this.fullWidth = false;
    }
    ButtonAtomSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-button-atom',
                    template: "<button [type]=\"btnType\" [disabled]=\"disabled\" class=\"sg-btn\"\n    [class.sg-btn--secondary]=\"btnStyle === 'secondary'\"\n    [class.sg-btn--tertiary]=\"btnStyle === 'tertiary'\"\n    [class.sg-btn--xsmall]=\"btnSize === 'xsmall'\"\n    [class.sg-btn--small]=\"btnSize === 'small'\"\n    [class.sg-btn--large]=\"btnSize === 'large'\"\n    [class.sg-btn--shadow]=\"btnShadow\"\n    [class.w-100]=\"fullWidth\"\n    >{{ label }}<span *ngIf=\"labelSecondary\" class=\"sg-btn--label\">{{labelSecondary}}</span></button>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    ButtonAtomSharedComponent.propDecorators = {
        btnShadow: [{ type: Input }],
        btnSize: [{ type: Input }],
        btnStyle: [{ type: Input }],
        btnType: [{ type: Input }],
        disabled: [{ type: Input }],
        fullWidth: [{ type: Input }],
        label: [{ type: Input }],
        labelSecondary: [{ type: Input }]
    };
    return ButtonAtomSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var SPORT_ICONS = {
    athletics: 'custom-athletics',
    badminton: 'badminton-shuttlecock',
    basketball: 'basketball-ball',
    cricket: 'cricket-bat-ball',
    esports: 'video-game-xbox-controller',
    football: 'soccer-ball',
    futsal: 'custom-futstal',
    gaa: 'custom-gaelic-football',
    golf: 'golf-ball',
    gym: 'fitness-dumbbell',
    handball: 'custom-handball',
    hockey: 'custom-hockey',
    lacrosse: 'custom-lacrosse',
    netball: 'custom-netball',
    quidditch: 'custom-quidditch',
    rugby: 'custom-rugby',
    'space-hire': 'custom-space-hire',
    squash: 'custom-squash',
    swimming: 'swimming-pool-stairs',
    'table-tennis': 'ping-pong-paddle',
    tennis: 'custom-tennis',
    volleyball: 'volleyball-ball',
    'american-football': 'american-football-helmet',
    'padel-tennis': 'custom-padel',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TransformSportToIconNamePipe = /** @class */ (function () {
    function TransformSportToIconNamePipe() {
    }
    /**
     * @param {?} sport
     * @return {?}
     */
    TransformSportToIconNamePipe.prototype.transform = /**
     * @param {?} sport
     * @return {?}
     */
    function (sport) {
        for (var prop in SPORT_ICONS) {
            if (SPORT_ICONS.hasOwnProperty(prop) && prop === sport) {
                return SPORT_ICONS[prop];
            }
        }
        return sport;
    };
    TransformSportToIconNamePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'sportIconPipe'
                },] }
    ];
    return TransformSportToIconNamePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IconSharedComponent = /** @class */ (function () {
    function IconSharedComponent(transformSportToIconName) {
        this.transformSportToIconName = transformSportToIconName;
        this.size = 'default';
    }
    Object.defineProperty(IconSharedComponent.prototype, "setIconName", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._name = value.replace(' ', '-');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IconSharedComponent.prototype, "name", {
        get: /**
         * @return {?}
         */
        function () { return this.transformSportToIconName.transform(this._name); },
        enumerable: true,
        configurable: true
    });
    IconSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-icon',
                    template: "<i\n    [class]=\"'icon-' + name\"\n    [class.small]=\"size === 'small'\"\n    [class.medium]=\"size === 'medium'\"\n    [class.large]=\"size === 'large'\"\n    [class.spin]=\"animation === 'spin'\"\n></i>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{vertical-align:middle}:host i{font-family:icomoon!important;speak:none;font-style:normal;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}:host i.small{font-size:1rem;line-height:1rem}:host i.medium{font-size:2.375rem;line-height:2.375rem}:host i.large{font-size:2.75rem;line-height:2.75rem}:host i.spin::before{display:inline-block;-webkit-animation-name:spin;animation-name:spin;-webkit-animation-duration:1.5s;animation-duration:1.5s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}@-webkit-keyframes spin{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.icon-add:before{content:\"\\e900\"}.icon-add-circle:before{content:\"\\e901\"}.icon-alert-circle:before{content:\"\\e902\"}.icon-american-football-helmet:before{content:\"\\e903\"}.icon-analytics-board-bars:before{content:\"\\e904\"}.icon-arrow-down-1:before{content:\"\\e913\"}.icon-arrow-left-1:before{content:\"\\e906\"}.icon-arrow-right-1:before{content:\"\\e907\"}.icon-arrow-up-1:before{content:\"\\e908\"}.icon-athletics-pole-vault:before{content:\"\\e909\"}.icon-award-trophy-star-1:before{content:\"\\e90a\"}.icon-badminton-shuttlecock:before{content:\"\\e90b\"}.icon-basketball-ball:before{content:\"\\e90c\"}.icon-bin:before{content:\"\\e90d\"}.icon-cake-birthday:before{content:\"\\e90e\"}.icon-calendar-1:before{content:\"\\e90f\"}.icon-calendar-3:before{content:\"\\e910\"}.icon-calendar-check-1:before{content:\"\\e911\"}.icon-calendar-clock:before{content:\"\\e912\"}.icon-calendar-date:before{content:\"\\e913\"}.icon-calendar-disable-1:before{content:\"\\e914\"}.icon-calendar:before{content:\"\\e915\"}.icon-camera-studio:before{content:\"\\e916\"}.icon-check-1:before{content:\"\\e917\"}.icon-check-circle-1:before{content:\"\\e918\"}.icon-close:before{content:\"\\e919\"}.icon-cog-double:before{content:\"\\e91a\"}.icon-compass-arrow:before{content:\"\\e91b\"}.icon-compass-direction:before{content:\"\\e91c\"}.icon-compass-directions:before{content:\"\\e91d\"}.icon-conversation-text:before{content:\"\\e91e\"}.icon-cricket-bat-ball:before{content:\"\\e91f\"}.icon-cursor:before{content:\"\\e920\"}.icon-custom-apple:before{content:\"\\e921\"}.icon-custom-athletics:before{content:\"\\e922\"}.icon-custom-cc-amex:before{content:\"\\e923\"}.icon-custom-cc-mastercard:before{content:\"\\e924\"}.icon-custom-cc-stripe:before{content:\"\\e925\"}.icon-custom-cc-visa:before{content:\"\\e926\"}.icon-custom-checkbox-checked:before{content:\"\\e927\"}.icon-custom-checkbox-open:before{content:\"\\e928\"}.icon-custom-credit-card:before{content:\"\\e929\"}.icon-custom-eye-closed:before{content:\"\\e92a\"}.icon-custom-eye-open:before{content:\"\\e92b\"}.icon-custom-flash:before{content:\"\\e92c\"}.icon-custom-football:before{content:\"\\e92d\"}.icon-custom-futstal:before{content:\"\\e92e\"}.icon-custom-gaelic-football:before{content:\"\\e92f\"}.icon-custom-google:before{content:\"\\e930\"}.icon-custom-handball:before{content:\"\\e931\"}.icon-custom-hockey:before{content:\"\\e932\"}.icon-custom-lacrosse:before{content:\"\\e933\"}.icon-custom-navigation-menu:before{content:\"\\e934\"}.icon-custom-netball:before{content:\"\\e935\"}.icon-custom-padel:before{content:\"\\e936\"}.icon-custom-print:before{content:\"\\e937\"}.icon-custom-question-circle:before{content:\"\\e938\"}.icon-custom-quidditch:before{content:\"\\e939\"}.icon-custom-rugby:before{content:\"\\e93a\"}.icon-custom-shield-check:before{content:\"\\e93b\"}.icon-custom-shield-padlock:before{content:\"\\e93c\"}.icon-custom-space-hire:before{content:\"\\e93d\"}.icon-custom-spinner-solid:before{content:\"\\e93e\"}.icon-custom-sports:before{content:\"\\e93f\"}.icon-custom-squash:before{content:\"\\e940\"}.icon-custom-tennis:before{content:\"\\e941\"}.icon-custom-yahoo:before{content:\"\\e942\"}.icon-email-action-unread:before{content:\"\\e943\"}.icon-filter-1:before{content:\"\\e944\"}.icon-fitness-dumbbell:before{content:\"\\e945\"}.icon-flash:before{content:\"\\e946\"}.icon-golf-ball:before{content:\"\\e947\"}.icon-headphones-customer-support-human-1:before{content:\"\\e948\"}.icon-house-2:before{content:\"\\e949\"}.icon-information-circle:before{content:\"\\e94a\"}.icon-layout-module-1:before{content:\"\\e94b\"}.icon-list-bullets-1:before{content:\"\\e94c\"}.icon-lock-1:before{content:\"\\e94d\"}.icon-login-1:before{content:\"\\e94e\"}.icon-logout-1:before{content:\"\\e94f\"}.icon-maps-pin-1:before{content:\"\\e950\"}.icon-maps:before{content:\"\\e951\"}.icon-megaphone:before{content:\"\\e952\"}.icon-navigation-left-circle-1_1:before{content:\"\\e953\"}.icon-navigation-menu-horizontal:before{content:\"\\e954\"}.icon-navigation-menu:before{content:\"\\e955\"}.icon-notes-edit:before{content:\"\\e956\"}.icon-phone-circle:before{content:\"\\e957\"}.icon-phone:before{content:\"\\e958\"}.icon-ping-pong-paddle:before{content:\"\\e959\"}.icon-professional-network-linkedin:before{content:\"\\e95a\"}.icon-railroad-train:before{content:\"\\e95b\"}.icon-rating-star-solid-custom:before{content:\"\\e95c\"}.icon-rating-star:before{content:\"\\e95d\"}.icon-search:before{content:\"\\e95e\"}.icon-share-1:before{content:\"\\e95f\"}.icon-single-neutral-actions-add:before{content:\"\\e960\"}.icon-single-neutral-circle:before{content:\"\\e961\"}.icon-single-neutral:before{content:\"\\e962\"}.icon-soccer-ball:before{content:\"\\e963\"}.icon-soccer-player-ball:before{content:\"\\e964\"}.icon-social-instagram:before{content:\"\\e965\"}.icon-social-media-facebook-1:before{content:\"\\e966\"}.icon-social-media-twitter:before{content:\"\\e967\"}.icon-space-rocket-flying:before{content:\"\\e968\"}.icon-stopwatch:before{content:\"\\e969\"}.icon-style-one-pin-bolt:before{content:\"\\e96a\"}.icon-style-one-pin:before{content:\"\\e96b\"}.icon-style-two-pin-marker:before{content:\"\\e96c\"}.icon-subtract-circle:before{content:\"\\e96d\"}.icon-swimming-pool-stairs:before{content:\"\\e96e\"}.icon-tennis-racquet:before{content:\"\\e96f\"}.icon-time-clock-circle-1:before{content:\"\\e970\"}.icon-tools-wench:before{content:\"\\e971\"}.icon-video-game-xbox-controller:before{content:\"\\e972\"}.icon-view-off:before{content:\"\\e973\"}.icon-view:before{content:\"\\e974\"}.icon-volleyball-ball:before{content:\"\\e975\"}.icon-multiple-neutral-1:before{content:\"\\e976\"}.icon-graph-stats-ascend:before{content:\"\\e977\"}.icon-social-whatsapp:before{content:\"\\ea93\"}.icon-external-link:before{content:\"\\ea94\"}"]
                }] }
    ];
    /** @nocollapse */
    IconSharedComponent.ctorParameters = function () { return [
        { type: TransformSportToIconNamePipe }
    ]; };
    IconSharedComponent.propDecorators = {
        size: [{ type: Input }],
        animation: [{ type: Input }],
        setIconName: [{ type: Input, args: ['name',] }]
    };
    return IconSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IconSharedModule = /** @class */ (function () {
    function IconSharedModule() {
    }
    IconSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        IconSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        IconSharedComponent
                    ],
                    providers: [
                        TransformSportToIconNamePipe
                    ]
                },] }
    ];
    return IconSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SpinnerSharedComponent = /** @class */ (function () {
    function SpinnerSharedComponent() {
    }
    SpinnerSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-spinner',
                    template: "<mlp-ng-icon name=\"custom-spinner-solid\" animation=\"spin\"></mlp-ng-icon>\n"
                }] }
    ];
    return SpinnerSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SpinnerSharedModule = /** @class */ (function () {
    function SpinnerSharedModule() {
    }
    SpinnerSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SpinnerSharedComponent
                    ],
                    imports: [
                        IconSharedModule
                    ],
                    exports: [
                        SpinnerSharedComponent
                    ]
                },] }
    ];
    return SpinnerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonIconSharedComponent = /** @class */ (function () {
    function ButtonIconSharedComponent() {
        this.disabled = false;
        this.btnSize = 'medium';
        this.btnShadow = false;
        this.btnType = 'button';
        this.fullWidth = false;
    }
    ButtonIconSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-button-icon',
                    template: "<button [type]=\"btnType\" [disabled]=\"disabled\" class=\"sg-btn\"\n        [class.sg-btn--secondary]=\"btnStyle === 'secondary'\"\n        [class.sg-btn--tertiary]=\"btnStyle === 'tertiary'\"\n        [class.sg-btn--small]=\"btnSize === 'small'\"\n        [class.sg-btn--xsmall]=\"btnSize === 'xsmall'\"\n        [class.sg-btn--large]=\"btnSize === 'large'\"\n        [class.sg-btn--shadow]=\"btnShadow\"\n        [class.w-100]=\"fullWidth\"\n><mlp-ng-icon [name]=\"btnIcon\" *ngIf=\"btnIcon\" [class]=\"btnIconClass ? btnIconClass : ''\"></mlp-ng-icon>{{ label }}<span *ngIf=\"labelSecondary\" class=\"sg-btn--label\">{{labelSecondary}}</span></button>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    ButtonIconSharedComponent.propDecorators = {
        disabled: [{ type: Input }],
        btnSize: [{ type: Input }],
        btnIcon: [{ type: Input }],
        btnIconClass: [{ type: Input }],
        btnStyle: [{ type: Input }],
        btnShadow: [{ type: Input }],
        btnType: [{ type: Input }],
        fullWidth: [{ type: Input }],
        label: [{ type: Input }],
        labelSecondary: [{ type: Input }]
    };
    return ButtonIconSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonSharedModule = /** @class */ (function () {
    function ButtonSharedModule() {
    }
    ButtonSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ButtonSharedComponent,
                        ButtonAtomSharedComponent,
                        ButtonIconSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        SpinnerSharedModule
                    ],
                    exports: [
                        ButtonSharedComponent,
                        ButtonAtomSharedComponent,
                        ButtonIconSharedComponent
                    ]
                },] }
    ];
    return ButtonSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return CheckBoxSharedComponent; }),
    multi: true
};
var CheckBoxSharedComponent = /** @class */ (function () {
    function CheckBoxSharedComponent(ref) {
        this.ref = ref;
        this.isTicked = false;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    CheckBoxSharedComponent.prototype.update = /**
     * @return {?}
     */
    function () {
        this.isTicked = !this.isTicked;
        this.onChange(this.isTicked);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckBoxSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckBoxSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    CheckBoxSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (!value) {
            this.isTicked = false;
            this.value = false;
        }
        if (value) {
            this.isTicked = true;
            this.value = value;
        }
        this.ref.markForCheck();
    };
    CheckBoxSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-shared-checkbox',
                    template: "<label class=\"sg-checkbox mb-0\" \n    [ngClass]=\"{ \n        '-small': size, \n        '-button': checkboxStyle === 'button',\n        '-checked': isTicked && checkboxStyle === 'button' }\"\n    role=\"checkbox\">\n    <span class=\"sg-checkbox__label\" [ngClass]=\"{'-fullsize': checkboxStyle === 'button'}\"><ng-content></ng-content></span>\n    <input class=\"sg-checkbox__input\" type=\"checkbox\" [checked]=\"isTicked\" (change)=\"update()\">\n    <span class=\"sg-checkbox__checkmark\" \n        [ngClass]=\"{ \n            '-small': size, \n            '-secondary': checkboxStyle === 'secondary',\n            '-checked': isTicked,\n            'd-none': checkboxStyle === 'button'\n        }\"></span>\n</label>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR
                    ],
                    styles: ["@charset \"UTF-8\";.sg-checkbox{display:block;position:relative;padding-left:25px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1.2}.sg-checkbox__label{font-size:80%}.sg-checkbox__label.-fullsize{font-size:100%}.sg-checkbox.-small{padding-left:1.25rem}.sg-checkbox.-button{display:inline-block;cursor:pointer;border-radius:.25rem;background-color:#fff;border:1px solid #007bff;padding:.25rem .75rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-checkbox.-button.-small{padding:.15rem .5rem;font-size:.875rem}.sg-checkbox.-button.-checked{background-color:#007bff;color:#fff}.sg-checkbox__input{position:absolute;opacity:0}.sg-checkbox__checkmark{position:absolute;top:0;left:0;height:20px;width:20px;border-radius:.25rem;background-color:#fff;border:1px solid #2f285a;transition:background-color 250ms ease-in-out,border 250ms ease-in-out}.sg-checkbox__checkmark:after{content:\"\";position:absolute;display:none;left:7px;top:3px;width:5px;height:10px;border:solid #2f285a;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.sg-checkbox__checkmark.-secondary{border:1px solid #56e07b}.sg-checkbox__checkmark.-secondary:after{border:solid #56e07b;border-width:0 3px 3px 0}.sg-checkbox__checkmark.-small{height:15px;width:15px;top:3px}.sg-checkbox__checkmark.-small:after{left:4px;top:1px}.sg-checkbox__checkmark.-checked:after{display:block}"]
                }] }
    ];
    /** @nocollapse */
    CheckBoxSharedComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    CheckBoxSharedComponent.propDecorators = {
        value: [{ type: Input }],
        checkboxStyle: [{ type: Input }],
        size: [{ type: Input }]
    };
    return CheckBoxSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CheckBoxSharedModule = /** @class */ (function () {
    function CheckBoxSharedModule() {
    }
    CheckBoxSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CheckBoxSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        CheckBoxSharedComponent
                    ]
                },] }
    ];
    return CheckBoxSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DaySharedComponent = /** @class */ (function () {
    function DaySharedComponent() {
    }
    DaySharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-day',
                    template: "<div class=\"d-inline-flex flex-md-column text-center\">\n    <div class=\"mr-1 mr-md-0\">{{dateInput | fnsFormat: 'EEE'}}</div>\n    <div class=\"mr-1 mr-md-0 day\">{{dateInput | fnsFormat: 'd'}}</div>\n    <div class=\"mr-1 mr-md-0\">{{dateInput | fnsFormat: 'LLL'}}</div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{color:#464a4c;font-weight:700;text-transform:uppercase;letter-spacing:1px;line-height:normal}:host .day{color:#464a4c}@media (min-width:768px){:host{color:#aeadad;font-size:.6875rem;font-weight:400}:host .day{font-size:2.125rem;font-weight:700;letter-spacing:.5px;margin-top:-4px;margin-bottom:-2px}}"]
                }] }
    ];
    DaySharedComponent.propDecorators = {
        dateInput: [{ type: Input }]
    };
    return DaySharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FnsFormatPipe = /** @class */ (function () {
    function FnsFormatPipe() {
    }
    /**
     * @param {?} date
     * @param {?=} formatBy
     * @return {?}
     */
    FnsFormatPipe.prototype.transform = /**
     * @param {?} date
     * @param {?=} formatBy
     * @return {?}
     */
    function (date, formatBy) {
        return date ? format(date, formatBy) : '';
    };
    FnsFormatPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'fnsFormat'
                },] }
    ];
    return FnsFormatPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FnsFormatPipeModule = /** @class */ (function () {
    function FnsFormatPipeModule() {
    }
    FnsFormatPipeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        FnsFormatPipe
                    ],
                    exports: [
                        FnsFormatPipe
                    ]
                },] }
    ];
    return FnsFormatPipeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DaySharedModule = /** @class */ (function () {
    function DaySharedModule() {
    }
    DaySharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        DaySharedComponent
                    ],
                    imports: [
                        FnsFormatPipeModule
                    ],
                    exports: [
                        DaySharedComponent
                    ]
                },] }
    ];
    return DaySharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ImageSharedComponent = /** @class */ (function () {
    function ImageSharedComponent() {
    }
    Object.defineProperty(ImageSharedComponent.prototype, "image", {
        set: /**
         * @param {?} image
         * @return {?}
         */
        function (image) {
            if (image) {
                this.defaultImg = image.large[0];
                this.srcset = image.small[0] + " 400w, " + image.medium[0] + " 640w, " + image.large[0] + " 1024w";
            }
        },
        enumerable: true,
        configurable: true
    });
    ImageSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-image',
                    template: "<img [attr.data-src]=\"defaultImg\" [attr.data-srcset]=\"srcset\" [title]=\"title\" [alt]=\"alt ? alt : ''\" class=\"lazyload\" loading=\"lazy\">\n<ng-content></ng-content>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{width:100%;padding-bottom:66.66%;position:relative;background-color:#eceeef}img{position:absolute;top:0;left:0;width:100%;height:100%}"]
                }] }
    ];
    ImageSharedComponent.propDecorators = {
        title: [{ type: Input }],
        alt: [{ type: Input }],
        image: [{ type: Input }]
    };
    return ImageSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ImageSharedModule = /** @class */ (function () {
    function ImageSharedModule() {
    }
    ImageSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ImageSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ImageSharedComponent
                    ]
                },] }
    ];
    return ImageSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(function () { return InputAtomSharedComponent; }),
    multi: true
};
var InputAtomSharedComponent = /** @class */ (function () {
    function InputAtomSharedComponent() {
        // tslint:disable-next-line:no-input-rename
        this._value = '';
        this.placeholder = '';
        this.inputType = 'text';
        this.inputId = '';
        this.inputName = '';
        this.inputDisabled = false;
        this.noBorder = false;
        this.errors = [];
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(InputAtomSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    InputAtomSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputAtomSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputAtomSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputAtomSharedComponent.prototype.updateValue = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.value = (/** @type {?} */ (event.target)).value;
    };
    InputAtomSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input-atom',
                    template: "<input \n    class=\"form-control sg-input__input\"\n    [class.sg-input__input]=\"!noBorder\"\n    [class.sg-input-group__input-molecule]=\"noBorder\"\n    [type]=\"inputType\"\n    [id]=\"inputId\"\n    [name]=\"inputName\"\n    [placeholder]=\"placeholder\"\n    [disabled]=\"inputDisabled\"\n    (input)=\"updateValue($event)\"\n    (focus)=\"focus.emit($event)\"\n    (blur)=\"blur.emit($event)\"\n    [value]=\"_value\"\n/>\n\n<small\n    *ngFor=\"let error of errors\"\n    class=\"form-text\"\n    [class.sg-input__error]=\"errors.length\"\n>\n    {{ error.title }}\n</small>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR
                    ],
                    styles: ["@charset \"UTF-8\";.sg-input-group{border:1px solid #d6d5d5;border-radius:.25rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-input-group__input-molecule{color:#373737;height:calc(1.5em + .75rem + 2px + 8px);box-shadow:none;border:none;padding:.275rem .75rem}.sg-input-group__input-molecule:focus{background-color:#f4f4f7}.sg-input-group__prepend__icon{background-color:#fff;color:#6c757d;width:44px}.sg-input-group__prepend__divider{background-color:#fff}.sg-input-group__prepend__divider__line{height:24px;width:2px;background-color:#d6d5d5}.sg-input-group__focus{border-color:#2f285a}.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group__prepend__divider__line{background-color:#2f285a}.sg-input-group__focus .sg-input-group-append-button-icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group-append-button-icon:hover{background-color:#f4f4f7!important}.sg-input-group__icon .sg-input-group__input-molecule{border-left:0}.sg-input-group__error{border-color:#c80a0a}.sg-input-group__secondary{box-shadow:0 2px 6px 0 rgba(0,0,0,.25)}.sg-input-group__secondary .sg-input-group__input-molecule{background-clip:unset;-webkit-appearance:none}.sg-input-group__secondary .sg-input-group__input-molecule:focus,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#fff}.sg-input-group-append-button-icon{transition:none;border-top-left-radius:0;border-bottom-left-radius:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff;color:#6c757d!important}.sg-input-group-append-button-icon:hover{color:#373737!important;background-color:#fff!important}.sg-input-group-append-button-icon__loading{padding-left:.1875rem;padding-right:.1875rem}"]
                }] }
    ];
    InputAtomSharedComponent.propDecorators = {
        _value: [{ type: Input, args: ['value',] }],
        placeholder: [{ type: Input }],
        inputType: [{ type: Input }],
        inputId: [{ type: Input }],
        inputName: [{ type: Input }],
        inputDisabled: [{ type: Input }],
        noBorder: [{ type: Input }],
        errors: [{ type: Input }],
        blur: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return InputAtomSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputAtomSharedModule = /** @class */ (function () {
    function InputAtomSharedModule() {
    }
    InputAtomSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputAtomSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        InputAtomSharedComponent
                    ]
                },] }
    ];
    return InputAtomSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LabelSharedComponent = /** @class */ (function () {
    function LabelSharedComponent() {
    }
    Object.defineProperty(LabelSharedComponent.prototype, "for", {
        get: /**
         * @return {?}
         */
        function () { return (this.label.for) ? this.label.for : ''; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelSharedComponent.prototype, "subText", {
        get: /**
         * @return {?}
         */
        function () { return (this.label.optional) ? '(optional)' : (this.label.subText) ? this.label.subText : ''; },
        enumerable: true,
        configurable: true
    });
    LabelSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-label',
                    template: "<label [for]=\"for\" class=\"col-form-label\">\n    <strong>{{ label.name }}</strong>\n    <ng-container *ngIf=\"subText\">\n        <small class=\"d-md-block\"><em>{{ subText }}</em></small>\n    </ng-container>\n</label>",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    LabelSharedComponent.propDecorators = {
        label: [{ type: Input }]
    };
    return LabelSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LabelSharedModule = /** @class */ (function () {
    function LabelSharedModule() {
    }
    LabelSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LabelSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        LabelSharedComponent
                    ]
                },] }
    ];
    return LabelSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ListSharedComponent = /** @class */ (function () {
    function ListSharedComponent() {
    }
    ListSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-list',
                    template: "<ul class=\"sg-list\" [ngClass]=\"{'-smaller': size}\">\n    <li class=\"sg-list__item\" *ngFor=\"let item of list\">\n        <mlp-ng-icon [name]=\"item.left_icon\" *ngIf=\"item.left_icon\"></mlp-ng-icon>\n        <div [innerHTML]=\"item.name\" class=\"d-inline\"></div>\n        <mlp-ng-icon [name]=\"item.icon\" *ngIf=\"item.icon\"></mlp-ng-icon>\n    </li>\n</ul>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-list{margin:0;padding:0;list-style-type:none;font-size:.875rem;color:#373737}@media (min-width:768px){.sg-list{font-size:1rem}.sg-list.-smaller{font-size:.875rem}}.sg-list__item ::ng-deep span{color:#56e07b}"]
                }] }
    ];
    ListSharedComponent.propDecorators = {
        list: [{ type: Input }],
        size: [{ type: Input }]
    };
    return ListSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ListSharedModule = /** @class */ (function () {
    function ListSharedModule() {
    }
    ListSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ListSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        ListSharedComponent
                    ]
                },] }
    ];
    return ListSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var RADIO_CUSTOM_INPUT_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return RadioSharedComponent; }),
    multi: true
};
var RadioSharedComponent = /** @class */ (function () {
    function RadioSharedComponent() {
        this.name = '';
        this.disable = false;
        // tslint:disable-next-line:no-input-rename
        this._value = '';
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(RadioSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._value;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (typeof value !== 'undefined') {
            this.value = value;
        }
        if (typeof value === 'undefined') {
            this.value = '';
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @return {?}
     */
    RadioSharedComponent.prototype.switch = /**
     * @return {?}
     */
    function () {
        this.value = this.radioValue;
    };
    RadioSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-radio',
                    template: "<ng-template [ngIf]=\"!config?.style\" [ngIfElse]=\"button\">\n    <label class=\"sg-radio mr-3\" role=\"radio\" (click)=\"!disable ? switch() : false\">\n        <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"input\"></ng-container>\n        <span class=\"sg-radio__checkmark\"></span>\n    </label>\n</ng-template>\n\n<ng-template #button>\n    <label role=\"radio\" (click)=\"!disable ? switch() : false\">\n        <ng-container *ngTemplateOutlet=\"input\"></ng-container>\n        <div class=\"sg-radio__button\" [ngClass]=\"{'sg-radio__button--small': config?.size === 'small'}\">\n            <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n        </div>\n    </label>\n</ng-template>\n\n<ng-template #input>\n    <input class=\"sg-radio__input\" type=\"radio\" [name]=\"name\" [value]=\"radioValue\" [disabled]=\"disable\" [checked]=\"value === radioValue\">\n</ng-template>\n\n<ng-template #content>\n    <ng-content></ng-content>\n</ng-template>\n",
                    providers: [
                        RADIO_CUSTOM_INPUT_ACCESSOR
                    ],
                    styles: ["@charset \"UTF-8\";:host{display:inline-block}.sg-radio{position:relative;padding-top:.25rem;padding-left:1.25rem;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#373737}.sg-radio__button{cursor:pointer;border-radius:.25rem;background-color:#fff;border:1px solid #2f285a;padding:.25rem .75rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-radio__button--small{padding:.15rem .5rem;font-size:.875rem}.sg-radio--disabled{color:#737373}.sg-radio__input{display:none}.sg-radio__input:disabled~.sg-radio__checkmark:after{top:0;left:0;height:12px;width:12px;background-color:#ececec}.sg-radio__input:checked~.sg-radio__checkmark:after,.sg-radio__input:disabled~.sg-radio__checkmark:after{opacity:1}.sg-radio__input:checked~.sg-radio__button,.sg-radio__input:disabled~.sg-radio__button{background-color:#2f285a;color:#fff}.sg-radio__input:disabled:checked~.sg-radio__checkmark:after{top:4px;left:4px;width:5px;height:5px;opacity:.45;background-color:#737373}.sg-radio__input:checked~.sg-radio__checkmark{background-color:#56e07b;border-color:transparent}.sg-radio__checkmark{position:absolute;top:.5rem;left:0;height:15px;width:15px;background-color:#fff;border:1px solid #c8c8c8;border-radius:50%}.sg-radio__checkmark:after{content:\"\";position:absolute;opacity:0;top:4px;left:4px;width:5px;height:5px;border-radius:50%;background-color:#2f285a;transition:opacity 250ms ease-in-out}"]
                }] }
    ];
    RadioSharedComponent.propDecorators = {
        name: [{ type: Input }],
        radioValue: [{ type: Input }],
        config: [{ type: Input }],
        disable: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }]
    };
    return RadioSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var RadioSharedModule = /** @class */ (function () {
    function RadioSharedModule() {
    }
    RadioSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        RadioSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        RadioSharedComponent
                    ]
                },] }
    ];
    return RadioSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR$1 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return SelectAtomSharedComponent; }),
    multi: true
};
var SelectAtomSharedComponent = /** @class */ (function () {
    function SelectAtomSharedComponent(ref) {
        this.ref = ref;
        this.options = [];
        this.disable = false;
        this.errors = [];
        this.shadow = false;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(SelectAtomSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._value;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.selectedValue = val;
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectAtomSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (typeof value !== 'undefined') {
            this.value = value;
        }
        if (typeof value === 'undefined') {
            this.value = '';
        }
        this.ref.markForCheck();
        this.switched();
    };
    /**
     * @param {?} o1
     * @param {?} o2
     * @return {?}
     */
    SelectAtomSharedComponent.prototype.customCompare = /**
     * @param {?} o1
     * @param {?} o2
     * @return {?}
     */
    function (o1, o2) {
        if (o1 && typeof o1 === 'object' && (JSON.stringify(o1) === JSON.stringify(o2)))
            return true;
        return o1 === o2;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectAtomSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectAtomSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @return {?}
     */
    SelectAtomSharedComponent.prototype.switched = /**
     * @return {?}
     */
    function () {
        this.value = this.selectedValue;
    };
    SelectAtomSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-select-atom',
                    template: "<select [disabled]=\"disable\" [(ngModel)]=\"selectedValue\" (ngModelChange)=\"switched()\" [compareWith]=\"customCompare\"\n        [class.--shadow]=\"shadow\"\n    class=\"custom-select sg-select d-block w-100\" [ngClass]=\"{'sg-select__error': errors.length }\">\n    <option *ngFor=\"let option of options\" [ngValue]=\"option.data\">{{ option.description }}</option>\n</select>\n\n<small class=\"form-text\" [ngClass]=\"{'sg-select__error-text': errors.length }\" *ngFor=\"let error of errors\">{{ error.title }}</small>\n",
                    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR$1],
                    styles: ["@charset \"UTF-8\";.sg-select{color:#373737;height:calc(1.5em + .75rem + 2px + 8px)}.sg-select:focus{border-color:#d6d5d5;box-shadow:none}.sg-select__error,.sg-select__error:focus{border:1px solid #c80a0a}.sg-select__error-text{color:#c80a0a}.sg-select.--shadow{border-color:#d6d5d5;box-shadow:0 2px 6px 0 rgba(0,0,0,.25)}"]
                }] }
    ];
    /** @nocollapse */
    SelectAtomSharedComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    SelectAtomSharedComponent.propDecorators = {
        options: [{ type: Input }],
        disable: [{ type: Input }],
        errors: [{ type: Input }],
        shadow: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }]
    };
    return SelectAtomSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SelectAtomSharedModule = /** @class */ (function () {
    function SelectAtomSharedModule() {
    }
    SelectAtomSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SelectAtomSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule
                    ],
                    exports: [
                        SelectAtomSharedComponent
                    ]
                },] }
    ];
    return SelectAtomSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonInternalAtomSharedComponent = /** @class */ (function () {
    function TextButtonInternalAtomSharedComponent() {
        this.uppercase = true;
    }
    /**
     * @return {?}
     */
    TextButtonInternalAtomSharedComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.attributes) {
            Object.keys(this.attributes).forEach(function (key) {
                _this.aTagElement.nativeElement.setAttribute(key, _this.attributes[key]);
            });
        }
    };
    TextButtonInternalAtomSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-text-button-internal-atom',
                    template: "<a href=\"\" \n    class=\"text-button-default sg-heading__h4 font-weight-normal\"\n    [class.text-uppercase]=\"uppercase\"\n    [class.text-button-default__light]=\"color === 'light'\"\n    #aTag \n    [routerLink]=\"url\">{{label}} <mlp-ng-icon *ngIf=\"icon\" [name]=\"icon\"></mlp-ng-icon></a>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.text-button-default{color:#2f285a}.text-button-default:hover{color:#6d688b}.text-button-default__light{color:#188155}.text-button-default__light:hover{color:#5da788}"]
                }] }
    ];
    TextButtonInternalAtomSharedComponent.propDecorators = {
        attributes: [{ type: Input }],
        label: [{ type: Input }],
        url: [{ type: Input }],
        icon: [{ type: Input }],
        uppercase: [{ type: Input }],
        color: [{ type: Input }],
        aTagElement: [{ type: ViewChild, args: ['aTag',] }]
    };
    return TextButtonInternalAtomSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonInternalAtomSharedModule = /** @class */ (function () {
    function TextButtonInternalAtomSharedModule() {
    }
    TextButtonInternalAtomSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TextButtonInternalAtomSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        RouterModule.forChild([])
                    ],
                    exports: [
                        TextButtonInternalAtomSharedComponent
                    ]
                },] }
    ];
    return TextButtonInternalAtomSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonExternalAtomSharedComponent = /** @class */ (function () {
    function TextButtonExternalAtomSharedComponent() {
        this.uppercase = true;
    }
    /**
     * @return {?}
     */
    TextButtonExternalAtomSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.attributes) {
            Object.keys(this.attributes).forEach(function (key) {
                _this.aTagElement.nativeElement.setAttribute(key, _this.attributes[key]);
            });
        }
    };
    TextButtonExternalAtomSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-text-button-external-atom',
                    template: "<a \n    [href]=\"url\" \n    class=\"text-button-default sg-heading__h4 font-weight-normal\"\n    [class.text-uppercase]=\"uppercase\"\n    [class.text-button-default__light]=\"color === 'light'\"\n    #aTag \n    target=\"_blank\">{{label}} <mlp-ng-icon *ngIf=\"icon\" [name]=\"icon\"></mlp-ng-icon></a>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.text-button-default{color:#2f285a}.text-button-default:hover{color:#6d688b}.text-button-default__light{color:#188155}.text-button-default__light:hover{color:#5da788}"]
                }] }
    ];
    TextButtonExternalAtomSharedComponent.propDecorators = {
        attributes: [{ type: Input }],
        label: [{ type: Input }],
        url: [{ type: Input }],
        icon: [{ type: Input }],
        uppercase: [{ type: Input }],
        color: [{ type: Input }],
        aTagElement: [{ type: ViewChild, args: ['aTag',] }]
    };
    return TextButtonExternalAtomSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonExternalAtomSharedModule = /** @class */ (function () {
    function TextButtonExternalAtomSharedModule() {
    }
    TextButtonExternalAtomSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TextButtonExternalAtomSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        TextButtonExternalAtomSharedComponent
                    ]
                },] }
    ];
    return TextButtonExternalAtomSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ProgressBarSharedComponent = /** @class */ (function () {
    function ProgressBarSharedComponent() {
        this.barStyle = 'secondary';
        this.progress = 0;
    }
    ProgressBarSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-progress-bar',
                    template: "<div class=\"w-100 mr-2 progress\">\n    <div\n        class=\"d-flex progress-bar\"\n        [class.progress-bar--danger]=\"barStyle === 'danger'\"\n        [class.progress-bar--warn]=\"barStyle === 'warn'\"\n        [class.progress-bar--secondary]=\"barStyle === 'secondary'\"\n        role=\"progressbar\"\n        [style.width]=\"progress + '%'\"\n    ></div>\n</div>",
                    styles: ["@charset \"UTF-8\";:host .progress{height:.469rem}:host .progress .progress-bar{border-radius:.25rem}:host .progress .progress-bar--danger{background-color:#c80a0a}:host .progress .progress-bar--warn{background-color:#ffbf00}:host .progress .progress-bar--secondary{background-color:#56e07b}"]
                }] }
    ];
    ProgressBarSharedComponent.propDecorators = {
        barStyle: [{ type: Input }],
        progress: [{ type: Input }]
    };
    return ProgressBarSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ProgressBarSharedModule = /** @class */ (function () {
    function ProgressBarSharedModule() {
    }
    ProgressBarSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ProgressBarSharedComponent
                    ],
                    exports: [
                        ProgressBarSharedComponent
                    ]
                },] }
    ];
    return ProgressBarSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonSocialSharedComponent = /** @class */ (function () {
    function ButtonSocialSharedComponent() {
    }
    ButtonSocialSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sg-ng-button-social',
                    template: "<button \n    type=\"button\" \n    class=\"sg-btn sg-social-btn\"\n    [class.-facebook]=\"social === 'facebook'\"\n    [class.-google]=\"social === 'google'\"\n><img [src]=\"path + social + '.svg'\" class=\"sg-social-btn__img\"> {{ label }}</button>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{display:block;width:100%}.sg-social-btn{width:100%;text-transform:none}.sg-social-btn__img{width:20px;height:auto;margin-right:1rem}.sg-social-btn.-facebook,.sg-social-btn.-facebook:hover{background-color:#4267b2;color:#fff}.sg-social-btn.-google{background-color:#fff;color:#373737;border:1px solid #373737}.sg-social-btn.-google:hover{background-color:#f4f4f7;color:#373737}"]
                }] }
    ];
    ButtonSocialSharedComponent.propDecorators = {
        label: [{ type: Input }],
        social: [{ type: Input }],
        path: [{ type: Input }]
    };
    return ButtonSocialSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonSocialSharedModule = /** @class */ (function () {
    function ButtonSocialSharedModule() {
    }
    ButtonSocialSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ButtonSocialSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ButtonSocialSharedComponent
                    ]
                },] }
    ];
    return ButtonSocialSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Animations settings are stored here
  @type {?} */
var ANIMATIONS = {
    speed: {
        default: '225ms',
        slow: '450ms',
        leave: '195ms'
    },
    bezierCurve: {
        default: 'ease-in-out'
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * \@example
 * [\@ngForAnimationFold]="item.open ? 'opened' : 'closed'"
 *
  @type {?} */
var foldDownUpAnimation = trigger('ngForAnimationFold', [
    state('closed', style({
        height: 0,
        opacity: 0,
        pointerEvents: 'none'
    })),
    state('opened', style({
        height: '*',
        opacity: 1,
        pointerEvents: 'inherit'
    })),
    transition('closed => opened', [
        animate(ANIMATIONS.speed.default + " " + ANIMATIONS.bezierCurve.default, keyframes([
            style({ height: 0, opacity: 0 }),
            style({ height: '*', opacity: 0.3 }),
            style({ height: '*', opacity: 1 })
        ]))
    ]),
    transition('opened => closed', [
        animate(ANIMATIONS.speed.leave + " " + ANIMATIONS.bezierCurve.default, keyframes([
            style({ height: '*', opacity: 1 }),
            style({ height: '*', opacity: 0.3 }),
            style({ height: 0, opacity: 0 })
        ]))
    ])
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AccordionComponent = /** @class */ (function () {
    function AccordionComponent() {
    }
    AccordionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-accordion',
                    template: "<div class=\"accordion\">\n    <div class=\"accordion-item pb-3 mb-3\" *ngFor=\"let item of items\">\n        <div class=\"d-flex flex-row justify-content-between\" (click)=\"item.open = !item.open\">\n            <div [class.sg-link]=\"!item.open\"><b>{{item.title}}</b></div>\n            <div class=\"sg-color\">\n                <mlp-ng-icon [name]=\"item.open ? 'subtract-circle' : 'add-circle'\"></mlp-ng-icon>\n            </div>\n        </div>\n        <small class=\"d-block description pr-3\" [@ngForAnimationFold]=\"item.open ? 'opened' : 'closed'\" [innerHTML]=\"item.desc\"></small>\n    </div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [foldDownUpAnimation],
                    styles: ["@charset \"UTF-8\";:host .accordion{font-size:1rem}:host .accordion .accordion-item{border-bottom:1px solid #dfdfdf;color:#373737}:host .accordion .accordion-item>div{cursor:pointer}:host .accordion .accordion-item .description{padding-top:.5rem}"]
                }] }
    ];
    AccordionComponent.propDecorators = {
        items: [{ type: Input }]
    };
    return AccordionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AccordionSharedModule = /** @class */ (function () {
    function AccordionSharedModule() {
    }
    AccordionSharedModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    declarations: [AccordionComponent],
                    exports: [AccordionComponent]
                },] }
    ];
    return AccordionSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AccordionContentComponent = /** @class */ (function () {
    function AccordionContentComponent() {
        this.open = false;
        this.toggle = new EventEmitter();
    }
    AccordionContentComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-accordion-content',
                    template: "<div class=\"accordion-item pb-3 mb-3\">\n    <div class=\"d-flex flex-row justify-content-between \" (click)=\"open = !open\">\n        <div [class.sg-link]=\"!open\"><b>{{title}}</b></div>\n        <div class=\"sg-color\">\n            <mlp-ng-icon [name]=\"open ? 'subtract-circle' : 'add-circle'\"></mlp-ng-icon>\n        </div>\n    </div>\n    <div class=\"d-block description\" [@ngForAnimationFold]=\"open ? 'opened' : 'closed'\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [foldDownUpAnimation],
                    styles: ["@charset \"UTF-8\";:host .accordion-item{border-bottom:1px solid #dfdfdf;color:#373737}:host .accordion-item>div.d-flex{cursor:pointer}:host .accordion-item .description{padding-top:.5rem}"]
                }] }
    ];
    AccordionContentComponent.propDecorators = {
        open: [{ type: Input }],
        title: [{ type: Input }],
        toggle: [{ type: Output }]
    };
    return AccordionContentComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AccordionContainerComponent = /** @class */ (function () {
    function AccordionContainerComponent() {
    }
    /**
     * @return {?}
     */
    AccordionContainerComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.panels.toArray().forEach(function (panel) {
            panel.toggle.subscribe(function () {
                _this.openPanel(panel);
            });
        });
    };
    /**
     * @param {?} panel
     * @return {?}
     */
    AccordionContainerComponent.prototype.openPanel = /**
     * @param {?} panel
     * @return {?}
     */
    function (panel) {
        this.panels.toArray().forEach(function (p) { return p.open = false; });
        panel.open = true;
    };
    AccordionContainerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-accordion-container',
                    template: '<ng-content></ng-content>',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [foldDownUpAnimation]
                }] }
    ];
    AccordionContainerComponent.propDecorators = {
        panels: [{ type: ContentChildren, args: [AccordionContentComponent,] }]
    };
    return AccordionContainerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AccordionContainerSharedModule = /** @class */ (function () {
    function AccordionContainerSharedModule() {
    }
    AccordionContainerSharedModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    declarations: [AccordionContainerComponent, AccordionContentComponent],
                    exports: [AccordionContainerComponent, AccordionContentComponent]
                },] }
    ];
    return AccordionContainerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AddToCalendarSharedComponent = /** @class */ (function () {
    function AddToCalendarSharedComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.open = false;
        this.MS_IN_MINUTES = 60 * 1000;
    }
    /**
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.calendars = this.generateCalendars({
            title: (this.event.title || ''),
            start: this.event.start,
            duration: this.event.duration,
            address: (this.event.address || ''),
            description: (this.event.description || '')
        });
    };
    /**
     * @param {?} url
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.sanitize = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.formatTime = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date.toISOString().replace(/-|:|\.\d+/g, '');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.calculateEndTime = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return event.end ? this.formatTime(event.end) :
            this.formatTime(new Date(event.start.getTime() + (event.duration * this.MS_IN_MINUTES)));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.google = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var startTime = this.formatTime(event.start);
        /** @type {?} */
        var endTime = this.calculateEndTime(event);
        /** @type {?} */
        var href = encodeURI([
            'https://www.google.com/calendar/render',
            '?action=TEMPLATE',
            "&text=" + event.title,
            "&dates=" + startTime + "/" + endTime,
            "&details=" + event.description,
            "&location=" + event.address,
            '&sprop=&sprop=name:'
        ].join(''));
        return href;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.yahoo = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var eventDuration = event.end ?
            ((event.end.getTime() - event.start.getTime()) / this.MS_IN_MINUTES) :
            event.duration;
        /** @type {?} */
        var yahooHourDuration = eventDuration < 600 ? "0 " + Math.floor((eventDuration / 60)) :
            "" + Math.floor((eventDuration / 60));
        /** @type {?} */
        var yahooMinuteDuration = eventDuration % 60 < 10 ? "0 " + eventDuration % 60 : "" + eventDuration % 60;
        /** @type {?} */
        var yahooEventDuration = yahooHourDuration + yahooMinuteDuration;
        /** @type {?} */
        var st = this.formatTime(new Date(event.start - (event.start.getTimezoneOffset() *
            this.MS_IN_MINUTES))) || '';
        /** @type {?} */
        var href = encodeURI([
            'http://calendar.yahoo.com/?v=60&view=d&type=20',
            "&title=" + event.title,
            "&st=" + st,
            "&dur=" + yahooEventDuration,
            "&desc=" + event.description,
            "&in_loc=" + event.address
        ].join(''));
        return href;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.ics = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var startTime = this.formatTime(event.start);
        /** @type {?} */
        var endTime = this.calculateEndTime(event);
        /** @type {?} */
        var href = encodeURI('data:text/calendar;charset=utf8,' + [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'BEGIN:VEVENT',
            'URL:' + document.URL,
            'DTSTART:' + startTime,
            'DTEND:' + endTime,
            'SUMMARY:' + event.title,
            'DESCRIPTION:' + event.description,
            'LOCATION:' + event.address,
            'END:VEVENT',
            'END:VCALENDAR'
        ].join('\n'));
        return href;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.ical = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return this.ics(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.outlook = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return this.ics(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddToCalendarSharedComponent.prototype.generateCalendars = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return {
            google: this.google(event),
            yahoo: this.yahoo(event),
            ical: this.ical(event),
            outlook: this.outlook(event)
        };
    };
    AddToCalendarSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-add-to-calendar',
                    template: "<a class=\"sg-add-to-calendar__button\" href=\"\" (click)=\"open = !open; false;\">\n    <mlp-ng-icon name=\"add-circle\"></mlp-ng-icon>\n    Add to my Calendar\n</a>\n\n<div class=\"sg-add-to-calendar__container\" *ngIf=\"open\">\n    <a class=\"sg-add-to-calendar__link\" target=\"_blank\" [href]=\"sanitize(calendars.google)\">\n        <mlp-ng-icon class=\"sg-add-to-calendar__icon\" name=\"custom-google\"></mlp-ng-icon>\n        Google Calendar <small class=\"sg-add-to-calendar__online\">(Online)</small>\n    </a>\n    <a class=\"sg-add-to-calendar__link\" target=\"_blank\" [href]=\"sanitize(calendars.yahoo)\">\n        <mlp-ng-icon class=\"sg-add-to-calendar__icon\" name=\"custom-yahoo\"></mlp-ng-icon>\n        Yahoo! Calendar <small class=\"sg-add-to-calendar__online\">(Online)</small>\n    </a>\n    <a class=\"sg-add-to-calendar__link\" target=\"_blank\" [href]=\"sanitize(calendars.ical)\">\n        <mlp-ng-icon class=\"sg-add-to-calendar__icon\" name=\"custom-apple\"></mlp-ng-icon>\n        Apple Calendar\n    </a>\n    <a class=\"sg-add-to-calendar__link\" target=\"_blank\" [href]=\"sanitize(calendars.ical)\">\n        <mlp-ng-icon class=\"sg-add-to-calendar__icon\" name=\"calendar\"></mlp-ng-icon>\n        Outlook Calendar\n    </a>\n</div>\n",
                    styles: ["@charset \"UTF-8\";:host{position:relative}.sg-add-to-calendar__button{color:#a3bc00;font-size:.875rem}.sg-add-to-calendar__button:hover{color:#778900}.sg-add-to-calendar__container{background-color:#fff;overflow:hidden;position:absolute;top:19px;left:0;width:230px;border:1px solid #dfdfdf;border-radius:.25rem;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);padding:0;z-index:2}.sg-add-to-calendar__link{display:block;color:#464a4c;padding:.25rem 1rem;transition:background-color 250ms ease-in-out}.sg-add-to-calendar__link:hover{background-color:#eceeef}.sg-add-to-calendar__icon{display:inline-block;width:1.25rem;padding-right:.25rem}.sg-add-to-calendar__online{font-weight:100;font-style:italic;color:#636c72}"]
                }] }
    ];
    /** @nocollapse */
    AddToCalendarSharedComponent.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    AddToCalendarSharedComponent.propDecorators = {
        event: [{ type: Input }]
    };
    return AddToCalendarSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AddToCalendarSharedModule = /** @class */ (function () {
    function AddToCalendarSharedModule() {
    }
    AddToCalendarSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AddToCalendarSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        AddToCalendarSharedComponent
                    ]
                },] }
    ];
    return AddToCalendarSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AlertService = /** @class */ (function () {
    function AlertService() {
        this.alerts = new Subject();
        this.alerts$ = this.alerts;
        this.alertData = [];
    }
    /**
     * @param {?} alert
     * @return {?}
     */
    AlertService.prototype.setAlert = /**
     * @param {?} alert
     * @return {?}
     */
    function (alert) {
        this.alertData.push(alert);
        this.alerts.next(this.alertData);
    };
    /**
     * @param {?} alert
     * @return {?}
     */
    AlertService.prototype.removeAlert = /**
     * @param {?} alert
     * @return {?}
     */
    function (alert) {
        var _this = this;
        alert.fadeOut = true;
        setTimeout(function (_) {
            _this.alertData = _this.alertData.filter(function (al) { return al !== alert; });
            _this.alerts.next(_this.alertData);
        }, 250);
    };
    AlertService.decorators = [
        { type: Injectable }
    ];
    return AlertService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AlertsSharedComponent = /** @class */ (function () {
    function AlertsSharedComponent(alertService) {
        this.alertService = alertService;
    }
    /**
     * @param {?} alert
     * @return {?}
     */
    AlertsSharedComponent.prototype.removeAlert = /**
     * @param {?} alert
     * @return {?}
     */
    function (alert) {
        this.alertService.removeAlert(alert);
    };
    AlertsSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-alerts',
                    template: "<div class=\"sg-alerts\">\n    <mlp-ng-alert [alert]=\"alert\" *ngFor=\"let alert of alertService.alertData\" \n        (removeAlert)=\"removeAlert(alert)\" (click)=\"removeAlert(alert)\"></mlp-ng-alert>\n</div>",
                    styles: ["@charset \"UTF-8\";:host{position:fixed;height:auto;max-width:350px;width:100%;bottom:0;right:0;z-index:1051}.sg-alerts{height:auto;padding-right:15px;padding-bottom:15px}"]
                }] }
    ];
    /** @nocollapse */
    AlertsSharedComponent.ctorParameters = function () { return [
        { type: AlertService }
    ]; };
    AlertsSharedComponent.propDecorators = {
        alerts: [{ type: Input }]
    };
    return AlertsSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AlertSharedComponent = /** @class */ (function () {
    function AlertSharedComponent(el) {
        this.el = el;
        this.removeAlert = new EventEmitter();
        this.alertReady = false;
    }
    Object.defineProperty(AlertSharedComponent.prototype, "status", {
        get: /**
         * @return {?}
         */
        function () {
            return (this.alert.status) ? this.alert.status : 'success';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlertSharedComponent.prototype, "timer", {
        get: /**
         * @return {?}
         */
        function () {
            return (this.alert.timeout) ? this.alert.timeout : 5000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AlertSharedComponent.prototype, "autoHide", {
        get: /**
         * @return {?}
         */
        function () {
            return (typeof this.alert.autoHide === 'boolean') ? this.alert.autoHide : (this.alert.status === 'danger') ? false : true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AlertSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.autoHide) {
            setTimeout(function (_) {
                _this.removeAlert.emit(_this.alert);
            }, this.timer);
        }
    };
    AlertSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-alert',
                    template: "<div class=\"sg-alert sg-alert--{{ status }}\" \n    [ngClass]=\"{'sg-alert--slideOut': alert.fadeOut}\"\n    >{{ alert.message }}<span class=\"sg-alert__close -{{ status }}\"><mlp-ng-icon name=\"close\" size=\"small\"></mlp-ng-icon></span></div>",
                    styles: ["@charset \"UTF-8\";.sg-alert{position:relative;padding:1.5rem;font-size:1rem;margin-top:1rem;opacity:1;line-height:1.4;border-radius:.25rem;border:1px solid transparent;cursor:default;-webkit-animation:1.5s linear both animation;animation:1.5s linear both animation}.sg-alert--slideOut{-webkit-animation:250ms linear both slideOutRight;animation:250ms linear both slideOutRight}.sg-alert--success{color:#373737;background-color:#56e07b}.sg-alert--info{color:#fff;background-color:#2f285a}.sg-alert--warning{color:#373737;background-color:#ffa400}.sg-alert--danger{color:#fff;background-color:#c80a0a}.sg-alert__close{position:absolute;float:right;top:10px;right:10px;cursor:pointer;outline:0;transition:opacity 250ms ease-in-out;color:#373737}.sg-alert__close.-danger,.sg-alert__close.-info{color:#fff}.sg-alert__close:hover{opacity:1}@-webkit-keyframes animation{0%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,250,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,250,0,0,1)}3.14%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,160.737,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,160.737,0,0,1)}4.3%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,132.565,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,132.565,0,0,1)}6.27%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,91.357,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,91.357,0,0,1)}8.61%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,51.939,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,51.939,0,0,1)}9.41%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,40.599,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,40.599,0,0,1)}12.48%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,6.498,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,6.498,0,0,1)}12.91%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.807,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.807,0,0,1)}16.22%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-17.027,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-17.027,0,0,1)}17.22%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-20.404,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-20.404,0,0,1)}19.95%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-24.473,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-24.473,0,0,1)}23.69%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-21.178,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-21.178,0,0,1)}27.36%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-13.259,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-13.259,0,0,1)}28.33%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-11.027,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-11.027,0,0,1)}34.77%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.142,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.142,0,0,1)}39.44%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.725,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.725,0,0,1)}42.18%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.675,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.675,0,0,1)}56.99%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.202,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.202,0,0,1)}61.66%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.223,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.223,0,0,1)}66.67%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.104,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.104,0,0,1)}83.98%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.01,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.01,0,0,1)}100%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)}}@keyframes animation{0%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,250,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,250,0,0,1)}3.14%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,160.737,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,160.737,0,0,1)}4.3%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,132.565,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,132.565,0,0,1)}6.27%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,91.357,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,91.357,0,0,1)}8.61%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,51.939,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,51.939,0,0,1)}9.41%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,40.599,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,40.599,0,0,1)}12.48%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,6.498,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,6.498,0,0,1)}12.91%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.807,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.807,0,0,1)}16.22%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-17.027,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-17.027,0,0,1)}17.22%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-20.404,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-20.404,0,0,1)}19.95%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-24.473,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-24.473,0,0,1)}23.69%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-21.178,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-21.178,0,0,1)}27.36%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-13.259,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-13.259,0,0,1)}28.33%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-11.027,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-11.027,0,0,1)}34.77%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.142,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.142,0,0,1)}39.44%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.725,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.725,0,0,1)}42.18%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.675,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,2.675,0,0,1)}56.99%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.202,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.202,0,0,1)}61.66%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.223,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.223,0,0,1)}66.67%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.104,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,-.104,0,0,1)}83.98%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.01,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,.01,0,0,1)}100%{-webkit-transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)}}@-webkit-keyframes slideOutRight{0%{-webkit-transform:translateX(0);transform:translateX(0)}25%{-webkit-transform:translateX(-10%);transform:translateX(-10%)}100%{-webkit-transform:translateX(110%);transform:translateX(110%)}}@keyframes slideOutRight{0%{-webkit-transform:translateX(0);transform:translateX(0)}25%{-webkit-transform:translateX(-10%);transform:translateX(-10%)}100%{-webkit-transform:translateX(110%);transform:translateX(110%)}}"]
                }] }
    ];
    /** @nocollapse */
    AlertSharedComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    AlertSharedComponent.propDecorators = {
        alert: [{ type: Input }],
        removeAlert: [{ type: Output }]
    };
    return AlertSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AlertSharedModule = /** @class */ (function () {
    function AlertSharedModule() {
    }
    AlertSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AlertSharedComponent,
                        AlertsSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        AlertsSharedComponent
                    ],
                    providers: [
                        AlertService
                    ]
                },] }
    ];
    return AlertSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonNavSharedComponent = /** @class */ (function () {
    function ButtonNavSharedComponent() {
    }
    /**
     * @return {?}
     */
    ButtonNavSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.side) {
            throw new Error('Attribute side is required');
        }
    };
    ButtonNavSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-button-nav',
                    template: "<button class=\"sg-button-nav sg-rounded d-inline-flex justify-content-center\">\n    <mlp-ng-icon name=\"arrow-{{side}}-1\"></mlp-ng-icon>\n</button>\n\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-button-nav{width:2.75rem;height:3.75rem;background-color:#373737;border-color:#373737;outline:0}.sg-button-nav ::ng-deep i{color:#fff}.sg-button-nav:focus,.sg-button-nav:hover{cursor:pointer;background-color:#737373}.sg-button-nav:not(:disabled):focus{box-shadow:none}.sg-button-nav:not(:disabled):active{-webkit-transform:scale(.98);transform:scale(.98)}"]
                }] }
    ];
    ButtonNavSharedComponent.propDecorators = {
        side: [{ type: Input }]
    };
    return ButtonNavSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ButtonNavSharedModule = /** @class */ (function () {
    function ButtonNavSharedModule() {
    }
    ButtonNavSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ButtonNavSharedComponent,
                    ],
                    imports: [
                        IconSharedModule
                    ],
                    exports: [
                        ButtonNavSharedComponent
                    ]
                },] }
    ];
    return ButtonNavSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ChipSharedComponent = /** @class */ (function () {
    function ChipSharedComponent() {
        this.remove = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ChipSharedComponent.prototype.removeChip = /**
     * @return {?}
     */
    function () {
        this.remove.emit(true);
    };
    ChipSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-chip',
                    template: "<div class=\"chip d-flex justify-content-between\" [ngClass]=\"{ '-list': data.style === 'list', '-secondary': data.state === 'secondary', '-tertiary': data.state === 'tertiary' }\">\n    <mlp-ng-icon *ngIf=\"data.icon\" [name]=\"data.icon\" class=\"chip__icon text-left\"></mlp-ng-icon>\n    <span class=\"chip__label\" [ngClass]=\"{'-sm': data.size === 'small', '-list': data.style === 'list'}\">{{ data.name }}</span>\n    <div class=\"chip__closebtn-wrapper ml-auto\">\n        <div class=\"chip__closebtn\" *ngIf=\"data.removeButton !== false\" [ngClass]=\"{'-list': data.style === 'list', 'pl-2': data.style !== 'list'}\"\n        (click)=\"removeChip()\"><b>&times;</b></div>\n    </div>\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.chip{position:relative;display:inline-block;padding:0 .75rem;height:1.875rem;font-size:1rem;line-height:1.875rem;border-radius:25px;background-color:#eceeef;color:#464a4c;border:1px solid #464a4c;width:100%}.chip.-secondary{background-color:#fff}.chip.-tertiary{background-color:#56e07b}.chip.-list{background-color:#fff;border-radius:5px;border:1px solid #dfdfdf;padding:.75rem 1rem .5rem;height:auto;line-height:1.2;margin-bottom:10px}.chip.-list.-secondary{background-color:#eceeef;border-radius:.25rem}.chip.-list.-tertiary{color:#fff;background-color:#2f285a;border-radius:.25rem}.chip__icon{width:10%;display:block;overflow:hidden;position:relative}.chip__label{width:75%;height:1.75rem;line-height:1.75rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;text-align:center}.chip__label.-sm{width:85%;font-size:.875rem}.chip__label.-list{text-align:left}.chip__closebtn-wrapper{position:relative;display:block;height:1.75rem;line-height:.8}.chip _:-ms-lang(x),.chip__closebtn-wrapper{line-height:1}.chip__closebtn{position:relative;display:block;clear:both;width:20px;height:20px;text-align:center;color:#2f285a;font-size:1.25rem;padding:0!important;cursor:pointer;transition:color 250ms ease-in-out;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.chip__closebtn:hover{color:#6d688b}.chip__closebtn.-list{width:22px;height:22px;background-color:#56e07b;color:#464a4c;text-align:center;border-radius:50%;border:1px solid #aeadad;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.chip__closebtn.-list:hover{background-color:#464a4c;color:#f3f9d2}"]
                }] }
    ];
    ChipSharedComponent.propDecorators = {
        data: [{ type: Input }],
        remove: [{ type: Output }]
    };
    return ChipSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ChipSharedModule = /** @class */ (function () {
    function ChipSharedModule() {
    }
    ChipSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ChipSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        ChipSharedComponent
                    ]
                },] }
    ];
    return ChipSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FooterNavSharedComponent = /** @class */ (function () {
    function FooterNavSharedComponent(cookieService) {
        this.cookieService = cookieService;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    FooterNavSharedComponent.prototype.clearCityCookie = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (url === '/') {
            this.cookieService.remove('city');
            window.location.href = '/';
        }
    };
    FooterNavSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-footer-nav',
                    template: "<section class=\"footer-nav\">\n    <h1 class=\"h5 mb-2\" [ngClass]=\"{'footer-nav__notitle': !title}\">{{ title }}</h1>\n    <nav>\n        <a [href]=\"link.url\" class=\"footer-nav__link\" *ngFor=\"let link of data?.links\" (click)=\"clearCityCookie(link.url)\">{{ link.name }}</a>\n        <a [href]=\"link.attributes.slug\" class=\"footer-nav__link\" *ngFor=\"let link of data?.data\">{{ link.attributes.name }}</a>\n    </nav>\n</section>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.footer-nav{color:#fff}.footer-nav__link{color:#188155;text-decoration:none;display:block;font-size:.75rem}.footer-nav__link:hover{color:#5da788}.footer-nav__notitle{margin-top:1.88rem}"]
                }] }
    ];
    /** @nocollapse */
    FooterNavSharedComponent.ctorParameters = function () { return [
        { type: CookieService }
    ]; };
    FooterNavSharedComponent.propDecorators = {
        title: [{ type: Input }],
        data: [{ type: Input }]
    };
    return FooterNavSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FooterNavSharedModule = /** @class */ (function () {
    function FooterNavSharedModule() {
    }
    FooterNavSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        FooterNavSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        CookieModule.forRoot()
                    ],
                    exports: [
                        FooterNavSharedComponent
                    ]
                },] }
    ];
    return FooterNavSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * This service is a browser service
 *
 * \@example
 * BrowserService.isBrowser;
 *
 */
var BrowserService = /** @class */ (function () {
    function BrowserService(platformId) {
        this.platformId = platformId;
        /**
         * Get the isBrowser value.
         */
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    BrowserService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BrowserService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
    ]; };
    return BrowserService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GridNavService = /** @class */ (function () {
    function GridNavService(browserService) {
        var _this = this;
        this.browserService = browserService;
        this.layout = new Subject();
        this.layout$ = this.layout;
        this.layout$.subscribe(function (layout) { return _this.formation = layout; });
    }
    Object.defineProperty(GridNavService.prototype, "formation", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.hasLocalStorage && this.browserService.isBrowser) {
                return localStorage.getItem('sg-layout');
            }
            return this._formation;
        },
        set: /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (this.hasLocalStorage && this.browserService.isBrowser) {
                localStorage.setItem('sg-layout', data);
            }
            this._formation = data;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    GridNavService.prototype.hasLocalStorage = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var hasLocalStorage = 'localStorage' in window && window['localStorage'] !== null;
        return !!hasLocalStorage;
    };
    GridNavService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    GridNavService.ctorParameters = function () { return [
        { type: BrowserService }
    ]; };
    return GridNavService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GridNavSharedComponent = /** @class */ (function () {
    function GridNavSharedComponent(gridNavService) {
        this.gridNavService = gridNavService;
    }
    /**
     * @return {?}
     */
    GridNavSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // tslint:disable-next-line:max-line-length
        this.gridNavService.formation = (this.gridNavService.formation) ? this.gridNavService.formation : (this.layout) ? this.layout : 'grid';
    };
    GridNavSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-grid-nav',
                    template: "<nav class=\"grid-nav\">\n    <a href=\"\" class=\"grid-nav__link pr-1\" (click)=\"gridNavService.layout.next('grid');false;\" [ngClass]=\"{ 'grid-nav__link--active': gridNavService.formation === 'grid' }\">\n        <mlp-ng-icon name=\"layout-module-1\"></mlp-ng-icon>\n    </a>\n    <a href=\"\" class=\"grid-nav__link ml-2\" (click)=\"gridNavService.layout.next('list');false;\" [ngClass]=\"{ 'grid-nav__link--active': gridNavService.formation === 'list' }\">\n        <mlp-ng-icon name=\"list-bullets-1\"></mlp-ng-icon>\n    </a>\n</nav>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.grid-nav{display:inline-block}.grid-nav__link{color:#aeadad}.grid-nav__link:first-of-type{border-right:1px solid #aeadad}.grid-nav__link--active,.grid-nav__link:hover{color:#464a4c}"]
                }] }
    ];
    /** @nocollapse */
    GridNavSharedComponent.ctorParameters = function () { return [
        { type: GridNavService }
    ]; };
    GridNavSharedComponent.propDecorators = {
        layout: [{ type: Input }]
    };
    return GridNavSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GridNavSharedModule = /** @class */ (function () {
    function GridNavSharedModule() {
    }
    GridNavSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        GridNavSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        GridNavSharedComponent
                    ],
                    providers: [
                        BrowserService,
                        GridNavService
                    ]
                },] }
    ];
    return GridNavSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Animates show/hide elements
 *
 * \@example
 * [\@fadeAnimation]="true"
 *
  @type {?} */
var fadeAnimation = trigger('fadeAnimation', [
    state('true', style({
        opacity: 0,
        display: 'none'
    })),
    state('false', style({
        opacity: 1,
        display: 'block'
    })),
    transition('* => *', animate(ANIMATIONS.speed.default + " " + ANIMATIONS.bezierCurve.default))
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IconNavSharedComponent = /** @class */ (function () {
    function IconNavSharedComponent() {
        this.hidden = true;
        this.openIcon = { name: 'navigation-menu-horizontal' };
        this.closeIcon = { name: 'close' };
        this.visibility = new EventEmitter();
    }
    /**
     * @param {?=} status
     * @return {?}
     */
    IconNavSharedComponent.prototype.toggleNav = /**
     * @param {?=} status
     * @return {?}
     */
    function (status) {
        this.hidden = (status) ? status : !this.hidden;
        this.visibility.emit(this.hidden);
    };
    IconNavSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-icon-nav',
                    template: "<a href=\"\" (click)=\"false;\" class=\"sg-icon-nav__toggle\" [ngClass]=\"{'sg-icon-nav__toggle--hidden': !hidden}\" (click)=\"toggleNav()\">\n    <mlp-ng-icon name=\"{{ openIcon.name }}\"></mlp-ng-icon>\n</a>\n\n<nav class=\"sg-icon-nav__menu\" [@fadeAnimation]=\"hidden\">\n    <a href=\"\" (click)=\"false;\" *ngIf=\"!hidden\" class=\"sg-icon-nav__toggle sg-icon-nav__toggle--open\" (click)=\"toggleNav()\">\n        <mlp-ng-icon size=\"small\" name=\"{{ closeIcon.name }}\"></mlp-ng-icon>\n    </a>\n\n    <ng-content></ng-content>\n\n    <ng-container *ngFor=\"let link of links\">\n        <a *ngIf=\"link.routerLink\" [routerLink]=\"link.routerLink\" class=\"sg-icon-nav__link\" >{{ link.name }}</a>\n        <a *ngIf=\"link.href\" [href]=\"link.href\" class=\"sg-icon-nav__link\" >{{ link.name }}</a>\n    </ng-container>\n</nav>\n\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [fadeAnimation],
                    styles: ["@charset \"UTF-8\";.sg-icon-nav__toggle{color:#2f285a!important;width:25px;height:25px;display:inline-block!important;z-index:2;position:relative}.sg-icon-nav__toggle--open{top:8px;right:0;position:absolute}.sg-icon-nav__toggle--hidden{visibility:hidden}.sg-icon-nav__toggle:hover{color:#6d688b!important}.sg-icon-nav__menu{background-color:#eceeef;position:absolute;bottom:0;left:0;width:100%;padding:.75rem;text-align:left;opacity:0}.sg-icon-nav__menu ::ng-deep a,.sg-icon-nav__menu ::ng-deep a:visited{display:block;color:#188155;font-size:.875rem}.sg-icon-nav__menu ::ng-deep a:hover,.sg-icon-nav__menu ::ng-deep a:visited:hover{color:#5da788}.sg-icon-nav__link{display:block;color:#188155;font-size:.875rem}.sg-icon-nav__link:hover{color:#5da788}"]
                }] }
    ];
    IconNavSharedComponent.propDecorators = {
        visibility: [{ type: Output }],
        links: [{ type: Input }]
    };
    return IconNavSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IconNavSharedModule = /** @class */ (function () {
    function IconNavSharedModule() {
    }
    IconNavSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        IconNavSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        RouterModule.forChild([])
                    ],
                    exports: [
                        IconNavSharedComponent
                    ]
                },] }
    ];
    return IconNavSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$1 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return InputSharedComponent; }),
    multi: true
};
var InputSharedComponent = /** @class */ (function () {
    function InputSharedComponent() {
        this.inputType = 'text';
        this.inputId = '';
        this.inputName = '';
        this.inputStyle = 'primary';
        this.inputDisabled = false;
        this.placeholder = '';
        this.loading = false;
        this.errors = [];
        // tslint:disable-next-line:no-input-rename
        this._value = '';
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.secondaryButtonClick = new EventEmitter();
        this.focused = false;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(InputSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    InputSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputSharedComponent.prototype.updateValue = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.value = (/** @type {?} */ (event.target)).value;
    };
    InputSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input',
                    template: "<div class=\"input-group sg-input-group\"\n     [class.sg-input-group__secondary]=\"inputStyle == 'secondary'\"\n     [class.sg-input-group__icon]=\"icon\"\n     [class.sg-input-group__error]=\"errors.length > 0\"\n     [class.sg-input-group__focus]=\"focused\">\n    <div class=\"input-group-prepend sg-input-group__prepend sg-rounded-left\" *ngIf=\"icon\">\n        <div class=\"sg-input-group__prepend__icon h-100 sg-rounded-left d-flex align-items-center justify-content-center\">\n            <mlp-ng-icon class=\"mw-100\" name=\"{{icon}}\"></mlp-ng-icon>\n        </div>\n        <div class=\"sg-input-group__prepend__divider d-flex align-items-center\">\n            <div class=\"sg-input-group__prepend__divider__line\"></div>\n        </div>\n    </div>\n    <input [type]=\"inputType\" [id]=\"inputId\" class=\"form-control sg-input-group__input-molecule\"\n        [placeholder]=\"placeholder\" (input)=\"updateValue($event)\" [value]=\"value\" [name]=\"inputName\"\n        [disabled]=\"inputDisabled\" (focus)=\"focused = true; focus.emit($event)\" (blur)=\"focused = false; blur.emit($event)\">\n    <div class=\"input-group-append sg-input-group-append sg-rounded-right\" *ngIf=\"iconSecondary\">\n        <div class=\"sg-rounded-right\">\n            <button *ngIf=\"loading\" type=\"button\" class=\"btn sg-btn h-100 sg-input-group-append-button-icon sg-input-group-append-button-icon__loading\">\n                <mlp-ng-spinner class=\"mr-2\"></mlp-ng-spinner>\n            </button>\n            <button *ngIf=\"!loading\" type=\"button\" class=\"btn sg-btn h-100 sg-input-group-append-button-icon\" (click)=\"secondaryButtonClick.emit()\">\n                <mlp-ng-icon class=\"mw-100\" name=\"{{iconSecondary}}\"></mlp-ng-icon>\n            </button>\n        </div>\n    </div>\n</div>\n<small class=\"form-text sg-color__danger\" *ngFor=\"let error of errors\">{{ error.title }}</small>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$1
                    ],
                    styles: ["@charset \"UTF-8\";.sg-input-group{border:1px solid #d6d5d5;border-radius:.25rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-input-group__input-molecule{color:#373737;height:calc(1.5em + .75rem + 2px + 8px);box-shadow:none;border:none;padding:.275rem .75rem}.sg-input-group__input-molecule:focus{background-color:#f4f4f7}.sg-input-group__prepend__icon{background-color:#fff;color:#6c757d;width:44px}.sg-input-group__prepend__divider{background-color:#fff}.sg-input-group__prepend__divider__line{height:24px;width:2px;background-color:#d6d5d5}.sg-input-group__focus{border-color:#2f285a}.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group__prepend__divider__line{background-color:#2f285a}.sg-input-group__focus .sg-input-group-append-button-icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group-append-button-icon:hover{background-color:#f4f4f7!important}.sg-input-group__icon .sg-input-group__input-molecule{border-left:0}.sg-input-group__error{border-color:#c80a0a}.sg-input-group__secondary{box-shadow:0 2px 6px 0 rgba(0,0,0,.25)}.sg-input-group__secondary .sg-input-group__input-molecule{background-clip:unset;-webkit-appearance:none}.sg-input-group__secondary .sg-input-group__input-molecule:focus,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#fff}.sg-input-group-append-button-icon{transition:none;border-top-left-radius:0;border-bottom-left-radius:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff;color:#6c757d!important}.sg-input-group-append-button-icon:hover{color:#373737!important;background-color:#fff!important}.sg-input-group-append-button-icon__loading{padding-left:.1875rem;padding-right:.1875rem}"]
                }] }
    ];
    InputSharedComponent.propDecorators = {
        icon: [{ type: Input }],
        iconSecondary: [{ type: Input }],
        inputType: [{ type: Input }],
        inputId: [{ type: Input }],
        inputName: [{ type: Input }],
        inputStyle: [{ type: Input }],
        inputDisabled: [{ type: Input }],
        placeholder: [{ type: Input }],
        loading: [{ type: Input }],
        input: [{ type: Input }],
        errors: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }],
        blur: [{ type: Output }],
        focus: [{ type: Output }],
        secondaryButtonClick: [{ type: Output }]
    };
    return InputSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputSharedModule = /** @class */ (function () {
    function InputSharedModule() {
    }
    InputSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        SpinnerSharedModule
                    ],
                    exports: [
                        InputSharedComponent
                    ]
                },] }
    ];
    return InputSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var EXPIRY_CUSTOM_INPUT_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(function () { return InputTooltipSharedComponent; }),
    multi: true
};
var InputTooltipSharedComponent = /** @class */ (function (_super) {
    __extends(InputTooltipSharedComponent, _super);
    function InputTooltipSharedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: no-input-rename
        _this._value = '';
        _this.inputStyle = 'primary';
        _this.inputType = 'text';
        _this.tooltip = '';
        _this.icon = '';
        _this.iconTooltip = 'custom-question-circle';
        _this.placement = 'top';
        _this.tooltipClass = 'sg-tooltip--primary';
        _this.focused = false;
        return _this;
    }
    InputTooltipSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input-tooltip',
                    template: "<div class=\"input-group sg-input-group d-flex flex-nowrap\"\n    [class.sg-input-group__secondary]=\"inputStyle == 'secondary'\"\n    [class.sg-input-group__error]=\"errors.length > 0\"\n    [class.sg-input-group__focus]=\"focused\">\n    <div class=\"input-group-prepend sg-input-group__prepend sg-rounded-left\" *ngIf=\"icon\">\n        <div class=\"sg-input-group__prepend__icon h-100 sg-rounded-left d-flex align-items-center justify-content-center\">\n            <mlp-ng-icon class=\"mw-100\" name=\"{{icon}}\"></mlp-ng-icon>\n        </div>\n        <div class=\"sg-input-group__prepend__divider d-flex align-items-center\">\n            <div class=\"sg-input-group__prepend__divider__line\"></div>\n        </div>\n    </div>\n\n    <mlp-ng-input-atom\n        class=\"flex-fill\"\n        [inputType]=\"inputType\"\n        [noBorder]=\"true\"\n        [placeholder]=\"placeholder\"\n        [inputId]=\"inputId\"\n        [inputName]=\"inputName\"\n        [inputDisabled]=\"inputDisabled\"\n        [(ngModel)]=\"value\"\n        (focus)=\"focused = true; focus.emit($event)\"\n        (blur)=\"focused = false; blur.emit($event)\"\n    ></mlp-ng-input-atom>\n\n    <div class=\"input-group-append sg-input-group-append sg-rounded-right\">\n        <div class=\"sg-rounded-right\">\n            <button\n                type=\"button\"\n                class=\"btn sg-btn h-100 sg-input-group-append-button-icon\"\n                [ngbTooltip]=\"tooltipTemplate || tooltip\"\n                [placement]=\"placement\"\n                [tooltipClass]=\"tooltipClass\"\n            >\n                <mlp-ng-icon class=\"mw-100\" name=\"{{iconTooltip}}\"></mlp-ng-icon>\n            </button>\n        </div>\n    </div>\n</div>\n\n<small class=\"form-text sg-color__danger\" *ngFor=\"let error of errors\">{{ error.title }}</small>",
                    providers: [
                        EXPIRY_CUSTOM_INPUT_ACCESSOR
                    ],
                    styles: ["@charset \"UTF-8\";.sg-input-group{border:1px solid #d6d5d5;border-radius:.25rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-input-group__input-molecule{color:#373737;height:calc(1.5em + .75rem + 2px + 8px);box-shadow:none;border:none;padding:.275rem .75rem}.sg-input-group__input-molecule:focus{background-color:#f4f4f7}.sg-input-group__prepend__icon{background-color:#fff;color:#6c757d;width:44px}.sg-input-group__prepend__divider{background-color:#fff}.sg-input-group__prepend__divider__line{height:24px;width:2px;background-color:#d6d5d5}.sg-input-group__focus{border-color:#2f285a}.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group__prepend__divider__line{background-color:#2f285a}.sg-input-group__focus .sg-input-group-append-button-icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group-append-button-icon:hover{background-color:#f4f4f7!important}.sg-input-group__icon .sg-input-group__input-molecule{border-left:0}.sg-input-group__error{border-color:#c80a0a}.sg-input-group__secondary{box-shadow:0 2px 6px 0 rgba(0,0,0,.25)}.sg-input-group__secondary .sg-input-group__input-molecule{background-clip:unset;-webkit-appearance:none}.sg-input-group__secondary .sg-input-group__input-molecule:focus,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#fff}.sg-input-group-append-button-icon{transition:none;border-top-left-radius:0;border-bottom-left-radius:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff;color:#6c757d!important}.sg-input-group-append-button-icon:hover{color:#373737!important;background-color:#fff!important}.sg-input-group-append-button-icon__loading{padding-left:.1875rem;padding-right:.1875rem}.sg-tooltip .tooltip .tooltip-inner{background-color:#56e07b}.sg-tooltip .tooltip.bs-tooltip-top .arrow:before{border-top-color:#56e07b}.sg-tooltip .tooltip.bs-tooltip-left .arrow:before{border-left-color:#56e07b}.sg-tooltip .tooltip.bs-tooltip-right .arrow:before{border-right-color:#56e07b}.sg-tooltip .tooltip.bs-tooltip-bottom .arrow:before{border-bottom-color:#56e07b}.sg-tooltip--primary .tooltip-inner{background-color:#2f285a;color:#fff;width:240px;margin-left:-160px}.sg-tooltip--primary .arrow::before{border-top-color:#2f285a}.sg-tooltip--warn .tooltip-inner{background-color:orange!important;color:#1a1a1a;width:240px;margin-left:-160px}.sg-tooltip--warn .arrow::before{border-top-color:orange!important}"]
                }] }
    ];
    InputTooltipSharedComponent.propDecorators = {
        _value: [{ type: Input, args: ['value',] }],
        inputStyle: [{ type: Input }],
        inputType: [{ type: Input }],
        tooltip: [{ type: Input }],
        tooltipTemplate: [{ type: Input }],
        icon: [{ type: Input }],
        iconTooltip: [{ type: Input }],
        placement: [{ type: Input }],
        tooltipClass: [{ type: Input }]
    };
    return InputTooltipSharedComponent;
}(InputAtomSharedComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputTooltipSharedModule = /** @class */ (function () {
    function InputTooltipSharedModule() {
    }
    InputTooltipSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputTooltipSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgbModule,
                        InputAtomSharedModule,
                        IconSharedModule
                    ],
                    exports: [
                        InputTooltipSharedComponent
                    ]
                },] }
    ];
    return InputTooltipSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var JumbotronSharedComponent = /** @class */ (function () {
    function JumbotronSharedComponent() {
    }
    JumbotronSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-jumbotron',
                    template: "<div class=\"sg-jumbotron d-flex flex-row\">\n    <div class=\"d-flex flex-column\">\n        <div class=\"sg-jumbotron__triangle_top_left\"></div>\n        <div class=\"sg-jumbotron__background h-100 sg-rounded-bottom-left\"></div>\n    </div>\n    <div class=\"sg-jumbotron__content py-4 sg-py-sm-1\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"d-flex flex-column\">\n        <div class=\"sg-jumbotron__background h-100 sg-rounded-top-right\"></div>\n        <div class=\"sg-jumbotron__triangle_bottom_right\"></div>\n    </div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-jumbotron{color:#fff;max-width:500px}.sg-jumbotron__background,.sg-jumbotron__content{background-color:rgba(86,224,123,.7)}.sg-jumbotron__triangle_bottom_right{width:100%;height:0;border-top:38px solid rgba(86,224,123,.7);border-right:24px solid transparent}.sg-jumbotron__triangle_top_left{width:100%;height:0;border-bottom:38px solid rgba(86,224,123,.7);border-left:24px solid transparent}@media (min-width:576px){.sg-jumbotron__triangle_bottom_right{width:100%;height:0;border-top:76px solid rgba(86,224,123,.7);border-right:48px solid transparent}.sg-jumbotron__triangle_top_left{width:100%;height:0;border-bottom:76px solid rgba(86,224,123,.7);border-left:48px solid transparent}}.sg-jumbotron__rounded_bottom_left{border-bottom-left-radius:.1875rem}.sg-jumbotron__rounded_top_right{border-top-right-radius:.1875rem}"]
                }] }
    ];
    return JumbotronSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var JumbotronSharedModule = /** @class */ (function () {
    function JumbotronSharedModule() {
    }
    JumbotronSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        JumbotronSharedComponent,
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        JumbotronSharedComponent
                    ]
                },] }
    ];
    return JumbotronSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LoadingSharedComponent = /** @class */ (function () {
    function LoadingSharedComponent() {
    }
    LoadingSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-loading',
                    template: "<div class=\"container-loading\">\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host .container-loading{margin:auto;height:150px;width:250px;-webkit-transform:scale(.5,.5);transform:scale(.5,.5)}:host .bar{float:left;width:35px;height:150px;background-color:#2f285a;margin-right:15px;border-radius:18px}:host .bar:nth-child(1){-webkit-animation:2s .16667s infinite shrink;animation:2s .16667s infinite shrink}:host .bar:nth-child(2){-webkit-animation:2s .33333s infinite shrink;animation:2s .33333s infinite shrink}:host .bar:nth-child(3){-webkit-animation:2s .5s infinite shrink;animation:2s .5s infinite shrink}:host .bar:nth-child(4){-webkit-animation:2s .66667s infinite shrink;animation:2s .66667s infinite shrink}:host .bar:nth-child(5){-webkit-animation:2s .83333s infinite shrink;animation:2s .83333s infinite shrink}:host .message{margin-top:50px;text-align:center;font-size:32px;color:#708090;-webkit-animation:6s 4s infinite fade;animation:6s 4s infinite fade}@-webkit-keyframes shrink{0%,100%{height:150px;margin-top:0;margin-bottom:0}50%{height:30px;margin-top:60px;margin-bottom:60px}}@keyframes shrink{0%,100%{height:150px;margin-top:0;margin-bottom:0}50%{height:30px;margin-top:60px;margin-bottom:60px}}@-webkit-keyframes fade{0%,100%{opacity:1}50%{opacity:.3}}@keyframes fade{0%,100%{opacity:1}50%{opacity:.3}}"]
                }] }
    ];
    return LoadingSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LoadingSharedModule = /** @class */ (function () {
    function LoadingSharedModule() {
    }
    LoadingSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LoadingSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        LoadingSharedComponent
                    ]
                },] }
    ];
    return LoadingSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ModalService = /** @class */ (function () {
    function ModalService(modalService) {
        this.modalService = modalService;
        this.configStore = {};
    }
    /**
     * @param {?} content
     * @param {?=} config
     * @return {?}
     */
    ModalService.prototype.open = /**
     * @param {?} content
     * @param {?=} config
     * @return {?}
     */
    function (content, config) {
        if (config === void 0) { config = {}; }
        if (config && !config['windowClass']) {
            config['windowClass'] = 'sg-modal-default';
        }
        this.configStore = config;
        this.modalRef = this.modalService.open(content, config);
        return this.modalRef;
    };
    /**
     * @return {?}
     */
    ModalService.prototype.close = /**
     * @return {?}
     */
    function () {
        if (this.modalRef) {
            this.modalRef.close();
        }
    };
    /**
     * @return {?}
     */
    ModalService.prototype.dismiss = /**
     * @return {?}
     */
    function () {
        if (this.modalRef) {
            this.modalRef.dismiss();
        }
    };
    ModalService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ModalService.ctorParameters = function () { return [
        { type: NgbModal }
    ]; };
    return ModalService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ModalSharedComponent = /** @class */ (function () {
    function ModalSharedComponent(modService) {
        this.modService = modService;
    }
    ModalSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-modal',
                    template: "<div class=\"modal-header sg-background__secondary sg-rounded-top border-bottom-0 d-flex p-0\">\n    <div class=\"w-100 sg-color__primary d-flex -content-align h-100\">\n        <div class=\"d-flex align-self-center\">\n            <ng-content select=\"[header]\"></ng-content>\n        </div>\n    </div>\n    <div class=\"triangle unset-width\"></div>\n    <div class=\"modal-close sg-color__white sg-background__primary d-flex justify-content-center h-100 sg-rounded-top-right\" (click)=\"modService.dismiss()\">\n        <div class=\"d-flex align-self-center\">\n            <mlp-ng-icon name=\"close\" size=\"small\"></mlp-ng-icon>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal-body sg-rounded-bottom\" ngbAutofocus>\n    <ng-content select=\"[body]\"></ng-content>\n</div>\n\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";::ng-deep .sg-modal-default .modal-content,::ng-deep .sg-modal-secondary .modal-content{border:0;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}::ng-deep .sg-modal-default .modal-content .modal-header,::ng-deep .sg-modal-secondary .modal-content .modal-header{height:50px}::ng-deep .sg-modal-default .modal-content .modal-header .triangle,::ng-deep .sg-modal-secondary .modal-content .modal-header .triangle{background-color:#2f285a;width:100%;height:0;border-top:50px solid #56e07b;border-right:29px solid transparent}::ng-deep .sg-modal-default .modal-content .modal-header .triangle.unset-width,::ng-deep .sg-modal-secondary .modal-content .modal-header .triangle.unset-width{width:unset}::ng-deep .sg-modal-default .modal-content .modal-header .-content-align,::ng-deep .sg-modal-secondary .modal-content .modal-header .-content-align{justify-content:center;padding-left:3rem}::ng-deep .sg-modal-default .modal-content .modal-header .modal-close,::ng-deep .sg-modal-secondary .modal-content .modal-header .modal-close{min-width:46px;cursor:pointer}::ng-deep .sg-modal-default .modal-content .modal-body,::ng-deep .sg-modal-secondary .modal-content .modal-body{background-color:#ececec}::ng-deep .-title-left.sg-modal-secondary .modal-lg .modal-content .modal-header .-content-align,::ng-deep .sg-modal-default.-title-left .modal-lg .modal-content .modal-header .-content-align{padding-left:2.25rem}::ng-deep .-title-left.sg-modal-secondary .modal-content .modal-header .-content-align,::ng-deep .sg-modal-default.-title-left .modal-content .modal-header .-content-align{justify-content:left;padding-left:1.5rem}::ng-deep .sg-modal-secondary .modal-body{background-color:#fff!important;padding:2rem 1.5rem}"]
                }] }
    ];
    /** @nocollapse */
    ModalSharedComponent.ctorParameters = function () { return [
        { type: ModalService }
    ]; };
    return ModalSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ModalSecondarySharedComponent = /** @class */ (function () {
    function ModalSecondarySharedComponent(modService) {
        this.modService = modService;
    }
    ModalSecondarySharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-modal-secondary',
                    template: "<div class=\"modal-header sg-modal__header pb-0\" [ngClass]=\"{'-secondary rounded-top': modService.configStore.headerStyle === 'secondary'}\">\n\n    <ng-content select=\"[header]\"></ng-content>\n\n    <button type=\"button\" class=\"sg-modal__close\" aria-label=\"Close\" *ngIf=\"!modService.configStore.closeBtnRemove\" (click)=\"modService.dismiss()\">\n        <mlp-ng-icon name=\"close\"></mlp-ng-icon>\n    </button>\n\n</div>\n\n<div class=\"modal-body\">\n\n    <ng-content select=\"[body]\"></ng-content>\n\n</div>\n\n<div class=\"sg-modal__footer pt-0\">\n\n    <ng-content select=\"[footer]\"></ng-content>\n\n</div>\n\n<div class=\"sg-modal__shard pt-0\">\n\n    <div class=\"-container\">\n\n        <ng-content select=\"[shard]\"></ng-content>\n\n    </div>\n\n</div>\n\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";::ng-deep .sg-modal-banner .modal-content{background-color:#2f285a;padding:1rem 1rem 3rem;font-family:\"Frank New\",sans-serif;font-weight:400;font-size:1rem;color:#fff;position:relative}::ng-deep .sg-modal-banner .modal-header{border-bottom:none}::ng-deep .sg-modal-banner .modal-body,::ng-deep .sg-modal-banner .modal-footer,::ng-deep .sg-modal-banner .modal-header{margin-bottom:1rem}::ng-deep .sg-modal-banner .modal-body .-highlight{color:#56e07b}::ng-deep .sg-modal-banner .sg-modal__close{background-color:transparent;border:none;color:#56e07b;margin-right:-16px}::ng-deep .sg-modal-banner .sg-modal__footer a{color:#56e07b;text-decoration:underline;transition:color 250ms ease-in-out}::ng-deep .sg-modal-banner .sg-modal__footer a:hover{color:#ccf5d7}::ng-deep .sg-modal-banner .sg-modal__shard{position:absolute;right:0;bottom:0;overflow:hidden;padding:6px;text-align:right}::ng-deep .sg-modal-banner .sg-modal__shard .-container{position:relative;width:100%;min-width:100px;height:auto;display:block;padding-top:130px}::ng-deep .sg-modal-banner .sg-modal__shard .-container img{position:relative;z-index:1;max-width:60px;height:auto}@media (min-width:768px){::ng-deep .sg-modal-banner .sg-modal__shard .-container{min-width:150px;padding-top:200px}::ng-deep .sg-modal-banner .sg-modal__shard .-container img{max-width:100px}}::ng-deep .sg-modal-banner .sg-modal__shard:after{content:'';position:absolute;display:block;width:100%;height:100%;top:0;left:0;z-index:0;background:#56e07b;-webkit-transform-origin:bottom left;transform-origin:bottom left;-webkit-transform:skew(-29.8deg,0deg);transform:skew(-29.8deg,0deg)}::ng-deep .sg-modal-banner-plain .modal-content{background-color:#2f285a;padding:1rem 1rem 0;font-family:\"Frank New\",sans-serif;font-weight:400;font-size:1rem;color:#fff;position:relative}::ng-deep .sg-modal-banner-plain .modal-header{border:none;padding:0}::ng-deep .sg-modal-banner-plain .modal-header .sg-modal__close{position:absolute;top:.5rem;right:1.2rem;font-size:.75rem;color:#fff}::ng-deep .sg-modal-banner-plain .modal-body{margin-bottom:1rem}::ng-deep .sg-modal-banner-plain .modal-body .-highlight{color:#56e07b}::ng-deep .sg-modal-banner-plain .sg-modal__close{background-color:transparent;border:none;color:#56e07b;margin-right:-16px}::ng-deep .sg-modal-banner-plain .sg-modal__shard{display:none}::ng-deep .sg-modal-banner-plain .sg-modal__footer{display:none}"]
                }] }
    ];
    /** @nocollapse */
    ModalSecondarySharedComponent.ctorParameters = function () { return [
        { type: ModalService }
    ]; };
    return ModalSecondarySharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ModalSharedModule = /** @class */ (function () {
    function ModalSharedModule() {
    }
    ModalSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ModalSharedComponent,
                        ModalSecondarySharedComponent,
                    ],
                    imports: [
                        CommonModule,
                        NgbModalModule,
                        IconSharedModule
                    ],
                    exports: [
                        ModalSharedComponent,
                        ModalSecondarySharedComponent,
                    ],
                    providers: [
                        ModalService
                    ]
                },] }
    ];
    return ModalSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NavDropdownSharedComponent = /** @class */ (function () {
    function NavDropdownSharedComponent() {
        this.linkClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    NavDropdownSharedComponent.prototype.linkHasBeenClicked = /**
     * @return {?}
     */
    function () {
        this.linkClicked.emit(true);
    };
    NavDropdownSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-nav-dropdown',
                    template: "<div class=\"sg-nav-dropdown\">\n    <nav class=\"px-3 py-2 container\">\n        <a [routerLink]=\"link.url\" routerLinkActive=\"-active\" (click)=\"linkHasBeenClicked()\" class=\"sg-nav-dropdown__link py-1\" *ngFor=\"let link of links\">\n            {{ link.name }}\n        </a>\n    </nav>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";@media (min-width:768px){:host{position:absolute;left:0;width:100%}}.sg-nav-dropdown{position:relative;z-index:6;background-color:#ececec;text-align:left}.sg-nav-dropdown__link{color:#2f285a;font-size:1rem;display:block}@media (min-width:768px){.sg-nav-dropdown__link{display:inline-block;width:234px;padding-right:1rem}}.sg-nav-dropdown__link.-active,.sg-nav-dropdown__link:hover{color:#56e07b}"]
                }] }
    ];
    NavDropdownSharedComponent.propDecorators = {
        links: [{ type: Input }],
        linkClicked: [{ type: Output }]
    };
    return NavDropdownSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Emit a event when clicked outside of the element
 *
 * __Usage :__
 *   (ngxClickOutside)="closeDropdown()"
 *
 * __Example :__
 *   <div (ngxClickOutside)="closeDropdown()"></div>
 *
 * Module {\@link ClickOutsideSharedDirectiveModule}
 */
var ClickOutsideDirective = /** @class */ (function () {
    function ClickOutsideDirective(elementRef) {
        this.elementRef = elementRef;
        // tslint:disable-next-line:prefer-output-readonly
        this.ngxClickOutside = new EventEmitter();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    ClickOutsideDirective.prototype.onDocumentClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var targetElement = /** @type {?} */ (event.target);
        // Check if the click was outside the element
        if (targetElement && !this.elementRef.nativeElement.contains(targetElement)) {
            this.ngxClickOutside.emit(event);
        }
    };
    ClickOutsideDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ngxClickOutside]'
                },] }
    ];
    /** @nocollapse */
    ClickOutsideDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    ClickOutsideDirective.propDecorators = {
        ngxClickOutside: [{ type: Output }],
        onDocumentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
    };
    return ClickOutsideDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The ClickOutsideSharedDirectiveModule module
 *
 * import { ClickOutsideSharedDirectiveModule } from 'styleguide/src/shared/directive/click.outside/click.outside.module';
 */
var ClickOutsideSharedDirectiveModule = /** @class */ (function () {
    function ClickOutsideSharedDirectiveModule() {
    }
    ClickOutsideSharedDirectiveModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ClickOutsideDirective
                    ],
                    imports: [],
                    exports: [
                        ClickOutsideDirective
                    ]
                },] }
    ];
    return ClickOutsideSharedDirectiveModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NavDropdownSharedModule = /** @class */ (function () {
    function NavDropdownSharedModule() {
    }
    NavDropdownSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        NavDropdownSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        ClickOutsideSharedDirectiveModule
                    ],
                    exports: [
                        NavDropdownSharedComponent
                    ]
                },] }
    ];
    return NavDropdownSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR$2 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return SelectSharedComponent; }),
    multi: true
};
var SelectSharedComponent = /** @class */ (function () {
    function SelectSharedComponent(fb, ref) {
        var _this = this;
        this.fb = fb;
        this.ref = ref;
        this.clearable = false;
        this.options = [];
        this.shadow = false;
        this.noBorder = false;
        this.errors = [];
        this.onChange = function () { };
        this.onTouched = function () { };
        this.form = this.fb.group({
            select: [{ value: {}, disabled: false }]
        });
        this.select.valueChanges.subscribe(function (value) {
            _this.value = value;
        });
    }
    Object.defineProperty(SelectSharedComponent.prototype, "select", {
        get: /**
         * @return {?}
         */
        function () {
            return this.form.get('select');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._value;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.selectedValue = val;
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (typeof value !== 'undefined') {
            this.value = value;
        }
        if (typeof value === 'undefined') {
            this.value = '';
        }
        this.ref.markForCheck();
        this.switched();
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectSharedComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        if (isDisabled) {
            this.select.disable();
        }
        else {
            this.select.enable();
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @return {?}
     */
    SelectSharedComponent.prototype.switched = /**
     * @return {?}
     */
    function () {
        this.value = this.selectedValue;
        this.select.setValue(this.selectedValue);
    };
    SelectSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-select',
                    template: "<form [formGroup]=\"form\">\n    <ng-select class=\"custom sg-rounded\"\n               [class.sg-select__shadow]=\"shadow\"\n               [class.sg-select__no-border]=\"noBorder\"\n               [class.sg-select__errors]=\"errors.length > 0\"\n               [items]=\"options\"\n               formControlName=\"select\"\n               [clearable]=\"clearable\"\n               [searchable]=\"false\"\n               [placeholder]=\"placeholder\"\n               bindLabel=\"description\">\n        <ng-template ng-label-tmp let-item=\"item\">\n            <div class=\"d-flex flex-row\" [class.sg-select__placeholder]=\"!item.data\">\n                <div *ngIf=\"item.icon\" class=\"d-flex\">\n                    <div class=\"select-icon text-center\"><mlp-ng-icon [name]=\"item.icon\"></mlp-ng-icon></div>\n                    <div class=\"ml-2 mr-2 select-divider\"></div>\n                </div>\n                <div class=\"ml-1\">{{item.description}}</div>\n            </div>\n        </ng-template>\n\n        <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\">\n            <div class=\"d-flex flex-row\" [class.sg-select__placeholder]=\"!item.data\">\n                <span class=\"mr-2 pr-1\" *ngIf=\"item.icon\"><mlp-ng-icon [name]=\"item.icon\"></mlp-ng-icon></span>\n                <div>{{item.description}}</div>\n            </div>\n        </ng-template>\n    </ng-select>\n    <small class=\"form-text sg-color__danger\" *ngFor=\"let error of errors\">{{ error.title }}</small>\n</form>\n",
                    encapsulation: ViewEncapsulation.None,
                    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR$2],
                    styles: ["@charset \"UTF-8\";.ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened>.ng-select-container .ng-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.ng-select.ng-select-opened>.ng-select-container .ng-arrow:hover{border-color:transparent transparent #333}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{background-color:#fff;border-radius:4px;border:1px solid #ccc;min-height:36px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}[dir=rtl] .ng-select .ng-select-container .ng-value-container{padding-right:10px;padding-left:0}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#9d9d9d}.ng-select.ng-select-single .ng-select-container{height:36px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:5px;left:0;padding-left:10px;padding-right:50px}[dir=rtl] .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-right:10px;padding-left:50px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e6e6e6}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:5px;padding-left:7px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-right:7px;padding-left:0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-bottom:5px;background-color:#ededf2;border-radius:2px;margin-right:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{margin-right:0;margin-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:0;padding-right:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label{display:inline-block;padding:1px 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#dedee7}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #cfcfdc}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-left:1px solid #cfcfdc;border-right:none}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #cfcfdc}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:0;border-right:1px solid #cfcfdc}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 0 3px 3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 3px 3px 0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{padding-right:3px;padding-left:0}.ng-select .ng-clear-wrapper{color:#999}.ng-select .ng-clear-wrapper:hover .ng-clear{color:#d0021b}.ng-select .ng-spinner-zone{padding:5px 5px 0 0}[dir=rtl] .ng-select .ng-spinner-zone{padding:5px 0 0 5px}.ng-select .ng-arrow-wrapper{width:25px;padding-right:5px}[dir=rtl] .ng-select .ng-arrow-wrapper{padding-left:5px;padding-right:0}.ng-select .ng-arrow-wrapper:hover .ng-arrow{border-top-color:#666}.ng-select .ng-arrow-wrapper .ng-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px 0 rgba(0,0,0,.06);left:0}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:1px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:8px 10px;font-weight:500;color:rgba(0,0,0,.54);cursor:pointer}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#f4f4f7}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected.ng-option-marked{background-color:#ededf2;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:rgba(0,0,0,.87);padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked{color:#373737;background-color:#ededf2}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#f4f4f7;color:#373737}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#d0d0d0}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-right:22px;padding-left:0}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{font-size:80%;font-weight:400;padding-right:5px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-left:5px;padding-right:0}[dir=rtl] .ng-dropdown-panel{direction:rtl;text-align:right}.ng-select.custom{text-shadow:none}.ng-select.custom .ng-dropdown-panel{box-shadow:0 4px 6px 0 rgba(0,0,0,.1)}.ng-select.custom .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{padding:10px}.ng-select.custom .select-icon{width:24px}.ng-select.custom .select-divider{border-left:1px solid #d6d5d5;height:24px}.ng-select.custom .sg-select__placeholder{color:#6c757d}.ng-select.custom.sg-select__no-border .ng-select-container{border-color:#fff}.ng-select.custom .ng-select-container{height:calc(1.5em + .75rem + 2px + 8px)}.ng-select.custom.ng-select-focused:not(.sg-select__errors) .ng-select-container{border-color:#d6d5d5;box-shadow:none}.ng-select.custom.ng-select-focused.sg-select__no-border:not(.sg-select__errors) .ng-select-container{border-color:#fff}.ng-select.custom.sg-select__shadow{box-shadow:0 2px 6px 0 rgba(0,0,0,.25)}.ng-select.custom.sg-select__errors .ng-select-container{border-color:#c80a0a}"]
                }] }
    ];
    /** @nocollapse */
    SelectSharedComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: ChangeDetectorRef }
    ]; };
    SelectSharedComponent.propDecorators = {
        _value: [{ type: Input, args: ['value',] }],
        clearable: [{ type: Input }],
        options: [{ type: Input }],
        placeholder: [{ type: Input }],
        shadow: [{ type: Input }],
        noBorder: [{ type: Input }],
        errors: [{ type: Input }]
    };
    return SelectSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SelectSharedModule = /** @class */ (function () {
    function SelectSharedModule() {
    }
    SelectSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SelectSharedComponent
                    ],
                    imports: [
                        ReactiveFormsModule,
                        CommonModule,
                        IconSharedModule,
                        NgSelectModule
                    ],
                    exports: [
                        SelectSharedComponent
                    ]
                },] }
    ];
    return SelectSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SearchFiltersSharedComponent = /** @class */ (function () {
    function SearchFiltersSharedComponent() {
        this.visible = false;
        this.selectedSection = '';
    }
    /**
     * @param {?} section
     * @return {?}
     */
    SearchFiltersSharedComponent.prototype.setVisible = /**
     * @param {?} section
     * @return {?}
     */
    function (section) {
        if (section === this.selectedSection) {
            this.visible = false;
            this.selectedSection = '';
            return;
        }
        this.selectedSection = section;
        this.visible = true;
    };
    /**
     * @param {?} item
     * @param {?} val
     * @return {?}
     */
    SearchFiltersSharedComponent.prototype.method = /**
     * @param {?} item
     * @param {?} val
     * @return {?}
     */
    function (item, val) {
        this.searchFilter.form.controls[item].setValue(val);
    };
    SearchFiltersSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-search-filters',
                    template: "<section class=\"search-filters\">\n    {{ searchFilter.name }}\n    <a href=\"\" (click)=\"setVisible(title); false;\" *ngFor=\"let title of searchFilter.titles\" class=\"search-filters__link ml-3\" \n    [ngClass]=\"{'search-filters__link--active': title == selectedSection}\">{{ title }} \n        <!-- TODO: New icons from Andrew/Luca -->\n        <mlp-ng-icon class=\"search-filters__icon\" name=\"arrow-down-1\"></mlp-ng-icon>\n    </a>\n    <section class=\"search-filters__section mt-2\" [ngClass]=\"{'search-filters__section--hidden': !visible}\">\n        <form [formGroup]=\"searchFilter.form\">\n            <ng-container *ngFor=\"let radios of searchFilter.options\">\n                    <ng-container *ngFor=\"let radio of radios.filterOptions\">\n\n                        <mlp-ng-radio \n                            *ngIf=\"!radios.type\" \n                            class=\"search-filters__label\"\n                            [formControlName]=\"radio.formControlName\" \n                            [name]=\"radio.name\" \n                            [radioValue]=\"radio.value\" \n                            [ngClass]=\"{'d-none': radios.name != selectedSection}\">{{ radio.label }}</mlp-ng-radio>\n                        \n                        <ng-container *ngIf=\"radios.type === 'calendar'\">\n                            <a class=\"sg-sf\" (click)=\"method(radio.formControlName, ''); false;\" [ngClass]=\"{'d-none': radios.name != selectedSection}\">\n                                <span class=\"sg-sf__indicator\" [ngClass]=\"{'checked': searchFilter.form.controls[radio.formControlName].value === ''}\"></span>\n                                   All\n                            </a>\n                            \n                            <mlp-ng-input-calendar class=\"search-filters__input\" \n                                [ngClass]=\"{'d-none': radios.name != selectedSection, 'd-inline-block': radios.name == selectedSection}\"\n                                [formControlName]=\"radio.formControlName\"\n                                [input]=\"{ placeholder: 'Select date' }\"></mlp-ng-input-calendar>\n\n                        </ng-container>\n\n                    </ng-container>\n            </ng-container>\n        </form>\n    </section>\n</section>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-radio{position:relative;padding-top:.25rem;padding-left:1.25rem;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#373737}.sg-radio__button{cursor:pointer;border-radius:.25rem;background-color:#fff;border:1px solid #2f285a;padding:.25rem .75rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-radio__button--small{padding:.15rem .5rem;font-size:.875rem}.sg-radio--disabled{color:#737373}.sg-radio__input{display:none}.sg-radio__input:disabled~.sg-radio__checkmark:after{top:0;left:0;height:12px;width:12px;background-color:#ececec}.sg-radio__input:checked~.sg-radio__checkmark:after,.sg-radio__input:disabled~.sg-radio__checkmark:after{opacity:1}.sg-radio__input:checked~.sg-radio__button,.sg-radio__input:disabled~.sg-radio__button{background-color:#2f285a;color:#fff}.sg-radio__input:disabled:checked~.sg-radio__checkmark:after{top:4px;left:4px;width:5px;height:5px;opacity:.45;background-color:#737373}.sg-radio__input:checked~.sg-radio__checkmark{background-color:#56e07b;border-color:transparent}.sg-radio__checkmark{position:absolute;top:.5rem;left:0;height:15px;width:15px;background-color:#fff;border:1px solid #c8c8c8;border-radius:50%}.sg-radio__checkmark:after{content:\"\";position:absolute;opacity:0;top:4px;left:4px;width:5px;height:5px;border-radius:50%;background-color:#2f285a;transition:opacity 250ms ease-in-out}:host{width:100%;display:block}.search-filters{color:#aeadad;font-size:.875rem}.search-filters__section{padding:1rem 1rem .75rem;border-radius:.25rem;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.search-filters__section--hidden{display:none}.search-filters__link{color:#aeadad;font-weight:700;vertical-align:text-top}.search-filters__link--active,.search-filters__link:hover{color:#464a4c}.search-filters__icon{display:inline;position:relative;top:-2px}.search-filters__label{display:block;text-transform:capitalize}@media (min-width:768px){.search-filters__label{display:inline-block;margin-right:1rem}}.search-filters__input{width:auto!important}.sg-sf{position:relative;padding-top:.35rem;padding-left:1.25rem;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-right:2rem}.sg-sf__indicator{position:absolute;top:.5rem;left:0;height:15px;width:15px;border:1px solid #aeadad;border-radius:50%}.sg-sf__indicator:after{content:\"\";position:absolute;opacity:0;top:4px;left:4px;width:5px;height:5px;border-radius:50%;background-color:#464a4c;transition:opacity 250ms ease-in-out}.sg-sf__indicator.checked:after{opacity:1}"]
                }] }
    ];
    SearchFiltersSharedComponent.propDecorators = {
        searchFilter: [{ type: Input }]
    };
    return SearchFiltersSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$2 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return InputCalendarSharedComponent; }),
    multi: true
};
var InputCalendarSharedComponent = /** @class */ (function () {
    function InputCalendarSharedComponent() {
        this.errors = [];
        // tslint:disable-next-line:no-input-rename
        this._value = '';
        this.toggleDtp = new EventEmitter();
        this.dateVal = '';
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(InputCalendarSharedComponent.prototype, "inputSettings", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var input = __assign({}, this.input);
            return input;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputCalendarSharedComponent.prototype, "id", {
        get: /**
         * @return {?}
         */
        function () { return (this.input.id) ? this.input.id : ''; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputCalendarSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.dateVal = (val) ? this.createDate(val) : '';
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.dateVal = (value) ? this.createDate(value) : '';
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.updateValue = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.value = event;
    };
    /**
     * @param {?} data
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.createDate = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var date = {
            day: this.prependZero(data.day),
            month: this.prependZero(data.month)
        };
        return date.day + "-" + date.month + "-" + data.year;
    };
    /**
     * @param {?} val
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.prependZero = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        return ("0" + val).slice(-2);
    };
    /**
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.updateDate = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var reg = new RegExp(/^\d{2}-\d{2}-\d{4}$|^\d{1}-\d{1}-\d{4}$|^\d{2}-\d{1}-\d{4}$|^\d{1}-\d{2}-\d{4}$/);
        /** @type {?} */
        var MATCHES = reg.test(this.dateVal);
        if (MATCHES) {
            /** @type {?} */
            var DATE = this.dateVal.split('-');
            this.updateValue({
                day: parseInt(this.prependZero(DATE[0]), 10),
                month: parseInt(this.prependZero(DATE[1]), 10),
                year: parseInt(DATE[2], 10)
            });
        }
    };
    /**
     * @return {?}
     */
    InputCalendarSharedComponent.prototype.toggleDatepicker = /**
     * @return {?}
     */
    function () {
        this.toggleDtp.emit();
    };
    InputCalendarSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input-calendar',
                    template: "<mlp-ng-input [(ngModel)]=\"dateVal\" icon=\"calendar-3\" placeholder=\"dd-mm-yyyy\"\n    [errors]=\"errors\" [inputDisabled]=\"inputDisabled\" (input)=\"updateDate()\" [inputId]=\"inputId\" (click)=\"!inputSettings.disabled ? toggleDatepicker() : false;\"></mlp-ng-input>\n<mlp-ng-datepicker [toggle]=\"toggleDtp\" [ngDatepickerConfig]=\"ngDatepickerConfig\" [date]=\"value\" (chosenDate)=\"updateValue($event)\"></mlp-ng-datepicker>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$2
                    ],
                    styles: ["@charset \"UTF-8\";:host{position:relative;display:block;width:100%}"]
                }] }
    ];
    InputCalendarSharedComponent.propDecorators = {
        input: [{ type: Input }],
        inputId: [{ type: Input }],
        inputDisabled: [{ type: Input }],
        errors: [{ type: Input }],
        ngDatepickerConfig: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }]
    };
    return InputCalendarSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DatepickerSharedComponent = /** @class */ (function () {
    function DatepickerSharedComponent(config) {
        this.config = config;
        this.toggle = new EventEmitter();
        // tslint:disable-next-line:prefer-output-readonly
        this.chosenDate = new EventEmitter();
    }
    /**
     * @return {?}
     */
    DatepickerSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.toggle.subscribe(function (_) { return _this.datepicker.toggle(); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    DatepickerSharedComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        /** @type {?} */
        var dateConfig = changes['ngDatepickerConfig'];
        if (dateConfig)
            Object.assign(this.config, this.ngDatepickerConfig);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DatepickerSharedComponent.prototype.onDateSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.chosenDate.emit(event);
    };
    DatepickerSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-datepicker',
                    template: "<input ngbDatepicker hidden #d=\"ngbDatepicker\" [(ngModel)]=\"date\" (dateSelect)=\"onDateSelect($event)\">",
                    providers: [NgbDatepickerConfig],
                    styles: ["@charset \"UTF-8\";:host ::ng-deep ngb-datepicker{position:absolute;background-color:#fff;width:14.75rem;top:32px!important;left:0;right:0;margin-left:auto;margin-right:auto;z-index:4}:host ::ng-deep ngb-datepicker .btn-link,:host ::ng-deep ngb-datepicker .ngb-dp-weekday{color:#2f285a!important}:host ::ng-deep ngb-datepicker .ngb-dp-month-name{height:1.5rem;line-height:1.5rem;font-size:1rem}:host ::ng-deep ngb-datepicker .ngb-dp-day .btn-light:hover{background-color:#6d688b}:host ::ng-deep ngb-datepicker .ngb-dp-day .bg-primary{background-color:#2f285a!important}:host ::ng-deep ngb-datepicker .ngb-dp-week{margin-bottom:5px}"]
                }] }
    ];
    /** @nocollapse */
    DatepickerSharedComponent.ctorParameters = function () { return [
        { type: NgbDatepickerConfig }
    ]; };
    DatepickerSharedComponent.propDecorators = {
        toggle: [{ type: Input }],
        date: [{ type: Input }],
        ngDatepickerConfig: [{ type: Input }],
        chosenDate: [{ type: Output }],
        datepicker: [{ type: ViewChild, args: ['d',] }]
    };
    return DatepickerSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DatepickerSharedModule = /** @class */ (function () {
    function DatepickerSharedModule() {
    }
    DatepickerSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        DatepickerSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        NgbDatepickerModule.forRoot()
                    ],
                    exports: [
                        DatepickerSharedComponent
                    ]
                },] }
    ];
    return DatepickerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputCalendarSharedModule = /** @class */ (function () {
    function InputCalendarSharedModule() {
    }
    InputCalendarSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputCalendarSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        InputSharedModule,
                        DatepickerSharedModule
                    ],
                    exports: [
                        InputCalendarSharedComponent
                    ]
                },] }
    ];
    return InputCalendarSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SearchFiltersSharedModule = /** @class */ (function () {
    function SearchFiltersSharedModule() {
    }
    SearchFiltersSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SearchFiltersSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        RadioSharedModule,
                        ReactiveFormsModule,
                        IconSharedModule,
                        InputCalendarSharedModule
                    ],
                    exports: [
                        SearchFiltersSharedComponent
                    ]
                },] }
    ];
    return SearchFiltersSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SlotService = /** @class */ (function () {
    function SlotService() {
    }
    /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    SlotService.prototype.getBookingFromSlot = /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    function (slot, pitch) {
        if (slot.relationships && slot.relationships.bookings && slot.relationships.bookings.data.length > 0 && pitch) {
            /** @type {?} */
            var bookingFound = slot.relationships.bookings.data.slice().reverse()
                .find(function (booking) { return pitch.id == booking.relationships.pitch.data.id; });
            if (bookingFound && bookingFound.attributes.status === 'confirmed') {
                return bookingFound;
            }
            /** @type {?} */
            var cascadingBookingFound = slot.relationships.bookings.data.slice().reverse()
                .find(function (booking) { return pitch.id != booking.relationships.pitch.data.id; });
            if (cascadingBookingFound && cascadingBookingFound.attributes.status === 'confirmed') {
                return cascadingBookingFound;
            }
            /** @type {?} */
            var cancelledBooking = slot.relationships.bookings.data.slice().reverse()
                .find(function (booking) { return booking.attributes.status === 'cancelled'; });
            if (cancelledBooking) {
                return cancelledBooking;
            }
            /** @type {?} */
            var pendingBooking = slot.relationships.bookings.data.slice().reverse()
                .find(function (booking) { return booking.attributes.status === 'pending'; });
            if (pendingBooking) {
                return pendingBooking;
            }
        }
    };
    /**
     * @param {?} slot
     * @return {?}
     */
    SlotService.prototype.getFirstBookingFromSlot = /**
     * @param {?} slot
     * @return {?}
     */
    function (slot) {
        if (slot.relationships && slot.relationships.bookings && slot.relationships.bookings.data.length > 0) {
            return slot.relationships.bookings.data[slot.relationships.bookings.data.length - 1];
        }
    };
    /**
     * @param {?} slots
     * @param {?} pitch
     * @return {?}
     */
    SlotService.prototype.isBookingPresent = /**
     * @param {?} slots
     * @param {?} pitch
     * @return {?}
     */
    function (slots, pitch) {
        var _this = this;
        /** @type {?} */
        var present = false;
        slots.forEach(function (slot) {
            if (_this.isConfirmedBooking(slot, pitch)) {
                present = true;
            }
        });
        return present;
    };
    /**
     * @param {?} slots
     * @return {?}
     */
    SlotService.prototype.isBookingPresentInAnyPitch = /**
     * @param {?} slots
     * @return {?}
     */
    function (slots) {
        var _this = this;
        /** @type {?} */
        var present = false;
        slots.forEach(function (slot) {
            if (_this.isConfirmedBookingInAnyPitch(slot)) {
                present = true;
            }
        });
        return present;
    };
    /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    SlotService.prototype.isConfirmedBooking = /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    function (slot, pitch) {
        /** @type {?} */
        var found = false;
        /** @type {?} */
        var booking = this.getBookingFromSlot(slot, pitch);
        if (slot.attributes.availabilities === 0 && pitch && booking) {
            if (booking.attributes.status === 'confirmed' && booking.relationships.pitch.data.id === pitch.id) {
                found = true;
            }
        }
        return found;
    };
    /**
     * @param {?} slot
     * @return {?}
     */
    SlotService.prototype.isConfirmedBookingInAnyPitch = /**
     * @param {?} slot
     * @return {?}
     */
    function (slot) {
        /** @type {?} */
        var found = false;
        /** @type {?} */
        var booking = this.getFirstBookingFromSlot(slot);
        if (slot.attributes.availabilities === 0 && booking && booking.attributes.status === 'confirmed') {
            found = true;
        }
        return found;
    };
    /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    SlotService.prototype.isCascadingBooking = /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    function (slot, pitch) {
        /** @type {?} */
        var found = false;
        /** @type {?} */
        var booking = this.getBookingFromSlot(slot, pitch);
        if (slot.attributes.availabilities === 0 && pitch && booking) {
            if (booking.attributes.status === 'confirmed' && booking.relationships.pitch.data.id !== pitch.id) {
                found = true;
            }
        }
        return found;
    };
    /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    SlotService.prototype.isCancelledBooking = /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    function (slot, pitch) {
        /** @type {?} */
        var found = false;
        /** @type {?} */
        var booking = this.getBookingFromSlot(slot, pitch);
        if (slot.attributes.availabilities === 0 && pitch && booking) {
            if (booking.attributes.status === 'cancelled') {
                found = true;
            }
        }
        return found;
    };
    /**
     * @param {?} slot
     * @return {?}
     */
    SlotService.prototype.isUnavailableSlot = /**
     * @param {?} slot
     * @return {?}
     */
    function (slot) {
        /** @type {?} */
        var flag = false;
        // tslint:disable-next-line:max-line-length
        if (slot.attributes.availabilities === 0 && (slot.relationships && slot.relationships.bookings && slot.relationships.bookings.data.length === 0)) {
            flag = true;
        }
        else if (slot.attributes.availabilities === 0 && (!slot.relationships || (slot.relationships && !slot.relationships.bookings))) {
            flag = true;
        }
        return flag;
    };
    SlotService.decorators = [
        { type: Injectable }
    ];
    return SlotService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Animates :enter and :leave
 *
 * \@example
 * [\@fadeInFadeOutAnimation]
 *
  @type {?} */
var fadeInFadeOutAnimation = trigger('fadeInFadeOutAnimation', [
    transition(':enter', [
        // styles at start of transition
        style({ opacity: 0 }),
        // animation and styles at end of transition
        animate(ANIMATIONS.speed.default, style({ opacity: 1 }))
    ])
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SlotSharedComponent = /** @class */ (function () {
    function SlotSharedComponent(slotService, cp) {
        this.slotService = slotService;
        this.cp = cp;
        this.showMenu = false;
    }
    /**
     * @param {?} state
     * @return {?}
     */
    SlotSharedComponent.prototype.toggleMenu = /**
     * @param {?} state
     * @return {?}
     */
    function (state$$1) {
        var _this = this;
        /** @type {?} */
        var slot = this.slot;
        if (state$$1 === 'enter' && slot && slot.attributes) {
            this.flippingDelay = setTimeout(function () {
                _this.showMenu = true;
            }, 400);
        }
        if (state$$1 === 'leave') {
            this.showMenu = false;
            clearTimeout(this.flippingDelay);
        }
    };
    /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    SlotSharedComponent.prototype.getTextForSlot = /**
     * @param {?} slot
     * @param {?} pitch
     * @return {?}
     */
    function (slot, pitch) {
        if (this.slotService.isUnavailableSlot(slot)) {
            return 'unavailable';
        }
        else if (this.slotService.isConfirmedBooking(slot, pitch) || this.slotService.isCascadingBooking(slot, pitch)) {
            return 'booked';
        }
        /** @type {?} */
        var booking = this.slotService.getBookingFromSlot(slot, pitch);
        if (booking && slot.attributes.availabilities === 0 && pitch.id != booking.relationships.pitch.data.id && booking.attributes.status === 'cancelled') {
            return 'cancelled';
        }
        else if (booking && booking.attributes.status === 'pending') {
            return 'pending';
        }
        return this.cp.transform(slot.attributes.price, slot.attributes.currency);
    };
    SlotSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-slot',
                    template: "<ng-container *ngIf=\"slot.id\">\n    <a class=\"sg-slot text-center cursor d-flex justify-content-center align-items-center\"\n       [class.sg-slot--available]=\"slot.attributes.availabilities > 0\"\n       [class.sg-slot--confirmed]=\"slotService.isConfirmedBooking(slot, pitch)\"\n       (mouseenter)=\"toggleMenu('enter')\" (mouseleave)=\"toggleMenu('leave')\">\n\n        <div *ngIf=\"!showMenu\" [@fadeInFadeOutAnimation]>\n            <p class=\"sg-slot__desc sg-slot__desc--bigger\">{{ slot.attributes.starts | ngxTime }}</p>\n            <p class=\"sg-slot__desc\">{{getTextForSlot(slot, pitch)}}</p>\n            <p class=\"sg-slot__desc\">{{ slot.attributes.starts | ngxDuration: slot.attributes.ends }}min</p>\n        </div>\n\n        <div *ngIf=\"showMenu\" [@fadeInFadeOutAnimation]>\n            <ng-content></ng-content>\n        </div>\n    </a>\n\n</ng-container>\n\n<div *ngIf=\"!slot.id\" class=\"sg-slot text-center sg-slot--empty\"></div>\n",
                    animations: [fadeInFadeOutAnimation],
                    styles: ["@charset \"UTF-8\";.sg-slot{display:block;background-color:#eceeef;border-radius:.25rem;padding:.25rem 0;color:#000;border:1px solid #dfdfdf;transition:background-color 250ms ease-in-out;height:55px;line-height:1.2;font-size:.75rem;position:relative;overflow:hidden}.sg-slot:hover{transition-delay:.2s;background-color:#eceeef}.sg-slot--available{background-color:#deee86;border:1px solid #a3bc00;line-height:1.3}.sg-slot--available:hover{transition-delay:.2s;background-color:#fff}.sg-slot--confirmed{background-color:#fef1cb;border:1px solid #dfdfdf;line-height:1.3}.sg-slot--confirmed:hover{transition-delay:.2s;background-color:#fff}.sg-slot--empty{background-color:#fff;border:1px solid #dfdfdf}.sg-slot--empty:hover{transition-delay:.2s;background-color:#fff}.sg-slot__desc{margin-bottom:0}.sg-slot__desc--bigger{font-weight:700;letter-spacing:1.5px;font-size:.875rem}"]
                }] }
    ];
    /** @nocollapse */
    SlotSharedComponent.ctorParameters = function () { return [
        { type: SlotService },
        { type: CurrencyPipe }
    ]; };
    SlotSharedComponent.propDecorators = {
        slot: [{ type: Input }],
        pitch: [{ type: Input }]
    };
    return SlotSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextNavSharedComponent = /** @class */ (function () {
    function TextNavSharedComponent() {
    }
    TextNavSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-text-nav',
                    template: "<nav class=\"sg-text-nav\" [ngClass]=\"{'sg-text-nav--small': config?.size === 'small'}\">\n    <ng-content></ng-content>\n</nav>",
                    // tslint:disable-next-line:use-view-encapsulation
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-text-nav>a{display:block;color:#188155;font-size:.875rem}.sg-text-nav>a:hover{color:#5da788}.sg-text-nav--small>a{font-size:.75rem}"]
                }] }
    ];
    TextNavSharedComponent.propDecorators = {
        config: [{ type: Input }]
    };
    return TextNavSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextNavSharedModule = /** @class */ (function () {
    function TextNavSharedModule() {
    }
    TextNavSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TextNavSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TextNavSharedComponent
                    ]
                },] }
    ];
    return TextNavSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment = momentNs;
/**
 * Converts a date string to format
 * https://momentjs.com/timezone/
 *
 * __Usage :__
 *   day | ngxTime
 *
 * __Example :__
 *   {{ '2019-01-29T09:00:00+01:00' | ngxTime }}
 *   formats to: 09:00
 *
 * Module {\@link TransformTimeModule}
 */
var TransformTimePipe = /** @class */ (function () {
    function TransformTimePipe() {
    }
    /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    TransformTimePipe.prototype.transform = /**
     * @param {?} date
     * @param {?=} format
     * @return {?}
     */
    function (date, format$$1) {
        if (format$$1 === void 0) { format$$1 = 'HH:mm'; }
        /** @type {?} */
        var moDate = moment.tz(date, 'Europe/London');
        if (moDate._isValid) {
            return moDate.format(format$$1);
        }
        return date;
    };
    TransformTimePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ngxTime'
                },] }
    ];
    return TransformTimePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The TransformDuration module
 *
 * import { TransformTimeModule } from 'styleguide/src/shared/pipe/time/pipe.time.module';
 */
var TransformTimeModule = /** @class */ (function () {
    function TransformTimeModule() {
    }
    TransformTimeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformTimePipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformTimePipe
                    ]
                },] }
    ];
    return TransformTimeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Get the duraton between start date and end date in minutes
 *
 * __Usage :__
 *   startDate | ngxDuration: endDate
 *
 * __Example :__
 *   {{ 2017-08-27T16:30:00.000Z | ngxDuration: 2017-08-27T17:30:00.000Z }}
 *   formats to: 60
 *
 * Module {\@link TransformDurationToTextModule}
 */
var TransformDurationPipe = /** @class */ (function () {
    function TransformDurationPipe() {
    }
    /**
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    TransformDurationPipe.prototype.transform = /**
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    function (startDate, endDate) {
        /** @type {?} */
        var diffs = 0;
        if (startDate && endDate) {
            /** @type {?} */
            var endTime = DateTime.fromISO(endDate);
            /** @type {?} */
            var start = DateTime.fromISO(startDate);
            diffs = endTime.diff(start, ['minutes']).toObject().minutes;
            if (diffs < 0 || typeof diffs === 'undefined')
                diffs = 0;
        }
        return diffs;
    };
    TransformDurationPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ngxDuration'
                },] }
    ];
    return TransformDurationPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The TransformDuration module
 *
 * import { TransformDurationModule } from 'styleguide/src/shared/pipe/duration/pipe.duration.module';
 */
var TransformDurationModule = /** @class */ (function () {
    function TransformDurationModule() {
    }
    TransformDurationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformDurationPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformDurationPipe
                    ]
                },] }
    ];
    return TransformDurationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SlotSharedModule = /** @class */ (function () {
    function SlotSharedModule() {
    }
    SlotSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SlotSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        TransformTimeModule,
                        TextNavSharedModule,
                        TransformDurationModule
                    ],
                    exports: [
                        SlotSharedComponent
                    ],
                    providers: [
                        SlotService,
                        CurrencyPipe
                    ]
                },] }
    ];
    return SlotSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SportSharedComponent = /** @class */ (function () {
    function SportSharedComponent() {
        this.active = false;
    }
    Object.defineProperty(SportSharedComponent.prototype, "faIcon", {
        get: /**
         * @return {?}
         */
        function () { return (this.active) ? 'check-1' : 'add'; },
        enumerable: true,
        configurable: true
    });
    SportSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-sport',
                    template: "<button type=\"button\" class=\"sg-sport cursor\" [ngClass]=\"{'sg-sport--active': active}\">\n    <mlp-ng-icon class=\"sg-sport__icon-action\" [ngClass]=\"{'-active': active}\" [name]=\"faIcon\"></mlp-ng-icon>\n    <figure class=\"sg-sport__figure\">\n        <mlp-ng-icon class=\"sg-sport__icon\" [name]=\"sport.id\"></mlp-ng-icon>\n        <figcaption>{{ sport.attributes.name }}</figcaption>\n    </figure>\n</button>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-sport{display:block;position:relative;width:100%;text-align:center;font-family:\"Frank New\",sans-serif;font-size:.875rem;font-weight:500;padding:.5rem .25rem;border:1px solid #d6d5d5;transition:border 250ms ease-in-out,box-shadow 250ms ease-in-out,color 250ms ease-in-out,box-shadow 250ms ease-in-out;border-radius:.25rem}@media (min-width:768px){.sg-sport{padding:1rem .25rem}}.sg-sport--active{background-color:#ccf5d7;border-color:#188155}.sg-sport:not(.sg-sport--active):hover{border-color:#188155;color:#188155}.sg-sport:not(.sg-sport--active):hover .sg-sport__icon-action{opacity:1;color:#188155}.sg-sport__figure{margin-bottom:0}.sg-sport__icon{display:block}.sg-sport__icon ::ng-deep i{font-size:3rem}.sg-sport__icon-action{position:absolute;top:5px;right:10px;color:#373737;opacity:0;transition:opacity 250ms ease-in-out}.sg-sport__icon-action.-active{opacity:1}"]
                }] }
    ];
    SportSharedComponent.propDecorators = {
        sport: [{ type: Input }],
        active: [{ type: Input }]
    };
    return SportSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SportSharedModule = /** @class */ (function () {
    function SportSharedModule() {
    }
    SportSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SportSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        SportSharedComponent
                    ]
                },] }
    ];
    return SportSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var StatusSharedComponent = /** @class */ (function () {
    function StatusSharedComponent() {
    }
    StatusSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-status',
                    template: "<section class=\"sg-status pl-3 pl-md-4\">\n    <h1 class=\"sg-status__title mb-0\">{{ status.title }}</h1>\n\n    <div>\n        <mlp-ng-icon class=\"sg-status__icon pr-2\" [name]=\"status.icon\"></mlp-ng-icon> <span class=\"sg-status__description\">{{ status.description }}</span>\n    </div>\n\n    <mlp-ng-text-button-internal [label]=\"status?.link?.label\" [url]=\"status?.link?.url\" [iconName]=\"status?.link?.icon\"></mlp-ng-text-button-internal>\n</section>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{display:block}.sg-status{border-left:1px solid #eceeef}.sg-status__description,.sg-status__title{font-family:\"Frank New\",sans-serif;font-weight:700}@media (min-width:768px){.sg-status__icon{font-size:1.5rem}}"]
                }] }
    ];
    StatusSharedComponent.propDecorators = {
        status: [{ type: Input }]
    };
    return StatusSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonInternalSharedComponent = /** @class */ (function () {
    function TextButtonInternalSharedComponent() {
        this.weight = 'normal';
        this.queryParamsHandling = 'preserve';
    }
    /**
     * @return {?}
     */
    TextButtonInternalSharedComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.attributes) {
            Object.keys(this.attributes).forEach(function (key) {
                _this.aTagElement.nativeElement.setAttribute(key, _this.attributes[key]);
            });
        }
    };
    TextButtonInternalSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-text-button-internal',
                    template: "<a href=\"\" class=\"text-button-default -{{weight}}\" #aTag [routerLink]=\"url\" [queryParamsHandling]=\"queryParamsHandling\">\n  <mlp-ng-icon name=\"{{iconName}}\" class=\"mr-1\" *ngIf=\"iconName\"></mlp-ng-icon>\n  {{label}}\n  <mlp-ng-icon name=\"{{iconNameAfter}}\" [size]=\"iconNameAfterSize\" class=\"ml-1\" *ngIf=\"iconNameAfter\"></mlp-ng-icon>\n</a>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.text-button-default{color:#2f285a;text-transform:uppercase;white-space:nowrap;font-family:\"Frank New\",sans-serif;font-weight:700;font-size:1.125rem}.text-button-default:hover{color:#6d688b}.text-button-default.-medium{font-size:1rem;font-weight:500!important}.text-button-default.-normal{font-size:1.125rem;font-weight:400!important}"]
                }] }
    ];
    TextButtonInternalSharedComponent.propDecorators = {
        attributes: [{ type: Input }],
        label: [{ type: Input }],
        url: [{ type: Input }],
        iconName: [{ type: Input }],
        iconNameAfter: [{ type: Input }],
        iconNameAfterSize: [{ type: Input }],
        weight: [{ type: Input }],
        queryParamsHandling: [{ type: Input }],
        aTagElement: [{ type: ViewChild, args: ['aTag',] }]
    };
    return TextButtonInternalSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonInternalSharedModule = /** @class */ (function () {
    function TextButtonInternalSharedModule() {
    }
    TextButtonInternalSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TextButtonInternalSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        RouterModule.forChild([])
                    ],
                    exports: [
                        TextButtonInternalSharedComponent
                    ]
                },] }
    ];
    return TextButtonInternalSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var StatusSharedModule = /** @class */ (function () {
    function StatusSharedModule() {
    }
    StatusSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        StatusSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        TextButtonInternalSharedModule,
                        IconSharedModule
                    ],
                    exports: [
                        StatusSharedComponent
                    ]
                },] }
    ];
    return StatusSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubNavSharedComponent = /** @class */ (function () {
    function SubNavSharedComponent() {
        this.toggleDropdown = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SubNavSharedComponent.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.links.showMenu = !this.links.showMenu;
        this.toggleDropdown.emit(this.links.showMenu);
    };
    SubNavSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-sub-nav',
                    template: "<a href=\"\" (click)=\"toggle(); false;\" class=\"sg-nav-sub__link py-1 text-right d-md-none\">\n    {{ (links.showMenu) ? 'Close' : 'More' }} <mlp-ng-icon [name]=\"(links.showMenu) ? 'arrow-up-1' : 'arrow-down-1'\"></mlp-ng-icon>\n</a>\n\n<nav class=\"sg-nav-sub pr-5 py-1 d-none d-md-block\">\n    <a class=\"sg-nav-sub__link py-3\" [routerLink]=\"link.url\" [routerLinkActive]=\"'-active'\" [routerLinkActiveOptions]=\"{ exact: links?.routerLinkActiveOptions }\" *ngFor=\"let link of links.mainLinks\">\n        {{ link.name }}\n    </a>\n    <a href=\"\" (click)=\"toggle(); false;\" class=\"sg-nav-sub__link py-3 d-none d-md-inline\" *ngIf=\"links.dropdownLinks\">\n        {{ (links.showMenu) ? 'Close' : 'More' }} <mlp-ng-icon [name]=\"(links.showMenu) ? 'arrow-up-1' : 'arrow-down-1'\"></mlp-ng-icon>\n    </a>\n</nav>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-nav-sub{width:100%}.sg-nav-sub__link{text-decoration:none;display:block;position:relative;color:#2f285a;font-family:\"Frank New\",sans-serif;font-weight:700}@media (min-width:768px){.sg-nav-sub__link{display:inline-block;margin-right:1.5rem;text-transform:uppercase}.sg-nav-sub__link:last-of-type{margin-right:0}}@media (min-width:992px){.sg-nav-sub__link{margin-right:2.5rem}}.sg-nav-sub__link.-active,.sg-nav-sub__link.-active:hover,.sg-nav-sub__link:hover{color:#56e07b}@media (min-width:768px){.sg-nav-sub__link.-active,.sg-nav-sub__link.-active:hover{color:#2f285a}.sg-nav-sub__link.-active:after{content:'';position:absolute;left:0;bottom:0;width:100%;border-bottom:4px solid #56e07b;z-index:2}}"]
                }] }
    ];
    SubNavSharedComponent.propDecorators = {
        links: [{ type: Input }],
        toggleDropdown: [{ type: Output }]
    };
    return SubNavSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubNavSharedModule = /** @class */ (function () {
    function SubNavSharedModule() {
    }
    SubNavSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SubNavSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        IconSharedModule,
                        NavDropdownSharedModule
                    ],
                    exports: [
                        SubNavSharedComponent
                    ]
                },] }
    ];
    return SubNavSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubNavHorizontalSharedComponent = /** @class */ (function () {
    function SubNavHorizontalSharedComponent() {
        this.rightButtonAction = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SubNavHorizontalSharedComponent.prototype.rightButtonClick = /**
     * @return {?}
     */
    function () {
        this.rightButtonAction.emit();
    };
    SubNavHorizontalSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-sub-nav-horizontal',
                    template: "<section class=\"nav-horizontal\">\n    <div class=\"container\">\n        <nav class=\"nav-horizontal__nav py-2 pt-md-4 pb-md-4\">\n            <a class=\"nav-horizontal__link\" [routerLink]=\"link.url\" [routerLinkActive]=\"'nav-horizontal__link--active'\" *ngFor=\"let link of links.data\">\n                <mlp-ng-icon class=\"nav-horizontal__icon mb-2\" [name]=\"link?.icon\"></mlp-ng-icon>\n                {{ link.name }}\n            </a>\n\n            <a *ngIf=\"rightButtonLabel\" href=\"\" class=\"nav-horizontal__link nav-horizontal__link--right\" (click)=\"rightButtonClick()\">\n                <mlp-ng-icon class=\"nav-horizontal__icon mb-2\" [name]=\"rightButtonIcon\"></mlp-ng-icon>\n                {{ rightButtonLabel }}\n            </a>\n        </nav>\n    </div>\n</section>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";@media (min-width:768px){:host{width:100%;display:block}.nav-horizontal{position:relative}.nav-horizontal:after{position:absolute;left:0;bottom:0;content:'';height:7px;width:100%;background:linear-gradient(to top,transparent,#eceeef)}}.nav-horizontal__nav{text-transform:uppercase;display:flex;flex-direction:row;position:fixed;bottom:0;left:0;width:100%;z-index:4;background-color:#2f285a;font-family:\"Frank New\",sans-serif;font-weight:400;font-size:.75rem}.nav-horizontal__link{color:#fff;text-decoration:none;margin:auto;text-align:center;display:inline-block;position:relative}.nav-horizontal__link:hover{color:#ccf5d7}@media (min-width:768px){.nav-horizontal__nav{font-family:\"Frank New\",sans-serif;font-weight:700;font-size:1rem;background-color:transparent;position:relative}.nav-horizontal__link{margin:0 2.5rem 0 0;color:#188155}.nav-horizontal__link:after{z-index:3;content:'';position:absolute;bottom:-1.3rem;left:0;width:100%;border-bottom:4px solid #56e07b;opacity:0;transition:opacity 250ms ease-in-out}.nav-horizontal__link--right{margin-left:auto}.nav-horizontal__link:last-of-type(:not(.nav-horizontal__link--right)){margin:0}.nav-horizontal__link:hover{color:#5da788}.nav-horizontal__link:hover:after{opacity:1}}.nav-horizontal__link--active{color:#56e07b}.nav-horizontal__link--active:hover{color:#56e07b}.nav-horizontal__icon{display:inline-block;width:100%}@media (min-width:768px){.nav-horizontal__link--active,.nav-horizontal__link--active:hover{color:#373737}.nav-horizontal__link--active:after{opacity:1}.nav-horizontal__icon{display:none}}"]
                }] }
    ];
    SubNavHorizontalSharedComponent.propDecorators = {
        links: [{ type: Input }],
        rightButtonLabel: [{ type: Input }],
        rightButtonIcon: [{ type: Input }],
        rightButtonAction: [{ type: Output }]
    };
    return SubNavHorizontalSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubNavHorizontalSharedModule = /** @class */ (function () {
    function SubNavHorizontalSharedModule() {
    }
    SubNavHorizontalSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SubNavHorizontalSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        IconSharedModule
                    ],
                    exports: [
                        SubNavHorizontalSharedComponent
                    ]
                },] }
    ];
    return SubNavHorizontalSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubNavVerticalSharedComponent = /** @class */ (function () {
    function SubNavVerticalSharedComponent() {
    }
    SubNavVerticalSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-sub-nav-vertical',
                    template: "<nav class=\"nav-vertical__nav\">\n    <a class=\"nav-vertical__link\" [routerLink]=\"link.url\" [routerLinkActive]=\"'-active'\" *ngFor=\"let link of links.data\">\n        <mlp-ng-icon name=\"arrow-right-1\" size=\"small\"></mlp-ng-icon>\n        <strong>{{ link.name }}</strong>\n    </a>\n</nav>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";@media (min-width:768px){:host{width:100%;display:block}}.nav-vertical__link{color:#188155;display:block;padding:.25rem 0}.nav-vertical__link:first-of-type{padding:0 0 .25rem}.nav-vertical__link:hover{color:#5da788}.nav-vertical__link.-active,.nav-vertical__link.-active:hover{color:#373737}"]
                }] }
    ];
    SubNavVerticalSharedComponent.propDecorators = {
        links: [{ type: Input }]
    };
    return SubNavVerticalSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubNavVerticalSharedModule = /** @class */ (function () {
    function SubNavVerticalSharedModule() {
    }
    SubNavVerticalSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SubNavVerticalSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        RouterModule.forChild([])
                    ],
                    exports: [
                        SubNavVerticalSharedComponent
                    ]
                },] }
    ];
    return SubNavVerticalSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TabsSharedComponent = /** @class */ (function () {
    function TabsSharedComponent() {
        this.changeTabManually = new EventEmitter();
        this.tabClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    TabsSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.numberTabs = this.tabs.tabs.length - 1;
        this.responsive = this.tabs.responsive;
        this.tabs.tabs.map(function (val, i) {
            if (val.active)
                _this.currentIndex = i;
        });
        this.changeTabManually.subscribe(function (newTab) {
            _this.changeTab(newTab);
        });
    };
    Object.defineProperty(TabsSharedComponent.prototype, "getResponive", {
        get: /**
         * @return {?}
         */
        function () {
            return (this.responsive) ? this.responsive : '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TabsSharedComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.showContent(true);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    TabsSharedComponent.prototype.changeTab = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.tabs.tabs[this.currentIndex].active = false;
        if (data === 'next') {
            this.showNextTab();
        }
        if (data === 'prev') {
            this.showPrevTab();
        }
        if (typeof data === 'number') {
            this.currentIndex = data;
        }
        this.tabs.tabs[this.currentIndex].active = true;
        this.tabClicked.emit(this.currentIndex);
        this.showContent();
    };
    /**
     * @return {?}
     */
    TabsSharedComponent.prototype.showNextTab = /**
     * @return {?}
     */
    function () {
        this.currentIndex = (this.currentIndex < this.numberTabs) ? this.currentIndex + 1 : 0;
    };
    /**
     * @return {?}
     */
    TabsSharedComponent.prototype.showPrevTab = /**
     * @return {?}
     */
    function () {
        this.currentIndex = (this.currentIndex !== 0) ? this.currentIndex - 1 : this.numberTabs;
    };
    /**
     * @param {?=} init
     * @return {?}
     */
    TabsSharedComponent.prototype.showContent = /**
     * @param {?=} init
     * @return {?}
     */
    function (init) {
        var _this = this;
        if (init === void 0) { init = false; }
        this.items.map(function (item, i) {
            if (init)
                item.nativeElement.classList.add('sg-tabs__content');
            if (_this.responsive)
                item.nativeElement.classList.add(_this.responsive);
            item.nativeElement.classList.remove('-active');
            if (_this.currentIndex === i)
                item.nativeElement.classList.add('-active');
        });
    };
    TabsSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-tabs',
                    template: "<ng-template [ngIf]=\"!tabs.nav\" [ngIfElse]=\"nav\">\n    <nav class=\"sg-tabs mb-5\">\n        <a href=\"\" (click)=\"changeTab('prev');false;\" class=\"sg-tabs__chevron\">\n            <mlp-ng-icon name=\"arrow-left\"></mlp-ng-icon>\n        </a>\n\n        <a href=\"\" (click)=\"changeTab(i);false\" class=\"sg-tabs__link text-center\" *ngFor=\"let tab of tabs.tabs; let i = index;\" [ngClass]=\"{'-active': tab.active}\">\n            <mlp-ng-icon class=\"sg-tabs__icon\" *ngIf=\"tab.icon\" [name]=\"tab.icon\"></mlp-ng-icon>\n            {{ tab.name }}\n        </a>\n\n        <a href=\"\" (click)=\"changeTab('next');false;\" class=\"sg-tabs__chevron -right\">\n            <mlp-ng-icon name=\"arrow-right\"></mlp-ng-icon>\n        </a>\n    </nav>\n</ng-template>\n\n<ng-template #nav>\n    <nav class=\"sg-tabs-nav mb-5\" [ngClass]=\"getResponive\">\n        <a href=\"\" (click)=\"changeTab(i);false\" class=\"sg-tabs-nav__link\" *ngFor=\"let tab of tabs.tabs; let i = index;\" [ngClass]=\"{'-active': tab.active}\">\n            {{ tab.name }}\n        </a>\n    </nav>\n</ng-template>\n\n<ng-content></ng-content>\n",
                    // tslint:disable-next-line:use-view-encapsulation
                    encapsulation: ViewEncapsulation.None,
                    styles: ["@charset \"UTF-8\";.sg-tabs{position:relative}.sg-tabs__chevron{color:#a3bc00;position:absolute;top:.75rem;left:0}.sg-tabs__chevron:focus{color:#778900}.sg-tabs__chevron.-right{left:auto;right:0}.sg-tabs__link{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);padding:.75rem .5rem;color:#1a1a1a;font-family:\"Frank New\",sans-serif;font-size:.875rem;position:relative;width:80%;margin:0 10%;white-space:nowrap;display:none;transition:background-color 250ms ease-in-out,box-shadow 250ms ease-in-out}@media (min-width:768px){.sg-tabs__chevron{display:none}.sg-tabs__chevron:hover{color:#778900}.sg-tabs__link{width:auto;margin:0;display:inline-block;padding:1rem 1.25rem;font-size:1rem}.sg-tabs__link:hover{color:#1a1a1a;background-color:#eceeef}.sg-tabs__link:hover:after{width:100%}}@media (min-width:992px){.sg-tabs__link{padding:1rem 2.5rem;font-size:1.125rem}}.sg-tabs__link:after{content:'';position:absolute;bottom:0;left:0;border-bottom:4px solid #a3bc00;width:0;transition:width 250ms ease-in-out}.sg-tabs__link:focus{color:#1a1a1a;background-color:#eceeef}.sg-tabs__link:focus:after{width:100%}.sg-tabs__link.-active{box-shadow:0 5px 21px -3px rgba(0,0,0,.55);display:block}.sg-tabs__link.-active:focus{background-color:transparent}.sg-tabs__link.-active:after{width:100%}@media (min-width:768px){.sg-tabs__link.-active{display:inline-block}.sg-tabs__link.-active:hover{background-color:transparent}.sg-tabs__icon{display:block}.sg-tabs__icon i{font-size:32px}.sg-tabs__content.md{display:block}}.sg-tabs__content{display:none}.sg-tabs__content.-active{display:block}.sg-tabs-nav{font-family:\"Frank New\",sans-serif;font-size:.875rem;position:relative}.sg-tabs-nav:after{position:absolute;left:0;bottom:-.45rem;content:'';height:7px;width:100%;background:linear-gradient(to top,transparent,#eceeef)}.sg-tabs-nav__link{color:#1a1a1a;display:inline-block;position:relative;font-weight:700;margin-right:.5rem;padding-bottom:.5rem}@media (min-width:768px){.sg-tabs-nav.md{display:none}.sg-tabs-nav__link:hover{color:#a3bc00}.sg-tabs-nav__link:hover:after{width:100%}}.sg-tabs-nav__link:after{content:'';position:absolute;bottom:0;left:0;border-bottom:4px solid #a3bc00;width:0;transition:width 250ms ease-in-out}.sg-tabs-nav__link.-active{color:#a3bc00}.sg-tabs-nav__link.-active:after{width:100%}"]
                }] }
    ];
    TabsSharedComponent.propDecorators = {
        tabs: [{ type: Input }],
        changeTabManually: [{ type: Input }],
        tabClicked: [{ type: Output }],
        items: [{ type: ContentChildren, args: ['tab',] }]
    };
    return TabsSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TabsSharedModule = /** @class */ (function () {
    function TabsSharedModule() {
    }
    TabsSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TabsSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        TabsSharedComponent
                    ]
                },] }
    ];
    return TabsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonExternalSharedComponent = /** @class */ (function () {
    function TextButtonExternalSharedComponent() {
        this.weight = 'normal';
    }
    /**
     * @return {?}
     */
    TextButtonExternalSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.attributes) {
            Object.keys(this.attributes).forEach(function (key) {
                _this.aTagElement.nativeElement.setAttribute(key, _this.attributes[key]);
            });
        }
    };
    TextButtonExternalSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-text-button-external',
                    template: "<a [href]=\"url\" class=\"text-button-default -{{weight}}\" #aTag target=\"_blank\">\n  <mlp-ng-icon name=\"{{iconName}}\" class=\"mr-1\" *ngIf=\"iconName\"></mlp-ng-icon> {{label}}\n</a>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.text-button-default{color:#2f285a;text-transform:uppercase;white-space:nowrap;font-family:\"Frank New\",sans-serif;font-weight:700;font-size:1.125rem}.text-button-default:hover{color:#6d688b}.text-button-default.-medium{font-size:1rem;font-weight:500!important}.text-button-default.-normal{font-size:1.125rem;font-weight:400!important}"]
                }] }
    ];
    TextButtonExternalSharedComponent.propDecorators = {
        attributes: [{ type: Input }],
        label: [{ type: Input }],
        url: [{ type: Input }],
        iconName: [{ type: Input }],
        weight: [{ type: Input }],
        aTagElement: [{ type: ViewChild, args: ['aTag',] }]
    };
    return TextButtonExternalSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextButtonExternalSharedModule = /** @class */ (function () {
    function TextButtonExternalSharedModule() {
    }
    TextButtonExternalSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TextButtonExternalSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        TextButtonExternalSharedComponent
                    ]
                },] }
    ];
    return TextButtonExternalSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextSliderSharedComponent = /** @class */ (function () {
    function TextSliderSharedComponent(dateFormatter) {
        this.dateFormatter = dateFormatter;
        this.config = {
            label: 'Needs a Label'
        };
        this.dateForDatepicker = new EventEmitter();
        this.toggleDtp = new EventEmitter();
        this.changeData = new EventEmitter();
        this.changeDateFromDatepicker = new EventEmitter();
    }
    /**
     * @return {?}
     */
    TextSliderSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dateForDatepicker.subscribe(function (date) {
            _this.date = _this.dateFormatter.parse(date);
        });
    };
    /**
     * @param {?} direction
     * @return {?}
     */
    TextSliderSharedComponent.prototype.change = /**
     * @param {?} direction
     * @return {?}
     */
    function (direction) {
        this.changeData.emit(direction);
    };
    /**
     * @return {?}
     */
    TextSliderSharedComponent.prototype.toggleDatepicker = /**
     * @return {?}
     */
    function () {
        this.toggleDtp.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TextSliderSharedComponent.prototype.onDateSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.date = event;
        this.changeDateFromDatepicker.emit(this.dateFormatter.format(event));
    };
    TextSliderSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-text-slider',
                    template: "<div class=\"clearfix\">\n    <button class=\"sg-text-slider__link\" role=\"button\" [disabled]=\"config?.sliderLeftDisabled\" (click)=\"change('prev');false;\">\n        <mlp-ng-icon name=\"arrow-left-1\"></mlp-ng-icon>\n    </button>\n\n    <div class=\"sg-text-slider__label-container\">\n        <span class=\"sg-text-slider__label\" [class.cursor]=\"config?.showDatepicker\" (click)=\"(config?.showDatepicker) ? toggleDatepicker() : false\">\n            {{ config.label }}\n        </span>\n        <mlp-ng-datepicker [toggle]=\"toggleDtp\" [date]=\"date\" [ngDatepickerConfig]=\"ngDatepickerConfig\" (chosenDate)=\"onDateSelect($event)\"></mlp-ng-datepicker>\n    </div>\n\n    <button class=\"sg-text-slider__link -right\" [disabled]=\"config?.sliderRightDisabled\" role=\"button\" (click)=\"change('next');false;\">\n        <mlp-ng-icon name=\"arrow-right-1\"></mlp-ng-icon>\n    </button>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{display:block}.sg-text-slider__link{width:50px;float:left;background-color:#f3f9d2;color:#1a1a1a;overflow:hidden;display:block;padding:.25rem 1rem;border:1px solid #dfdfdf;border-top-left-radius:5px;border-bottom-left-radius:5px;text-align:center;transition:background-color 250ms ease-in-out,color 250ms ease-in-out}.sg-text-slider__link.-right{border-radius:0 5px 5px 0}.sg-text-slider__link:hover{color:#a3bc00}.sg-text-slider__link:disabled{cursor:not-allowed;background-color:#eceeef;color:#636c72}.sg-text-slider__label-container{position:relative;float:left;width:calc(100% - 100px)}.sg-text-slider__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative;display:block;text-align:center;border-top:1px solid #dfdfdf;border-bottom:1px solid #dfdfdf;padding:.25rem .5rem}"]
                }] }
    ];
    /** @nocollapse */
    TextSliderSharedComponent.ctorParameters = function () { return [
        { type: NgbDateParserFormatter }
    ]; };
    TextSliderSharedComponent.propDecorators = {
        config: [{ type: Input }],
        dateForDatepicker: [{ type: Input }],
        ngDatepickerConfig: [{ type: Input }],
        changeData: [{ type: Output }],
        changeDateFromDatepicker: [{ type: Output }]
    };
    return TextSliderSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TextSliderSharedModule = /** @class */ (function () {
    function TextSliderSharedModule() {
    }
    TextSliderSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TextSliderSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        DatepickerSharedModule,
                        NgbDatepickerModule.forRoot(),
                        IconSharedModule
                    ],
                    exports: [
                        TextSliderSharedComponent
                    ]
                },] }
    ];
    return TextSliderSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TileSharedComponent = /** @class */ (function () {
    function TileSharedComponent() {
        this.active = false;
    }
    Object.defineProperty(TileSharedComponent.prototype, "faIcon", {
        get: /**
         * @return {?}
         */
        function () { return (this.active) ? 'check-1' : 'add'; },
        enumerable: true,
        configurable: true
    });
    TileSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-tile',
                    template: "<button type=\"button\" class=\"sg-tile cursor\" [ngClass]=\"class\" [class.sg-tile--active]=\"active\">\n    <mlp-ng-icon class=\"sg-tile__icon-action\" [ngClass]=\"{'-active': active}\" [name]=\"faIcon\" size=\"small\"></mlp-ng-icon>\n    <span class=\"sg-tile__text\"><ng-content></ng-content></span>\n</button>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-tile{display:inline-block;position:relative;text-align:center;font-family:\"Frank New\",sans-serif;font-size:.875rem;font-weight:500;padding:.75rem .25rem;border:1px solid #d6d5d5;transition:border 250ms ease-in-out,box-shadow 250ms ease-in-out,color 250ms ease-in-out,box-shadow 250ms ease-in-out;border-radius:.25rem}.sg-tile--active{background-color:#ccf5d7;border-color:#188155}.sg-tile:not(.sg-tile--active):hover{border-color:#188155;color:#188155}.sg-tile:not(.sg-tile--active):hover .sg-tile__icon-action{opacity:1;color:#188155}.sg-tile__text{margin-left:24px;margin-right:24px}.sg-tile__icon-action{position:absolute;top:4px;right:6px;color:#373737;opacity:0;transition:opacity 250ms ease-in-out}.sg-tile__icon-action.-active{opacity:1}.sg-tile:focus{outline:0}"]
                }] }
    ];
    TileSharedComponent.propDecorators = {
        active: [{ type: Input }],
        class: [{ type: Input }]
    };
    return TileSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TileSharedModule = /** @class */ (function () {
    function TileSharedModule() {
    }
    TileSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TileSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        TileSharedComponent
                    ]
                },] }
    ];
    return TileSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ModNgbTooltip = /** @class */ (function (_super) {
    __extends(ModNgbTooltip, _super);
    function ModNgbTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.body = (document) ? document.querySelector('body') : undefined;
        return _this;
    }
    /**
     * @return {?}
     */
    ModNgbTooltip.prototype.addClassToBody = /**
     * @return {?}
     */
    function () {
        // do my own stuff with tooltip here.
        if (this.body) {
            this.body.classList.add('sg-tooltip');
        }
    };
    /**
     * @return {?}
     */
    ModNgbTooltip.prototype.open = /**
     * @return {?}
     */
    function () {
        this.addClassToBody();
        _super.prototype.open.call(this);
    };
    return ModNgbTooltip;
}(NgbTooltip));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TooltipSharedModule = /** @class */ (function () {
    function TooltipSharedModule() {
    }
    TooltipSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ModNgbTooltip
                    ],
                    imports: [
                        CommonModule,
                        NgbTooltipModule
                    ],
                    providers: [
                        NgbTooltipConfig
                    ],
                    exports: [
                        ModNgbTooltip
                    ]
                },] }
    ];
    return TooltipSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var HeadlineSharedComponent = /** @class */ (function () {
    function HeadlineSharedComponent() {
        this.backgroundUrl = '/assets/img/background_image_football.jpg';
    }
    HeadlineSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-headline',
                    template: "<div class=\"sg-headline\" [style.background-image]=\"'url(' + backgroundUrl + ')'\">\n    <div class=\"sg-headline__shard\">\n        <div class=\"row sg-headline__shard__shade\">\n            <div class=\"col-sm-12 col-md-7 sg-headline__shard__shade__overlay\"></div>\n            <div class=\"d-none d-md-block col-md-3 col-xl-1 sg-headline__shard__shade__triangle d-sm-none\"></div>\n        </div>\n    </div>\n\n    <ng-content></ng-content>\n</div>\n",
                    styles: ["@charset \"UTF-8\";.sg-headline{height:240px;background-size:cover}@media (min-width:1200px){.sg-headline{height:283px}}.sg-headline__shard{position:absolute;width:100%;height:240px}@media (min-width:1200px){.sg-headline__shard{height:283px}}.sg-headline__shard__shade{margin:0;height:100%}.sg-headline__shard__shade__overlay{background-color:rgba(47,40,90,.7);height:100%}.sg-headline__shard__shade__triangle{width:100%;height:0;border-top:240px solid rgba(47,40,90,.7);border-right:139px solid transparent}@media (min-width:1200px){.sg-headline__shard__shade__triangle{width:100%;height:0;border-top:283px solid rgba(47,40,90,.7);border-right:163px solid transparent}}"]
                }] }
    ];
    HeadlineSharedComponent.propDecorators = {
        backgroundUrl: [{ type: Input }]
    };
    return HeadlineSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var HeadlineSharedModule = /** @class */ (function () {
    function HeadlineSharedModule() {
    }
    HeadlineSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        HeadlineSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        IconSharedModule
                    ],
                    exports: [
                        HeadlineSharedComponent
                    ]
                },] }
    ];
    return HeadlineSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$3 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return PasswordSharedComponent; }),
    multi: true
};
var PasswordSharedComponent = /** @class */ (function (_super) {
    __extends(PasswordSharedComponent, _super);
    function PasswordSharedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line:no-input-rename
        _this._value = '';
        _this.currentInputType = 'password';
        _this.onChange = function () { };
        _this.onTouched = function () { };
        return _this;
    }
    Object.defineProperty(PasswordSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    PasswordSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PasswordSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PasswordSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @return {?}
     */
    PasswordSharedComponent.prototype.togglePassword = /**
     * @return {?}
     */
    function () {
        this.currentInputType = this.currentInputType === 'password' ? 'text' : 'password';
    };
    PasswordSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-password',
                    template: "<mlp-ng-input\n    [inputId]=\"inputId\"\n    [inputName]=\"inputName\"\n    [inputType]=\"currentInputType\"\n    [inputStyle]=\"inputStyle\"\n    [inputDisabled]=\"inputDisabled\"\n    [placeholder]=\"placeholder\"\n    [icon]=\"icon\"\n    [iconSecondary]=\"currentInputType === 'password' ? 'custom-eye-closed' : 'custom-eye-open'\"\n    [loading]=\"loading\"\n    [input]=\"input\"\n    [errors]=\"errors\"\n    (blur)=\"blur.emit()\"\n    (focus)=\"focus.emit()\"\n    (secondaryButtonClick)=\"togglePassword()\"\n    [(ngModel)]=\"value\"\n></mlp-ng-input>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$3
                    ]
                }] }
    ];
    PasswordSharedComponent.propDecorators = {
        _value: [{ type: Input, args: ['value',] }]
    };
    return PasswordSharedComponent;
}(InputSharedComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PasswordSharedModule = /** @class */ (function () {
    function PasswordSharedModule() {
    }
    PasswordSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PasswordSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        IconSharedModule,
                        InputSharedModule
                    ],
                    exports: [
                        PasswordSharedComponent
                    ]
                },] }
    ];
    return PasswordSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var CC_CUSTOM_INPUT_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(function () { return CreditCardSharedComponent; }),
    multi: true
};
var CreditCardSharedComponent = /** @class */ (function (_super) {
    __extends(CreditCardSharedComponent, _super);
    function CreditCardSharedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cardIcon = 'custom-credit-card';
        return _this;
    }
    Object.defineProperty(CreditCardSharedComponent.prototype, "value", {
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.pickCardIcon(val);
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    CreditCardSharedComponent.prototype.formatValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value) {
            /** @type {?} */
            var number$$1 = parseInt(value.replace(/ /g, ''));
            if (isNaN(number$$1)) {
                return '';
            }
            else {
                // limit to 16 characters and add space every 4 characters
                return number$$1.toString().substr(0, 16).match(/.{1,4}/g).join(' ');
            }
        }
    };
    /**
     * @param {?} number
     * @return {?}
     */
    CreditCardSharedComponent.prototype.pickCardIcon = /**
     * @param {?} number
     * @return {?}
     */
    function (number$$1) {
        /** @type {?} */
        var valid = number(number$$1);
        if (valid.card) {
            switch (valid.card.type) {
                case 'visa':
                    this.icon = 'custom-cc-visa';
                    break;
                case 'mastercard':
                    this.icon = 'custom-cc-mastercard';
                    break;
                case 'american-express':
                    this.icon = 'custom-cc-amex';
                    break;
                default: this.icon = this.cardIcon;
            }
        }
        else {
            this.icon = this.cardIcon;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    CreditCardSharedComponent.prototype.updateValue = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var target = /** @type {?} */ (event.target);
        /** @type {?} */
        var value = this.formatValue(target.value);
        if (value !== undefined) {
            target.value = value;
            this.value = value;
        }
    };
    /**
     * @return {?}
     */
    CreditCardSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.icon) {
            this.cardIcon = this.icon;
        }
        this.inputComponent.updateValue = this.updateValue.bind(this);
    };
    CreditCardSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-credit-card',
                    template: "<mlp-ng-input\n    inputType=\"tel\"\n    [icon]=\"icon\"\n    [iconSecondary]=\"iconSecondary\"\n    [inputId]=\"inputId\"\n    [inputName]=\"inputName\"\n    [inputStyle]=\"inputStyle\"\n    [inputDisabled]=\"inputDisabled\"\n    [placeholder]=\"placeholder\"\n    [loading]=\"loading\"\n    [input]=\"input\"\n    [errors]=\"errors\"\n    [value]=\"_value\"\n    (blur)=\"blur.emit()\"\n    (focus)=\"focus.emit()\"\n    (secondaryButtonClick)=\"secondaryButtonClick.emit()\"\n></mlp-ng-input>",
                    providers: [
                        CC_CUSTOM_INPUT_ACCESSOR
                    ]
                }] }
    ];
    CreditCardSharedComponent.propDecorators = {
        inputComponent: [{ type: ViewChild, args: [InputSharedComponent,] }]
    };
    return CreditCardSharedComponent;
}(InputSharedComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CreditCardSharedModule = /** @class */ (function () {
    function CreditCardSharedModule() {
    }
    CreditCardSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CreditCardSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        InputSharedModule
                    ],
                    exports: [
                        CreditCardSharedComponent
                    ]
                },] }
    ];
    return CreditCardSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CreditCardListElementSharedComponent = /** @class */ (function () {
    function CreditCardListElementSharedComponent() {
        this.selectable = true;
        this.path = '/assets/cc-logos/';
        this.add = new EventEmitter();
        this.select = new EventEmitter();
        this.remove = new EventEmitter();
    }
    /**
     * @return {?}
     */
    CreditCardListElementSharedComponent.prototype.cardLogo = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var icon = 'generic';
        if (this.card && this.card.attributes && this.card.attributes.brand) {
            if (this.card.attributes.brand === 'American Express') {
                icon = 'amex';
            }
            else {
                icon = this.card.attributes.brand.toLowerCase().split(/\s/g)[0];
            }
        }
        return "" + this.path + icon + ".svg";
    };
    /**
     * @return {?}
     */
    CreditCardListElementSharedComponent.prototype.expiry = /**
     * @return {?}
     */
    function () {
        return [
            this.card.attributes.exp_month.toString().padStart(2, '0'),
            // pad expiry month to 2 characters
            this.card.attributes.exp_year.toString().substr(-2) // get only last 2 characters of expiry year
        ].join('/'); // join with slash
    };
    CreditCardListElementSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-credit-card-list-element',
                    template: "<div class=\"sg-bordered-input credit-card-list-element container w-100 p-2\" [class.sg-bordered-input--selected]=\"!!selected || !!edit\">\n    <div class=\"row align-items-center credit-card-list-element__selector\" *ngIf=\"!card\" (click)=\"this.add.emit()\">\n        <div class=\"col pl-4 pr-0 pt-1 credit-card-list-element__mw-88px\">\n            <mlp-ng-icon name=\"custom-credit-card\" size=\"medium\"></mlp-ng-icon>\n        </div>\n\n        <div class=\"col col-lg-3 px-0\">\n            <h6 class=\"sg-heading__h6 mb-0\">Add a new card</h6>\n        </div>\n\n        <div class=\"col-12 col-lg\">\n            <p class=\"m-0 ml-2 ml-lg-0 credit-card-list-element--color-sgInputPlaceholder\">Playfinder accepts all major credit and debit cards</p>\n        </div>\n    </div>\n\n    <div *ngIf=\"card\" class=\"row px-2 align-items-center credit-card-list-element__selector\" (click)=\"this.select.emit(this.card.id)\">\n        <div *ngIf=\"selectable\" class=\"col credit-card-list-element__mw-32px\">\n            <div class=\"credit-card-list-element__indicator\" [class.credit-card-list-element__indicator--selected]=\"!!selected\">\n                <div class=\"credit-card-list-element__inner\"></div>\n            </div>\n        </div>\n\n        <div class=\"col credit-card-list-element__mw-88px\">\n            <img [src]=\"cardLogo()\" [alt]=\"card.attributes?.brand\" class=\"w-100\" />\n        </div>\n\n        <div class=\"col credit-card-list-element__lg-mw-30\">\n            <p class=\"credit-card-list-element__brandname mb-0 text-uppercase\">{{card.attributes?.brand}}</p>\n            <p class=\"m-0 p-0 credit-card-list-element--color-sgInputPlaceholder\">Ending in {{card.attributes?.last4}}</p>\n        </div>\n\n        <div class=\"col-12 col-lg pl-lg-0\" [class.credit-card-list-element__indent-left]=\"selectable\">\n            <p class=\"credit-card-list-element__brandname mb-0 mt-3 mt-lg-0\">{{card.attributes?.name}}</p>\n            <p class=\"m-0 p-0 credit-card-list-element--color-sgInputPlaceholder\">Expiry Date: {{expiry()}}</p>\n        </div>\n    </div>\n\n    <div class=\"col text-right mt-2 mt-lg-0\" *ngIf=\"!!edit && card\">\n        <a (click)=\"this.remove.emit(this.card.id)\" class=\"text-uppercase credit-card-list-element__remove\">Remove card</a>\n    </div>\n</div>\n",
                    styles: ["@charset \"UTF-8\";.sg-bordered-input{border-radius:.25rem;border:2px solid #d6d5d5}.sg-bordered-input--selected{border-color:#56e07b}:host .credit-card-list-element__mw-32px{max-width:32px}:host .credit-card-list-element__indent-left{padding-left:44px}:host .credit-card-list-element__mw-88px{max-width:88px}@media (min-width:992px){:host .credit-card-list-element__lg-mw-30{max-width:30%}}:host .credit-card-list-element__selector{cursor:pointer}:host .credit-card-list-element__remove{cursor:pointer;color:#c80a0a;font-size:.875rem;font-weight:500}:host .credit-card-list-element__remove:hover{color:#c80a0a}:host .credit-card-list-element--color-sgInputPlaceholder{color:#6c757d;font-size:.875rem}:host .credit-card-list-element__brandname{font-size:1rem;font-weight:700}:host .credit-card-list-element__indicator{border-radius:50%;width:1rem;height:1rem;border:2px solid #d6d5d5}:host .credit-card-list-element__indicator--selected{border-color:#373737}:host .credit-card-list-element__indicator--selected .credit-card-list-element__inner{background-color:#56e07b}:host .credit-card-list-element__inner{border-radius:50%;margin-top:2px;margin-left:2px;width:.5rem;height:.5rem}"]
                }] }
    ];
    CreditCardListElementSharedComponent.propDecorators = {
        card: [{ type: Input }],
        edit: [{ type: Input }],
        selected: [{ type: Input }],
        selectable: [{ type: Input }],
        path: [{ type: Input }],
        add: [{ type: Output }],
        select: [{ type: Output }],
        remove: [{ type: Output }]
    };
    return CreditCardListElementSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CreditCardListElementSharedModule = /** @class */ (function () {
    function CreditCardListElementSharedModule() {
    }
    CreditCardListElementSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CreditCardListElementSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        CheckBoxSharedModule,
                        IconSharedModule
                    ],
                    exports: [
                        CreditCardListElementSharedComponent
                    ]
                },] }
    ];
    return CreditCardListElementSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var EXPIRY_CUSTOM_INPUT_ACCESSOR$1 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(function () { return ExpirySharedComponent; }),
    multi: true
};
var ExpirySharedComponent = /** @class */ (function (_super) {
    __extends(ExpirySharedComponent, _super);
    function ExpirySharedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: no-input-rename
        _this._value = '';
        _this.inputStyle = 'primary';
        _this.focused = false;
        return _this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ExpirySharedComponent.prototype.formatValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value) {
            /** @type {?} */
            var number$$1 = value.replace(/\s|\/|\D+/g, '');
            if (number$$1) {
                /** @type {?} */
                var formatted = number$$1.substr(0, 4).match(/.{1,2}/g).join('/');
                // append slash after entering 2 characters
                return value.length === 2 ? formatted + '/' : formatted;
            }
            else {
                return '';
            }
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ExpirySharedComponent.prototype.updateValue = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var target = /** @type {?} */ (event.target);
        /** @type {?} */
        var value = this.formatValue(target.value);
        if (value !== undefined) {
            target.value = value;
            this.value = value;
        }
    };
    /**
     * @return {?}
     */
    ExpirySharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.inputComponent.updateValue = this.updateValue.bind(this);
    };
    ExpirySharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-expiry',
                    template: "<div class=\"input-group sg-input-group\"\n     [class.sg-input-group__secondary]=\"inputStyle == 'secondary'\"\n     [class.sg-input-group__error]=\"errors.length > 0\"\n     [class.sg-input-group__focus]=\"focused\">\n    <mlp-ng-input-atom\n        class=\"w-100\"\n        inputType=\"tel\"\n        [noBorder]=\"true\"\n        [placeholder]=\"placeholder\"\n        [inputId]=\"inputId\"\n        [inputName]=\"inputName\"\n        [inputDisabled]=\"inputDisabled\"\n        (focus)=\"focused = true; focus.emit($event)\"\n        (blur)=\"focused = false; blur.emit($event)\"\n        [(ngModel)]=\"value\"\n    ></mlp-ng-input-atom>\n</div>\n\n<small class=\"form-text sg-color__danger\" *ngFor=\"let error of errors\">{{ error.title }}</small>",
                    providers: [
                        EXPIRY_CUSTOM_INPUT_ACCESSOR$1
                    ],
                    styles: ["@charset \"UTF-8\";.sg-input-group{border:1px solid #d6d5d5;border-radius:.25rem;transition:background-color 250ms ease-in-out,color 250ms ease-in-out,border 250ms ease-in-out}.sg-input-group__input-molecule{color:#373737;height:calc(1.5em + .75rem + 2px + 8px);box-shadow:none;border:none;padding:.275rem .75rem}.sg-input-group__input-molecule:focus{background-color:#f4f4f7}.sg-input-group__prepend__icon{background-color:#fff;color:#6c757d;width:44px}.sg-input-group__prepend__divider{background-color:#fff}.sg-input-group__prepend__divider__line{height:24px;width:2px;background-color:#d6d5d5}.sg-input-group__focus{border-color:#2f285a}.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group__prepend__divider__line{background-color:#2f285a}.sg-input-group__focus .sg-input-group-append-button-icon{background-color:#f4f4f7}.sg-input-group__focus .sg-input-group-append-button-icon:hover{background-color:#f4f4f7!important}.sg-input-group__icon .sg-input-group__input-molecule{border-left:0}.sg-input-group__error{border-color:#c80a0a}.sg-input-group__secondary{box-shadow:0 2px 6px 0 rgba(0,0,0,.25)}.sg-input-group__secondary .sg-input-group__input-molecule{background-clip:unset;-webkit-appearance:none}.sg-input-group__secondary .sg-input-group__input-molecule:focus,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__divider,.sg-input-group__secondary.sg-input-group__focus .sg-input-group__prepend__icon{background-color:#fff}.sg-input-group-append-button-icon{transition:none;border-top-left-radius:0;border-bottom-left-radius:0;padding-left:.5rem;padding-right:.5rem;background-color:#fff;color:#6c757d!important}.sg-input-group-append-button-icon:hover{color:#373737!important;background-color:#fff!important}.sg-input-group-append-button-icon__loading{padding-left:.1875rem;padding-right:.1875rem}"]
                }] }
    ];
    ExpirySharedComponent.propDecorators = {
        inputComponent: [{ type: ViewChild, args: [InputAtomSharedComponent,] }],
        _value: [{ type: Input, args: ['value',] }],
        inputStyle: [{ type: Input }]
    };
    return ExpirySharedComponent;
}(InputAtomSharedComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ExpirySharedModule = /** @class */ (function () {
    function ExpirySharedModule() {
    }
    ExpirySharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ExpirySharedComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        IconSharedModule,
                        InputAtomSharedModule
                    ],
                    exports: [
                        ExpirySharedComponent
                    ]
                },] }
    ];
    return ExpirySharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PromptSharedComponent = /** @class */ (function () {
    function PromptSharedComponent(modalService) {
        this.modalService = modalService;
    }
    PromptSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-prompt',
                    template: "<ng-template #template>\n    <mlp-ng-modal>\n        <div header class=\"sg-heading__h5\">{{ title }}</div>\n\n        <div body class=\"sg-mw_300 mx-auto text-center\">\n            <p class=\"mb-3\">{{ description }}</p>\n\n            <mlp-ng-button\n                (click)=\"modalService.close()\"\n                label=\"Yes\"\n            ></mlp-ng-button>\n\n            <mlp-ng-button\n                (click)=\"modalService.dismiss()\"\n                label=\"No\"\n            ></mlp-ng-button>\n        </div>\n    </mlp-ng-modal>\n</ng-template>\n"
                }] }
    ];
    /** @nocollapse */
    PromptSharedComponent.ctorParameters = function () { return [
        { type: ModalService }
    ]; };
    PromptSharedComponent.propDecorators = {
        template: [{ type: ViewChild, args: [TemplateRef,] }],
        title: [{ type: Input }],
        description: [{ type: Input }]
    };
    return PromptSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PromptService = /** @class */ (function () {
    function PromptService(modalService) {
        this.modalService = modalService;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    PromptService.prototype.open = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        config.component.title = config.title;
        config.component.description = config.description;
        return this.modalService.open(config.component.template).result;
    };
    PromptService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PromptService.ctorParameters = function () { return [
        { type: ModalService }
    ]; };
    return PromptService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PromptSharedModule = /** @class */ (function () {
    function PromptSharedModule() {
    }
    PromptSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PromptSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ButtonSharedModule,
                        ModalSharedModule
                    ],
                    providers: [
                        PromptService
                    ],
                    exports: [
                        PromptSharedComponent
                    ]
                },] }
    ];
    return PromptSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AppBannerSharedComponent = /** @class */ (function () {
    function AppBannerSharedComponent() {
        this.backgroundImage = '/assets/img/recreate-background-banner-app.jpg';
        this.appPreviewImage = '/assets/img/phone-screens.png';
        this.downloadAndroid = 'https://play.google.com/store/apps/details?id=com.mylocalpitch';
        this.downloadIOS = 'https://itunes.apple.com/gb/app/mylocalpitch/id1020056658?pt=117881873&amp;mt=8';
        this.downloadAndroidImg = '/assets/banner/google-play-badge.svg';
        this.downloadIOSImg = '/assets/banner/download-app.svg';
        this.downloadAndroidImgAlt = 'andorid';
        this.downloadIOSImgAlt = 'ios';
        this.appPreviewImageAlt = 'playfinder app in phones';
    }
    AppBannerSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-app-banner',
                    template: "<div class=\"sg-app-banner position-relative sg-py-4 lazyload\" [attr.data-bgset]=\"backgroundImage\">\n    <div class=\"sg-app-banner-container\">\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"col-12 col-md-6 sg-color__white sg-pt-2\">\n                    <div class=\"sg-heading__h2 text-uppercase text-center text-md-left\">{{appBanner.heading}}</div>\n                    <div class=\"sg-heading__h1 text-uppercase text-center text-md-left sg-mb-1\">{{appBanner.subheading}}</div>\n\n                    <div [class.mb-2]=\"!last\" *ngFor=\"let item of appBanner.list; let last = last;\">\n                        <mlp-ng-icon name=\"check-1\" class=\"sg-color -secondary\"></mlp-ng-icon>\n                        {{item}}\n                    </div>\n\n                    <div class=\"sg-mb-1 sg-mb-lg-2\"></div>\n\n                    <div class=\"d-flex flex-column flex-lg-row align-items-xs-center\">\n                        <a target=\"_blank\" [href]=\"downloadIOS\">\n                            <img class=\"mb-2 mr-md-2 lazyload\" height=\"48\" [alt]=\"downloadIOSImgAlt\" [attr.data-src]=\"downloadIOSImg\">\n                        </a>\n\n                        <a target=\"_blank\" [href]=\"downloadAndroid\">\n                            <img class=\"mb-2 lazyload\" height=\"48\" [alt]=\"downloadAndroidImgAlt\" [attr.data-src]=\"downloadAndroidImg\">\n                        </a>\n                    </div>\n                </div>\n                <div class=\"col-12 col-md-6 triangle sg-pt-1 sg-pt-md-2 pr-lg-0 sg-pb-2 pb-md-0\">\n                    <div class=\"d-flex justify-content-center justify-content-md--end\">\n                        <img [alt]=\"appPreviewImageAlt\" class=\"app-placeholder lazyload\" [attr.data-src]=\"appPreviewImage\" imgService=\"w=250\" />\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-app-banner{background-position:top left,top left;background-size:cover}@media (max-width:767.98px){.sg-app-banner .triangle{background:rgba(47,40,90,.7)}}.sg-app-banner .app-placeholder{max-height:420px;max-width:750px}@media (max-width:991.98px){.sg-app-banner .app-placeholder{max-width:100%}}"]
                }] }
    ];
    AppBannerSharedComponent.propDecorators = {
        appBanner: [{ type: Input }],
        backgroundImage: [{ type: Input }],
        appPreviewImage: [{ type: Input }],
        downloadAndroid: [{ type: Input }],
        downloadIOS: [{ type: Input }],
        downloadAndroidImg: [{ type: Input }],
        downloadIOSImg: [{ type: Input }],
        downloadAndroidImgAlt: [{ type: Input }],
        downloadIOSImgAlt: [{ type: Input }],
        appPreviewImageAlt: [{ type: Input }]
    };
    return AppBannerSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Add parameters to srcset to support serving images through imgix.com domain.
 * Some default values are based on imgix.com documentation
 *
 * __Usage :__
 *   <img src="https://domain.com/any.png" imgService="w=100">
 *
 * __Example :__
 *   <img src="https://domain.com/any.png" srcset="https://domain.com/any.png?w=100&dpr=2 2x ..."></div>
 *
 */
var ImgServiceDirective = /** @class */ (function () {
    function ImgServiceDirective(elementRef) {
        this.elementRef = elementRef;
        this.defaultParams = 'auto=format,compress';
    }
    /**
     * @return {?}
     */
    ImgServiceDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.applyChanges(this.elementRef.nativeElement.src);
    };
    /**
     * @param {?} src
     * @return {?}
     */
    ImgServiceDirective.prototype.applyChanges = /**
     * @param {?} src
     * @return {?}
     */
    function (src) {
        if (src && src.substr(-1) !== '/') {
            /** @type {?} */
            var params = this.params ? "?" + this.params + "&" : '?';
            /** @type {?} */
            var srcParams = "" + src + params + this.defaultParams;
            this.elementRef.nativeElement.src = "" + srcParams;
            this.elementRef.nativeElement.srcset = srcParams + "&dpr=1 1x, " + srcParams + "&dpr=2 2x, " + srcParams + "&dpr=3 3x";
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ImgServiceDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.applyChanges(this.imgServiceBinding);
    };
    ImgServiceDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[imgService]'
                },] }
    ];
    /** @nocollapse */
    ImgServiceDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    ImgServiceDirective.propDecorators = {
        params: [{ type: Input, args: ['imgService',] }],
        imgServiceBinding: [{ type: Input }]
    };
    return ImgServiceDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The ImgServiceDirectiveModule module
 */
var ImgServiceDirectiveModule = /** @class */ (function () {
    function ImgServiceDirectiveModule() {
    }
    ImgServiceDirectiveModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ImgServiceDirective
                    ],
                    imports: [],
                    exports: [
                        ImgServiceDirective
                    ]
                },] }
    ];
    return ImgServiceDirectiveModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AppBannerSharedModule = /** @class */ (function () {
    function AppBannerSharedModule() {
    }
    AppBannerSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AppBannerSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        ImgServiceDirectiveModule
                    ],
                    exports: [
                        AppBannerSharedComponent
                    ]
                },] }
    ];
    return AppBannerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function _window() {
    // return the global native browser window object
    return window;
}
/**
 * This service is a window service
 *
 * \@example
 * WindowRefService.nativeWindow;
 *
 */
var WindowRefService = /** @class */ (function () {
    function WindowRefService() {
    }
    Object.defineProperty(WindowRefService.prototype, "nativeWindow", {
        get: /**
         * @return {?}
         */
        function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
    WindowRefService.decorators = [
        { type: Injectable }
    ];
    return WindowRefService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$1 = momentNs;
/** @type {?} */
var TIMEZONE = 'Europe/London';
var CalendarSlideService = /** @class */ (function () {
    function CalendarSlideService(windowRef, document) {
        var _this = this;
        this.windowRef = windowRef;
        this.document = document;
        this.holder = 0;
        this.dragActive = false;
        this.click = new Subject();
        this.click$ = this.click;
        this.meridiem = new Subject();
        this.meridiem$ = this.meridiem;
        this.disabled = false;
        this.arrows$ = new BehaviorSubject(undefined);
        this.indexFromStart = 0;
        this.indexForNoon = 0;
        this.columns = 0;
        this.slotsWithDataWidth = 0;
        this.meridiemChosen = moment$1().tz(TIMEZONE).format('A');
        fromEvent(this.windowRef.nativeWindow, 'resize')
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(function (_) {
            _this.resetCalendar();
        });
    }
    Object.defineProperty(CalendarSlideService.prototype, "constrain", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var calenderCol = this.document.querySelector('.js-sg-calendar__col--overflow-hidden');
            return (calenderCol) ? Math.round(calenderCol.getBoundingClientRect().width) : 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} resetStyle
     * @param {?=} columns
     * @return {?}
     */
    CalendarSlideService.prototype.resetCalendar = /**
     * @param {?=} resetStyle
     * @param {?=} columns
     * @return {?}
     */
    function (resetStyle, columns) {
        var _this = this;
        if (resetStyle === void 0) { resetStyle = true; }
        if (typeof columns === 'number')
            this.setColumns(columns);
        if (resetStyle)
            this.drag.nativeElement.removeAttribute('style');
        setTimeout(function (_) {
            _this.disabled = false;
            _this.setConfig(_this.drag, resetStyle);
        }, 0);
    };
    /**
     * @return {?}
     */
    CalendarSlideService.prototype.setClick = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.setConfig(undefined);
        this.click$.pipe(map(function (data) { return _this.setStep(data); }))
            .subscribe(function (_) {
            _this.setTransform(_this.holder);
        });
    };
    /**
     * @param {?} data
     * @return {?}
     */
    CalendarSlideService.prototype.meridiemChange = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.meridiemChosen = data;
        if (data === 'AM')
            this.setTransform(this.setOffset(0));
        if (data === 'PM')
            this.setTransform(this.setOffset(this.indexForNoon));
    };
    /**
     * @param {?=} drag
     * @param {?=} columns
     * @return {?}
     */
    CalendarSlideService.prototype.setDrag = /**
     * @param {?=} drag
     * @param {?=} columns
     * @return {?}
     */
    function (drag, columns) {
        var _this = this;
        this.setColumns(columns);
        this.setConfig(drag);
        /** @type {?} */
        var mouseup$ = fromEvent(this.document, 'mouseup');
        /** @type {?} */
        var mousedown$ = fromEvent(drag.nativeElement, 'mousedown');
        /** @type {?} */
        var mousemove$ = fromEvent(this.document, 'mousemove');
        /** @type {?} */
        var touchstart$ = fromEvent(drag.nativeElement, 'touchstart');
        /** @type {?} */
        var touchend$ = fromEvent(this.document, 'touchend');
        /** @type {?} */
        var touchmove$ = fromEvent(this.document, 'touchmove');
        /** @type {?} */
        var mousedrag$ = mousedown$.pipe(filter(function (data) { return !_this.disabled; }), tap(function (md) {
            md.preventDefault();
            // tslint:disable-next-line:max-line-length
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/pageYOffset || https://developer.mozilla.org/it/docs/Web/API/Window/scrollX
            // tslint:disable-next-line:max-line-length
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/pageYOffset || https://developer.mozilla.org/it/docs/Web/API/Window/scrollX
            _this.startX = md.clientX + _this.windowRef.nativeWindow.pageXOffset;
            _this.startLeft = _this.holder || 0;
        }), mergeMap(function (data) {
            return mousemove$.pipe(map(function (mm) {
                mm.preventDefault();
                return _this.startLeft + mm.clientX - _this.startX;
            }), takeUntil(mouseup$));
        }));
        /** @type {?} */
        var touchdrag$ = touchstart$
            .pipe(filter(function (data) { return !_this.disabled; }), tap(function (ts) {
            ts.preventDefault();
            // tslint:disable-next-line:max-line-length
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/pageYOffset || https://developer.mozilla.org/it/docs/Web/API/Window/scrollX
            // tslint:disable-next-line:max-line-length
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/pageYOffset || https://developer.mozilla.org/it/docs/Web/API/Window/scrollX
            _this.startX = ts.touches[0].clientX + _this.windowRef.nativeWindow.pageXOffset;
            _this.startLeft = _this.holder || 0;
        }), mergeMap(function (data) {
            return touchmove$
                .pipe(map(function (tm) {
                tm.preventDefault();
                return _this.startLeft + tm.touches[0].clientX - _this.startX;
            }), takeUntil(touchend$));
        }));
        /** @type {?} */
        var mouseTouch$ = merge(mousedrag$, touchdrag$);
        mouseTouch$.pipe(map(function (data) {
            if (data > 0)
                data = 0;
            if (_this.end >= data)
                data = _this.end;
            _this.holder = data;
            return data;
        }), tap(function (_) { return _this.configArrows; }))
            .subscribe(function (pos) {
            _this.setTransform(pos);
        });
    };
    /**
     * @param {?=} columns
     * @return {?}
     */
    CalendarSlideService.prototype.setColumns = /**
     * @param {?=} columns
     * @return {?}
     */
    function (columns) {
        if (typeof columns === 'number')
            this.columns = columns;
    };
    /**
     * @return {?}
     */
    CalendarSlideService.prototype.getSlotWidth = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var oneSlot = this.slots[0];
        /** @type {?} */
        var styles = getComputedStyle(oneSlot);
        /** @type {?} */
        var margin = parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
        return oneSlot.getBoundingClientRect().width + margin || 0;
    };
    /**
     * @param {?} drag
     * @param {?=} setOffset
     * @return {?}
     */
    CalendarSlideService.prototype.setConfig = /**
     * @param {?} drag
     * @param {?=} setOffset
     * @return {?}
     */
    function (drag, setOffset) {
        if (setOffset === void 0) { setOffset = true; }
        if (drag) {
            this.drag = drag;
            this.slots = drag.nativeElement.querySelectorAll('.js-sg-calendar__row .js-sg-calendar__slot');
            this.slotWidth = this.getSlotWidth();
            this.slotsWithDataWidth = this.slotWidth * this.columns + 1;
            this.width = this.slotWidth * this.slots.length;
            this.end = this.constrain - this.slotWidth * this.columns + 1;
            this.drag.nativeElement.style.width = this.width + "px";
            this.configArrows(this.setOffset());
            if (setOffset)
                this.setTransform(this.setOffset());
            if (this.constrain > this.width || this.constrain > this.slotsWithDataWidth)
                this.disabled = true;
        }
    };
    /**
     * @param {?=} index
     * @return {?}
     */
    CalendarSlideService.prototype.setOffset = /**
     * @param {?=} index
     * @return {?}
     */
    function (index) {
        if (index === void 0) { index = this.indexFromStart; }
        /** @type {?} */
        var offsetX = (this.slotWidth * index === 0 || this.constrain > this.slotsWithDataWidth) ? 0 : -(this.slotWidth * index);
        if (this.meridiemChosen === 'PM' && this.indexForNoon > 0) {
            if (offsetX < this.end) {
                offsetX = this.end;
            }
        }
        if (this.width > this.end) {
            if (offsetX < this.end) {
                this.holder = 0;
                return 0;
            }
            this.holder = offsetX;
            return offsetX;
        }
    };
    /**
     * @param {?} pos
     * @return {?}
     */
    CalendarSlideService.prototype.configArrows = /**
     * @param {?} pos
     * @return {?}
     */
    function (pos) {
        if (this.width <= this.constrain)
            this.arrows$.next({ left: false, right: false });
        if (pos > this.end && this.width > this.constrain)
            this.arrows$.next({ left: true, right: true });
        if (pos <= this.end && this.width > this.constrain)
            this.arrows$.next({ left: true, right: false });
        if (pos === 0 && this.width > this.constrain)
            this.arrows$.next({ left: false, right: true });
        if (this.constrain > this.slotsWithDataWidth)
            this.arrows$.next({ left: false, right: false });
    };
    /**
     * @param {?} pos
     * @return {?}
     */
    CalendarSlideService.prototype.setTransform = /**
     * @param {?} pos
     * @return {?}
     */
    function (pos) {
        this.configArrows(pos);
        this.drag.nativeElement.style.transform = "translateX(" + pos + "px)";
        this.selectMeridiem();
    };
    /**
     * @return {?}
     */
    CalendarSlideService.prototype.selectMeridiem = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var noon = -this.slotWidth * this.indexForNoon;
        if (this.columns) {
            if (noon < this.holder && !this.disabled) {
                this.meridiem.next('AM');
            }
            if (noon >= this.holder && !this.disabled) {
                this.meridiem.next('PM');
            }
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    CalendarSlideService.prototype.setStep = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var futureResult;
        if (data === 'right' && !this.disabled) {
            futureResult = this.holder - this.slotWidth;
            this.holder = (futureResult > this.end) ? futureResult : this.end;
        }
        if (data === 'left' && !this.disabled) {
            futureResult = this.holder + this.slotWidth;
            this.holder = (futureResult < 0) ? futureResult : 0;
        }
    };
    CalendarSlideService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CalendarSlideService.ctorParameters = function () { return [
        { type: WindowRefService },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    return CalendarSlideService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$2 = momentNs;
/** @type {?} */
var TIMEZONE$1 = 'Europe/London';
var CalendarDataService = /** @class */ (function () {
    function CalendarDataService(calSlideService) {
        this.calSlideService = calSlideService;
        this.meridiem = moment$2().tz(TIMEZONE$1).format('A');
    }
    /**
     * @param {?} timeRange
     * @return {?}
     */
    CalendarDataService.prototype.getIndexForTimes = /**
     * @param {?} timeRange
     * @return {?}
     */
    function (timeRange) {
        var _this = this;
        /** @type {?} */
        var nowHour = moment$2().tz(TIMEZONE$1).format('HH:mm').substring(0, 2);
        timeRange.map(function (time, i) {
            /** @type {?} */
            var timeMod = time.substring(0, 2);
            if (timeMod >= '12' && _this.calSlideService.indexForNoon === 0)
                _this.calSlideService.indexForNoon = i;
            if (timeMod === nowHour && _this.calSlideService.indexFromStart === 0 ||
                timeMod > nowHour && _this.calSlideService.indexFromStart === 0) {
                _this.calSlideService.indexFromStart = i;
            }
        });
    };
    CalendarDataService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CalendarDataService.ctorParameters = function () { return [
        { type: CalendarSlideService }
    ]; };
    return CalendarDataService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CalendarEventService = /** @class */ (function () {
    function CalendarEventService() {
    }
    /**
     * @param {?} direction
     * @param {?} start
     * @return {?}
     */
    CalendarEventService.prototype.updateDates = /**
     * @param {?} direction
     * @param {?} start
     * @return {?}
     */
    function (direction, start) {
        /** @type {?} */
        var startDate = DateTime.fromISO(start);
        /** @type {?} */
        var days = 7;
        if (direction === 'next') {
            return this.createDatesObject(this.plusDays(startDate, days), this.plusDays(startDate, days + (days - 1)));
        }
        if (direction === 'prev') {
            return this.createDatesObject(this.minusDays(startDate, days), this.minusDays(startDate, 1));
        }
        if (direction === 'fromDatepicker') {
            return this.createDatesObject(startDate.toFormat('yyyy-LL-dd'), this.plusDays(startDate, days));
        }
    };
    /**
     * @param {?} startDate
     * @param {?} days
     * @return {?}
     */
    CalendarEventService.prototype.plusDays = /**
     * @param {?} startDate
     * @param {?} days
     * @return {?}
     */
    function (startDate, days) {
        return startDate.plus({ days: days }).toFormat('yyyy-LL-dd');
    };
    /**
     * @param {?} startDate
     * @param {?} days
     * @return {?}
     */
    CalendarEventService.prototype.minusDays = /**
     * @param {?} startDate
     * @param {?} days
     * @return {?}
     */
    function (startDate, days) {
        return startDate.minus({ days: days }).toFormat('yyyy-LL-dd');
    };
    /**
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    CalendarEventService.prototype.createDatesObject = /**
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    function (start, end) {
        return {
            startDate: start,
            endDate: end
        };
    };
    CalendarEventService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CalendarEventService.ctorParameters = function () { return []; };
    return CalendarEventService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CalendarSharedComponent = /** @class */ (function () {
    function CalendarSharedComponent(calDataService, calSlideService, calEventService, slotService) {
        this.calDataService = calDataService;
        this.calSlideService = calSlideService;
        this.calEventService = calEventService;
        this.slotService = slotService;
        this.dateRange = new EventEmitter();
        this.date = new EventEmitter();
        this.slotEvent = new EventEmitter();
        this.meridiem = this.calDataService.meridiem;
        this.arrows = {
            left: false,
            right: true
        };
        this.dateForDatepicker = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    CalendarSharedComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        /** @type {?} */
        var cal = changes['calendar'];
        if (cal && !cal.firstChange) {
            /** @type {?} */
            var resetCalendar = (this.calendar.reload) ? this.calendar.reload : false;
            this.calSlideService.indexForNoon = 0;
            this.calDataService.getIndexForTimes(this.calendar.timeRange);
            this.calSlideService.resetCalendar(resetCalendar, this.calendar.columns);
        }
    };
    /**
     * @return {?}
     */
    CalendarSharedComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.calDataService.getIndexForTimes(this.calendar.timeRange);
        this.calSlideService.setDrag(this.drag, this.calendar.columns);
        this.calSlideService.setClick();
        setTimeout(function (_) {
            _this.calSlideService.arrows$.subscribe(function (arrows) { return _this.arrows = arrows; });
            _this.calSlideService.meridiem$.subscribe(function (meridiem) { return _this.meridiem = meridiem; });
        }, 0);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    CalendarSharedComponent.prototype.meridiemChange = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.calSlideService.meridiemChange(data);
    };
    /**
     * @param {?} direction
     * @return {?}
     */
    CalendarSharedComponent.prototype.sendNewDateData = /**
     * @param {?} direction
     * @return {?}
     */
    function (direction) {
        /** @type {?} */
        var newDate = this.calEventService.updateDates(direction, this.calendar.startDate);
        this.dateForDatepicker.emit(newDate.startDate);
        this.dateRange.emit(this.calEventService.updateDates(direction, this.calendar.startDate));
    };
    /**
     * @param {?} newDate
     * @return {?}
     */
    CalendarSharedComponent.prototype.sendNewDateDataFromDatepicker = /**
     * @param {?} newDate
     * @return {?}
     */
    function (newDate) {
        this.dateRange.emit(this.calEventService.updateDates('fromDatepicker', newDate));
    };
    /**
     * @param {?} date
     * @param {?} index
     * @return {?}
     */
    CalendarSharedComponent.prototype.sendDay = /**
     * @param {?} date
     * @param {?} index
     * @return {?}
     */
    function (date, index) {
        this.date.emit({ date: date, index: index });
    };
    /**
     * @param {?} slot
     * @param {?} index
     * @param {?} row
     * @param {?} type
     * @return {?}
     */
    CalendarSharedComponent.prototype.sendSlotEvent = /**
     * @param {?} slot
     * @param {?} index
     * @param {?} row
     * @param {?} type
     * @return {?}
     */
    function (slot, index, row, type) {
        this.slotEvent.emit({ slot: slot, index: index, row: row, type: type });
    };
    CalendarSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-calendar',
                    template: "<ng-container *ngIf=\"calendar\">\n        <section class=\"sg-calendar__header row no-gutters\">\n            <div class=\"col-12\">\n                <mlp-ng-text-slider class=\"sg-calendar__text-slider mr-1\" [config]=\"{ label: calendar.textDate, showDatepicker: calendar.showDatepicker }\" [dateForDatepicker]=\"dateForDatepicker\" (changeDateFromDatepicker)=\"sendNewDateDataFromDatepicker($event)\" (changeData)=\"sendNewDateData($event)\"></mlp-ng-text-slider>\n                <mlp-ng-radio [(ngModel)]=\"meridiem\" (click)=\"meridiemChange('AM')\" name=\"dateTime\" radioValue=\"AM\" [config]=\"{ style: 'button' }\">AM</mlp-ng-radio>\n                <mlp-ng-radio [(ngModel)]=\"meridiem\" (click)=\"meridiemChange('PM')\" name=\"dateTime\" radioValue=\"PM\" [config]=\"{ style: 'button' }\">PM</mlp-ng-radio>\n            </div>\n\n        </section>\n\n        <section class=\"sg-calendar__row\">\n            <div class=\"sg-calendar__loading text-center\" *ngIf=\"loading\">\n                <!-- TODO: use our new loader -->\n                <h1>Loading here...</h1>\n                <span class=\"sr-only\">Loading...</span>\n            </div>\n\n            <a href=\"\" *ngIf=\"arrows.left\" class=\"sg-calendar__chevron d-none d-md-inline\"\n                (click)=\"calSlideService.click.next('left');false;\">\n                <mlp-ng-icon name=\"arrow-left-1\"></mlp-ng-icon>\n            </a>\n\n            <a href=\"\" *ngIf=\"arrows.right\" class=\"sg-calendar__chevron sg-calendar__chevron--right d-none d-md-inline\"\n                (click)=\"calSlideService.click.next('right');false;\">\n                <mlp-ng-icon name=\"arrow-right-1\"></mlp-ng-icon>\n            </a>\n\n            <section class=\"sg-calendar__col--small\">\n                <div class=\"sg-calendar__date\" *ngFor=\"let day of calendar.days;\">\n                    <div class=\"sg-calendar__day-of-week\">{{ day.weekDay }}</div>\n                    <div [outerHTML]=\"day.date | ngxDateNth\"></div>\n                </div>\n            </section>\n\n            <section class=\"sg-calendar__col--container\">\n                <div class=\"sg-calendar__col--overflow-hidden js-sg-calendar__col--overflow-hidden\">\n                    <div class=\"sg-calendar__col--moving\" #drag>\n                        <div class=\"row no-gutters\" [ngClass]=\"{'js-sg-calendar__row': I === 0}\" *ngFor=\"let day of calendar.days; let I = index;\">\n                            <mlp-ng-slot [slot]=\"slot\" [pitch]=\"pitch\" *ngFor=\"let slot of day.slots; let i = index;\" class=\"sg-calendar__slot js-sg-calendar__slot\">\n                                <mlp-ng-text-nav class=\"d-flex flex-column align-items-center\" [config]=\"{size: 'small'}\">\n                                    <a href=\"\" *ngIf=\"!slotService.isConfirmedBooking(slot, pitch) && !slotService.isCascadingBooking(slot, pitch)\" (click)=\"sendSlotEvent(slot, i, I, 'addBooking');false\">Add booking</a>\n                                    <a href=\"\" *ngIf=\"slot.attributes.availabilities || slotService.isConfirmedBooking(slot, pitch) || slotService.isCascadingBooking(slot, pitch)\" (click)=\"sendSlotEvent(slot, i, I, 'edit');false\">Edit</a>\n                                    <a href=\"\" *ngIf=\"slot.attributes.availabilities && slot.relationships?.bookings.data.length === 0\" (click)=\"sendSlotEvent(slot, i, I, 'cancel');false\">Cancel</a>\n                                    <a href=\"\" *ngIf=\"slot.attributes.availabilities === 0 && (slotService.isCancelledBooking(slot, pitch) || slotService.isUnavailableSlot(slot))\" (click)=\"sendSlotEvent(slot, i, I, 'addSlot');false\">Add slot</a>\n\n                                    <div *ngIf=\"slot.relationships?.bookings.data.length > 0\" class=\"d-flex align-items-center flex-column\">\n                                        <a *ngIf=\"slotService.isConfirmedBookingInAnyPitch(slot)\" href=\"\" (click)=\"sendSlotEvent(slot, i, I, 'cancelBooking');false\">Cancel</a>\n                                    </div>\n                                </mlp-ng-text-nav>\n                            </mlp-ng-slot>\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <section class=\"sg-calendar__col--small sg-calendar__col--right\">\n                <mlp-ng-icon class=\"sg-calendar__add cursor\" (click)=\"sendDay(day.ngbDateStruct, i)\" name=\"add\" *ngFor=\"let day of calendar.days; let i = index;\"></mlp-ng-icon>\n            </section>\n        </section>\n</ng-container>\n",
                    providers: [
                        WindowRefService,
                        CalendarDataService,
                        CalendarSlideService,
                        CalendarEventService,
                        TransformTimePipe
                    ],
                    styles: ["@charset \"UTF-8\";:host{display:block}.sg-calendar__header{margin-bottom:1rem}.sg-calendar__text-slider{max-width:350px;margin-bottom:1rem;display:block;float:left}.sg-calendar__row{display:flex;flex-direction:row;position:relative}@media (min-width:768px){.sg-calendar__header{margin-left:85px}.sg-calendar__row{margin:0 2rem}}.sg-calendar__loading{position:absolute;z-index:4;background-color:rgba(255,255,255,.7);height:100%;width:100%}.sg-calendar__loading-icon{position:absolute;top:43.5%;left:50%}.sg-calendar__col--small{width:40px;margin-right:15px}.sg-calendar__col--right{margin-right:0;margin-left:15px;width:20px}.sg-calendar__col--container{width:calc(100% - 90px)}.sg-calendar__col--overflow-hidden{width:100%;height:100%;overflow:hidden}.sg-calendar__col--moving{width:2000px}.sg-calendar__slot{height:55px;width:75px;margin:0 .25rem .25rem 0;display:inline-block}.sg-calendar__chevron{color:#a3bc00;position:absolute;top:47%;left:-2.2rem}.sg-calendar__chevron:hover{color:#cfef00}.sg-calendar__chevron--right{left:auto;right:-2.2rem}.sg-calendar__add{display:block;height:55px;line-height:55px;-ms-grid-row-align:center;align-self:center;margin-bottom:.25rem;transition:color 250ms ease-in-out;text-align:center}.sg-calendar__add:hover{color:#a3bc00}.sg-calendar__date{height:55px;-ms-grid-row-align:center;align-self:center;margin-bottom:.25rem}.sg-calendar__day-of-week{margin-bottom:-5px;padding-top:5px}.sg-calendar__relative{position:relative}"]
                }] }
    ];
    /** @nocollapse */
    CalendarSharedComponent.ctorParameters = function () { return [
        { type: CalendarDataService },
        { type: CalendarSlideService },
        { type: CalendarEventService },
        { type: SlotService }
    ]; };
    CalendarSharedComponent.propDecorators = {
        calendar: [{ type: Input }],
        pitch: [{ type: Input }],
        textDate: [{ type: Input }],
        loading: [{ type: Input }],
        drag: [{ type: ViewChild, args: ['drag',] }],
        dateRange: [{ type: Output }],
        date: [{ type: Output }],
        slotEvent: [{ type: Output }]
    };
    return CalendarSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Appends st, nd, th to number
 *
 * __Usage :__
 *   day | ngxDateNth
 *
 * __Example :__
 *   {{ 27 | ngxDateNth }}
 *   formats to: 27th
 *
 * Module {\@link TransformDateNthModule}
 */
var TransformDateNthPipe = /** @class */ (function () {
    function TransformDateNthPipe() {
    }
    /**
     * @param {?} day
     * @return {?}
     */
    TransformDateNthPipe.prototype.transform = /**
     * @param {?} day
     * @return {?}
     */
    function (day) {
        if (day > 3 && day < 21)
            return day + "th";
        switch (day % 10) {
            case 1: return day + "st";
            case 2: return day + "nd";
            case 3: return day + "rd";
            default: return day + "th";
        }
    };
    TransformDateNthPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ngxDateNth'
                },] }
    ];
    return TransformDateNthPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The TransformDateNth module
 *
 * import { TransformDateNthModule } from 'styleguide/src/shared/pipe/dateNth/pipe.dateNth.module';
 */
var TransformDateNthModule = /** @class */ (function () {
    function TransformDateNthModule() {
    }
    TransformDateNthModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformDateNthPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformDateNthPipe
                    ]
                },] }
    ];
    return TransformDateNthModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CalendarSharedModule = /** @class */ (function () {
    function CalendarSharedModule() {
    }
    CalendarSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CalendarSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        SlotSharedModule,
                        RadioSharedModule,
                        TextNavSharedModule,
                        TransformDateNthModule,
                        TextSliderSharedModule,
                        IconSharedModule,
                    ],
                    exports: [
                        CalendarSharedComponent
                    ]
                },] }
    ];
    return CalendarSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$3 = momentNs;
/** @type {?} */
var TIMEZONE$3 = 'Europe/London';
/** @type {?} */
var DATE = 'ddd DD MMM';
/** @type {?} */
var FULLDATE = 'll';
var CalendarProcessService = /** @class */ (function () {
    function CalendarProcessService() {
        this.amountOfDays = 7;
        this.defaultSlots = 15;
        this.columns = 0;
        this.startDate = moment$3.tz('Europe/London');
        this.days = [];
        this.timeRange = [];
        this.calendar$ = new BehaviorSubject({
            days: [],
            textDate: '',
            startDate: '',
            timeRange: [],
            columns: 0,
            showDatepicker: false
        });
    }
    /**
     * @param {?} slots
     * @param {?=} startDate
     * @param {?=} update
     * @return {?}
     */
    CalendarProcessService.prototype.setDays = /**
     * @param {?} slots
     * @param {?=} startDate
     * @param {?=} update
     * @return {?}
     */
    function (slots, startDate, update) {
        var _this = this;
        if (update === void 0) { update = false; }
        this.days = [];
        this.timeRange = [];
        this.startDate = (startDate) ? moment$3.tz(startDate, TIMEZONE$3) : this.startDate;
        /** @type {?} */
        var date = moment$3(this.startDate);
        /** @type {?} */
        var textDate = this.startDate.format(DATE) + " - " + date.add({ days: 6 }).format(DATE);
        this.createTimeRange(slots)
            .subscribe(function (_) { }, function (_) { }, function () {
            _this.timeRange = _this.timeRange.sort();
            _this.columns = _this.timeRange.length;
            _this.createDays(slots);
            _this.calendar$.next({
                days: _this.days, textDate: textDate, startDate: moment$3.tz(_this.startDate, TIMEZONE$3).format("YYYY-MM-DDTHH:mm:ss"),
                timeRange: _this.timeRange, columns: _this.columns, reload: update, showDatepicker: true
            });
        });
    };
    /**
     * @param {?} slots
     * @return {?}
     */
    CalendarProcessService.prototype.createDays = /**
     * @param {?} slots
     * @return {?}
     */
    function (slots) {
        for (var i = 0; i < this.amountOfDays; i++) {
            /** @type {?} */
            var mutabilityFix = moment$3(this.startDate);
            /** @type {?} */
            var day = mutabilityFix.add(i, 'd');
            /** @type {?} */
            var fullDate = day.format(FULLDATE);
            this.days.push({
                fullDate: fullDate,
                ngbDateStruct: { year: +day.format('YYYY'), month: +day.format('M'), day: +day.format('D') },
                date: day.format('D'),
                weekDay: day.format('ddd'),
                slots: this.createSlot(slots, fullDate)
            });
        }
    };
    /**
     * @param {?} slots
     * @param {?=} fullDate
     * @return {?}
     */
    CalendarProcessService.prototype.createTimeRange = /**
     * @param {?} slots
     * @param {?=} fullDate
     * @return {?}
     */
    function (slots, fullDate) {
        var _this = this;
        return from(slots)
            .pipe(filter(function (slot) {
            /** @type {?} */
            var diff = moment$3.duration(moment$3.tz(slot.attributes.starts, TIMEZONE$3).diff(moment$3(_this.startDate))).days();
            return (diff >= 0 && diff <= 7);
        }), map(function (slot) { return _this.getTimeZone(slot.attributes.starts); }), map(function (time) { return ({ hasTime: _this.timeRange.indexOf(time), time: time }); }), tap(function (result) { if (result.hasTime === -1)
            _this.timeRange.push(result.time); }));
    };
    /**
     * @param {?} slots
     * @param {?=} fullDate
     * @return {?}
     */
    CalendarProcessService.prototype.createSlot = /**
     * @param {?} slots
     * @param {?=} fullDate
     * @return {?}
     */
    function (slots, fullDate) {
        var _this = this;
        /** @type {?} */
        var slotsData = [];
        /** @type {?} */
        var slotsHolder = [];
        slotsHolder = slots.filter(function (slot) { return moment$3.tz(slot.attributes.starts, TIMEZONE$3).format(FULLDATE) === fullDate; });
        if (this.timeRange.length < this.defaultSlots)
            this.increaseTimeRange();
        this.timeRange.map(function (time) {
            /** @type {?} */
            var added = false;
            slotsHolder.map(function (slot) {
                /** @type {?} */
                var pushData = true;
                if (time === _this.getTimeZone(slot.attributes.starts)) {
                    slotsData.filter(function (alreadyAddedSlot, i) {
                        if (_this.getTimeZone(slot.attributes.starts) === _this.getTimeZone(alreadyAddedSlot.attributes.starts)) {
                            if (!alreadyAddedSlot.attributes.availabilities) {
                                slotsData[i] = slot;
                            }
                            pushData = false;
                        }
                    });
                    if (pushData)
                        slotsData.push(slot);
                    added = true;
                }
            });
            if (!added) {
                slotsData.push(_this.emptySlot());
            }
        });
        if (!this.timeRange.length) {
            for (var i = 0; i < this.defaultSlots; i++) {
                slotsData.push(this.emptySlot());
            }
        }
        return slotsData;
    };
    /**
     * @return {?}
     */
    CalendarProcessService.prototype.emptySlot = /**
     * @return {?}
     */
    function () {
        return {
            id: undefined,
            attributes: {
                name: undefined,
                starts: undefined,
                ends: undefined,
                price: undefined,
                currency: undefined,
                availabilities: undefined
            }
        };
    };
    /**
     * @param {?=} date
     * @return {?}
     */
    CalendarProcessService.prototype.getTimeZone = /**
     * @param {?=} date
     * @return {?}
     */
    function (date) {
        if (date === void 0) { date = ''; }
        return moment$3(date).tz(TIMEZONE$3).format('HH:mm');
    };
    /**
     * @return {?}
     */
    CalendarProcessService.prototype.increaseTimeRange = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var length = this.timeRange.length;
        for (var i = length; i < this.defaultSlots; i = i + 1) {
            this.timeRange.push('');
        }
    };
    CalendarProcessService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CalendarProcessService.ctorParameters = function () { return []; };
    return CalendarProcessService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CardSimpleSharedComponent = /** @class */ (function () {
    function CardSimpleSharedComponent() {
    }
    CardSimpleSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-card-simple',
                    template: "<div class=\"card-simple-container rounded\">\n    <div class=\"card-simple-header d-flex flex-row rounded-top\" [class.-success]=\"state === 'success'\" [class.-danger]=\"state === 'alert'\" [class.-info]=\"state === 'info'\">\n        <div class=\"py-2 flex-fill\">\n            <ng-content select=\"[header]\"></ng-content>\n        </div>\n        <div class=\"px-2\">\n            <ng-content select=\"[header-corner]\"></ng-content>\n        </div>\n    </div>\n    <div class=\"card-simple-body rounded-bottom\">\n        <ng-content select=\"[body]\"></ng-content>\n    </div>\n</div>\n\n\n\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host .card-simple-container .card-simple-header{color:#fff;background-color:#313436;padding-left:.75rem}:host .card-simple-container .card-simple-body{border:1px solid #aeadad;border-top:none;color:#464a4c;background-color:#f9f9f9}:host .card-simple-container .-success{color:#fff;background-color:#a3bc00}:host .card-simple-container .-info{color:#fff;background-color:#439fc2}:host .card-simple-container .-warning{color:#fff;background-color:#ffbf00}:host .card-simple-container .-danger{color:#fff;background-color:#c80a0a}"]
                }] }
    ];
    CardSimpleSharedComponent.propDecorators = {
        state: [{ type: Input }]
    };
    return CardSimpleSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CardSimpleSharedModule = /** @class */ (function () {
    function CardSimpleSharedModule() {
    }
    CardSimpleSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CardSimpleSharedComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        CardSimpleSharedComponent
                    ],
                },] }
    ];
    return CardSimpleSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * This service is a array service
 */
var ArrayService = /** @class */ (function () {
    function ArrayService() {
    }
    /**
     * Splits an array in two
     *
     * @example
     * ArrayService.splitArray(Array<any>);
     *
     * param {Array<any>}
     * returns {object} { firstArray: Array<any>, secondArray: Array<any> }
     */
    /**
     * Splits an array in two
     *
     * \@example
     * ArrayService.splitArray(Array<any>);
     *
     * param {Array<any>}
     * returns {object} { firstArray: Array<any>, secondArray: Array<any> }
     * @param {?} arr
     * @return {?}
     */
    ArrayService.prototype.splitArray = /**
     * Splits an array in two
     *
     * \@example
     * ArrayService.splitArray(Array<any>);
     *
     * param {Array<any>}
     * returns {object} { firstArray: Array<any>, secondArray: Array<any> }
     * @param {?} arr
     * @return {?}
     */
    function (arr) {
        if (!Array.isArray(arr)) {
            console.error('It is not an array');
            return;
        }
        /** @type {?} */
        var mid = Math.ceil(arr.length / 2);
        /** @type {?} */
        var data = {
            firstArray: [],
            secondArray: []
        };
        data.firstArray = arr.slice(0, mid);
        data.secondArray = arr.slice(mid);
        return data;
    };
    ArrayService.decorators = [
        { type: Injectable }
    ];
    return ArrayService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CardSharedComponent = /** @class */ (function () {
    function CardSharedComponent(arrService) {
        this.arrService = arrService;
        this.layout = 'grid';
    }
    Object.defineProperty(CardSharedComponent.prototype, "card", {
        get: /**
         * @return {?}
         */
        function () { return this._cardData; },
        set: /**
         * @param {?} card
         * @return {?}
         */
        function (card) {
            if (card) {
                /** @type {?} */
                var split = this.arrService.splitArray(card.list);
                card.listSplit = split.firstArray;
                card.listSplitTwo = split.secondArray;
                this._cardData = card;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardSharedComponent.prototype, "isGrid", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var isGrid = (this.layout === 'grid') ? true : false;
            return isGrid;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    CardSharedComponent.prototype.menuDisplayChanges = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event) {
            this.addToCalendarVisible = false;
        }
        if (!event) {
            this.addToCalendarVisible = true;
        }
    };
    CardSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-card',
                    template: "<section class=\"sg-card mb-4\" \n    [ngClass]=\"{'sg-card--disabled': card?.disabled, 'sg-card--list': layout === 'list', 'sg-card--link': card.linkTo, 'sg-card--secondary-bg': card?.cardBackgroundStyle }\"\n    *ngIf=\"card\">\n    \n    <ng-template [ngIf]=\"isGrid\" [ngIfElse]=\"landscape\">\n\n        <ng-template [ngIf]=\"card.linkTo?.routerLink\" [ngIfElse]=\"gridCard\">\n            <a [routerLink]=\"card.linkTo.routerLink\">\n                <ng-container *ngTemplateOutlet=\"gridCard\"></ng-container>\n            </a>\n        </ng-template>\n\n    </ng-template>\n\n</section>\n\n\n<ng-template #gridCard>\n\n    <mlp-ng-image [title]=\"card.name\" [alt]=\"card.name\" [image]=\"card?.images\" class=\"sg-card__image rounded-top mb-4\">\n        <ng-container *ngTemplateOutlet=\"badge; context: {class: ''}\"></ng-container>\n        \n    </mlp-ng-image>\n\n    <section class=\"col-12 sg-card__body\">\n\n        <ng-container *ngTemplateOutlet=\"badge_icon\"></ng-container>\n\n        <ng-container *ngTemplateOutlet=\"heading; context: {class: ''}\"></ng-container>\n\n        <ng-container *ngTemplateOutlet=\"list; context: {col: '', data: card.list}\"></ng-container>\n\n    </section>\n\n    <section class=\"col-12 mt-2\">\n        <ng-container *ngTemplateOutlet=\"footer; context: {col: ''}\"></ng-container>\n    </section>\n\n</ng-template>\n\n\n<ng-template #landscape>\n\n    <ng-template [ngIf]=\"card.linkTo?.routerLink\" [ngIfElse]=\"landscapeCard\">\n        <a [routerLink]=\"card.linkTo.routerLink\">\n            <ng-container *ngTemplateOutlet=\"landscapeCard\"></ng-container>\n        </a>\n    </ng-template>\n\n</ng-template>\n\n\n<ng-template #landscapeCard>\n\n    <section class=\"row mb-3 mb-md-0\">\n\n        <section class=\"col-4 col-lg-4 col-xl-3 pr-0 pr-md-3 position-relative\">\n            <mlp-ng-image [title]=\"card.name\" [image]=\"card?.images\" class=\"sg-card__image rounded-left\"></mlp-ng-image>\n            <ng-container *ngTemplateOutlet=\"badge_icon; context: {class: '-landscape'}\"></ng-container>\n        </section>\n\n        <section class=\"col-8 col-lg-8 col-xl-9 sg-card__body sg-card__body--no-height\">\n\n            <div class=\"pt-md-3 pr-md-3\">\n\n                <ng-container *ngTemplateOutlet=\"heading; context: {class: 'sg-card__title--landscape mb-0'}\"></ng-container>\n                <ng-container *ngTemplateOutlet=\"badge; context: {class: 'sg-card__badge--relative'}\"></ng-container>\n    \n                <section class=\"sg-card__body sg-card__body--no-height row align-items-end mt-3 mb-0 pb-md-3 sg-card__hidden-md-down\">\n    \n                    <ng-container *ngTemplateOutlet=\"list; context: {col: 'col-4', data: card.listSplit}\"></ng-container>\n                    <ng-container *ngTemplateOutlet=\"list; context: {col: 'col-4', data: card.listSplitTwo}\"></ng-container>\n                    <ng-container *ngTemplateOutlet=\"footer; context: {col: 'col-4 sg-card__footer--no-pb', copy: true}\"></ng-container>\n                    \n                </section>\n\n            </div>\n    \n        </section>\n        \n    </section>\n    \n    <section class=\"sg-card__body sg-card__body--no-height row mb-3 d-md-none\">\n        <ng-container *ngTemplateOutlet=\"list; context: {col: 'col-6', data: card.listSplit}\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"list; context: {col: 'col-6', data: card.listSplitTwo}\"></ng-container>\n    </section>\n\n    <section class=\"col-12 px-0 d-md-none\">\n        <ng-container *ngTemplateOutlet=\"footer; context: {col: ''}\"></ng-container>\n    </section>\n\n</ng-template>\n\n\n<ng-template #list let-default let-col=\"col\" let-data=\"data\">\n    <mlp-ng-list class=\"{{ col }}\" [list]=\"data\"></mlp-ng-list>\n    <ng-content></ng-content>\n</ng-template>\n\n\n<ng-template #footer let-default let-col=\"col\" let-copy=\"copy\">\n    <footer class=\"sg-card__footer {{ col }}\">\n        <ng-container *ngIf=\"!card.disabled && card.toEvent\" >\n            {{ card.toEvent }} \n        </ng-container>\n        &nbsp;\n        <mlp-ng-icon-nav class=\"pull-right\" [links]=\"card.links\" (visibility)=\"menuDisplayChanges($event)\" *ngIf=\"!card.linkTo\">\n            <!-- https://github.com/angular/angular/issues/9173 -->\n            <ng-content select=[links] *ngIf=\"copy\"></ng-content>\n            <!-- https://github.com/angular/angular/issues/9173 -->\n            <ng-content select=[links-copy] *ngIf=\"!copy\"></ng-content>\n            <mlp-ng-add-to-calendar [event]=\"card.event\" *ngIf=\"card.event && addToCalendarVisible\"></mlp-ng-add-to-calendar>\n        </mlp-ng-icon-nav>\n    </footer>\n</ng-template>\n\n\n<ng-template #badge let-default let-class=\"class\">\n    <mlp-ng-badge *ngIf=\"card?.badge\" [badge]=\"card?.badge\" class=\"sg-card__badge {{ class }}\"></mlp-ng-badge>\n</ng-template>\n\n\n<ng-template #badge_icon let-default let-class=\"class\">\n    <mlp-ng-icon *ngIf=\"card?.mainIcon\" class=\"sg-card__sport {{ class }}\" size=\"medium\" name=\"{{ card.mainIcon }}\"></mlp-ng-icon>\n</ng-template>\n\n\n<ng-template #heading let-default let-class=\"class\">\n    <h2 class=\"sg-heading__h3 sg-card__title {{ class }}\" [ngClass]=\"{'sg-card__title--secondary-title-color': card?.titleStyle}\">\n        <a [routerLink]=\"card.link\" class=\"sg-card__link\" *ngIf=\"card.link\">{{ card.name }}</a>\n        <ng-container *ngIf=\"!card.link\">{{ card.name }}</ng-container>\n    </h2>\n    <div class=\"sg-divider__short mb-2\"></div>\n</ng-template>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{width:100%;display:block;color:#464a4c}.sg-card{border-radius:.25rem;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:box-shadow 250ms ease-in-out}.sg-card--secondary-bg{background-color:#fff}@media (min-width:768px){.sg-card:hover{box-shadow:0 5px 21px -3px rgba(0,0,0,.55)}}.sg-card--link:active{box-shadow:0 5px 21px -3px #56e07b}.sg-card--list{box-shadow:0 3px 0 rgba(0,0,0,.24)}.sg-card--disabled{opacity:.5}.sg-card__link{color:#a3bc00}.sg-card__link:hover{color:#778900}.sg-card__image{position:relative;display:block;overflow:hidden}.sg-card__badge{position:absolute;bottom:.75rem;left:.75rem}.sg-card__badge--relative{position:relative;left:0;bottom:0}.sg-card__sport{width:3.5rem;height:3.5rem;position:absolute;top:-3.75rem;right:.75rem;border-radius:50%;background-color:#fff;text-align:center;padding-top:.62rem;color:#373737}.sg-card__sport.-landscape{padding-top:.1rem;top:-14%;position:relative;display:block;right:-60%}@media (min-width:576px){.sg-card__sport.-landscape{top:-10%;right:-75%}}@media (min-width:768px){.sg-card__sport.-landscape{top:-4%;padding-left:.1rem}}@media (min-width:992px){.sg-card--list{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.sg-card__sport.-landscape{top:-10%;right:-69%;padding-top:.6rem}}@media (max-width:991.98px){.sg-card__sport.-landscape{width:2rem;height:2rem}.sg-card__sport.-landscape ::ng-deep i{width:1.375rem;height:1.375rem;font-size:1.375rem;line-height:1.375rem}}.sg-card__body{min-height:170px;position:relative;color:#373737}@media (min-width:768px){.sg-card__body{min-height:212px}}.sg-card__body--no-height{min-height:auto}.sg-card__title{position:relative;height:3.6em;min-height:3.6em;overflow:hidden;color:#373737}.sg-card__title:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;width:50%;height:1.2em;background:linear-gradient(to right,rgba(255,255,255,0),#fff 50%)}.sg-card__title--landscape{min-height:auto}.sg-card__title--secondary-title-color,.sg-card__title--secondary-title-color:hover{color:#188155}.sg-card__footer{color:#737373;font-size:.75rem;padding-bottom:.75rem}.sg-card__footer--no-pb{padding-bottom:0}@media (max-width:767.98px){.sg-card__hidden-md-down{display:none}}"]
                }] }
    ];
    /** @nocollapse */
    CardSharedComponent.ctorParameters = function () { return [
        { type: ArrayService }
    ]; };
    CardSharedComponent.propDecorators = {
        layout: [{ type: Input }],
        card: [{ type: Input }]
    };
    return CardSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CardPlainSharedComponent = /** @class */ (function () {
    function CardPlainSharedComponent() {
    }
    CardPlainSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-card-plain',
                    template: "<section class=\"sg-card mb-4\" \n    *ngIf=\"card\">\n\n    <mlp-ng-image \n        [title]=\"card.name\" \n        [alt]=\"card.name\" \n        [image]=\"card?.images\" \n        class=\"sg-card__image sg-rounded mb-4\"\n    ></mlp-ng-image>\n\n    <h2 class=\"sg-heading__h3 sg-card__title position-relative\">\n        <mlp-ng-icon *ngIf=\"card?.icon\" class=\"sg-card__icon\" size=\"medium\" name=\"{{ card.icon }}\"></mlp-ng-icon>\n        {{ card.name }}\n    </h2>\n\n    <section class=\"sg-card__body\">\n        \n        <p>{{ card.description }}</p>\n\n        <ng-content></ng-content>\n\n    </section>\n\n</section>\n    ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{width:100%;display:block;color:#464a4c}.sg-card{border-radius:.25rem;text-align:center}.sg-card__image{position:relative;display:block;overflow:hidden}.sg-card__title{color:#2f285a;position:relative;margin-bottom:2rem}.sg-card__title:after{border-top:4px solid #56e07b;content:'';width:60px;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:-10px}@media (min-width:768px){.sg-card{text-align:left}.sg-card__title:after{left:0;-webkit-transform:translateX(0);transform:translateX(0)}}.sg-card__body{position:relative;color:#373737}.sg-card__description{color:#373737;margin-bottom:1.5rem}.sg-card__icon{width:3.5rem;height:3.5rem;position:absolute;top:-58px;right:.75rem;border-radius:50%;background-color:#fff;text-align:center;padding-top:.625rem;color:#2f285a}"]
                }] }
    ];
    CardPlainSharedComponent.propDecorators = {
        card: [{ type: Input }]
    };
    return CardPlainSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CardSharedModule = /** @class */ (function () {
    function CardSharedModule() {
    }
    CardSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CardSharedComponent,
                        CardPlainSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ListSharedModule,
                        ImageSharedModule,
                        BadgeSharedModule,
                        IconNavSharedModule,
                        AddToCalendarSharedModule,
                        RouterModule.forChild([]),
                        IconSharedModule
                    ],
                    exports: [
                        CardSharedComponent,
                        CardPlainSharedComponent
                    ],
                    providers: [
                        ArrayService
                    ]
                },] }
    ];
    return CardSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CarouselService = /** @class */ (function () {
    function CarouselService(browserService, windowRef, document) {
        var _this = this;
        this.browserService = browserService;
        this.windowRef = windowRef;
        this.document = document;
        this.currentPosition = 0;
        this.leftArrowDisabled$ = new BehaviorSubject(false);
        this.rightArrowDisabled$ = new BehaviorSubject(false);
        // Observable to inform if the user is sliding the carousel or clicking on a card
        this.isSliding$ = new BehaviorSubject(false);
        if (browserService.isBrowser) {
            fromEvent(this.windowRef.nativeWindow, 'resize')
                .pipe(debounceTime(1000), distinctUntilChanged())
                .subscribe(function (_) {
                _this.setCarouselInitialConfig(_this.carousel, _this.carouselOutterContainer);
            });
        }
    }
    /**
     * @param {?} c
     * @param {?} outterContainer
     * @return {?}
     */
    CarouselService.prototype.setCarouselInitialConfig = /**
     * @param {?} c
     * @param {?} outterContainer
     * @return {?}
     */
    function (c, outterContainer) {
        this.carousel = c;
        this.carouselOutterContainer = outterContainer;
        this.carouselItems = this.carousel.nativeElement.querySelectorAll('.js-carousel-item');
        this.numOfItems = this.carousel.nativeElement.querySelectorAll('.js-carousel-item').length;
        this.outterCarouselWidth = Math.ceil(parseFloat(getComputedStyle(this.carouselOutterContainer.nativeElement).width));
        /** @type {?} */
        var itemStyles = getComputedStyle(this.carouselItems[0]);
        this.itemWidthWithMargin = parseInt(itemStyles.width, 10) +
            parseInt(itemStyles.marginLeft, 10) +
            parseInt(itemStyles.marginRight, 10);
        this.carousel.nativeElement.style.width = ((this.itemWidthWithMargin * this.numOfItems)) + "px";
        // this.setArrows();
        this.setCarouselDragEvent(this.carousel);
    };
    /**
     * @return {?}
     */
    CarouselService.prototype.setArrows = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var carouselWidth = parseInt(this.carousel.nativeElement.style.width, 10);
        if (carouselWidth > this.outterCarouselWidth) {
            if (this.currentPosition === 0) {
                this.leftArrowDisabled$.next(true);
                this.rightArrowDisabled$.next(false);
            }
            if (this.currentPosition < 0 && (this.outterCarouselWidth < (carouselWidth + this.currentPosition))) {
                this.leftArrowDisabled$.next(false);
                this.rightArrowDisabled$.next(false);
            }
            if (this.currentPosition < 0 && (this.outterCarouselWidth === (carouselWidth + this.currentPosition))) {
                this.leftArrowDisabled$.next(false);
                this.rightArrowDisabled$.next(true);
            }
        }
        else {
            this.leftArrowDisabled$.next(true);
            this.rightArrowDisabled$.next(true);
        }
    };
    /**
     * @param {?=} drag
     * @return {?}
     */
    CarouselService.prototype.setCarouselDragEvent = /**
     * @param {?=} drag
     * @return {?}
     */
    function (drag) {
        var _this = this;
        /** @type {?} */
        var mousedown$ = fromEvent(drag.nativeElement, 'mousedown');
        /** @type {?} */
        var mouseup$ = fromEvent(this.document, 'mouseup');
        /** @type {?} */
        var mousemove$ = fromEvent(this.document, 'mousemove');
        /** @type {?} */
        var touchstart$ = fromEvent(drag.nativeElement, 'touchstart');
        /** @type {?} */
        var touchend$ = fromEvent(this.document, 'touchend');
        /** @type {?} */
        var touchmove$ = fromEvent(this.document, 'touchmove');
        /** @type {?} */
        var mousedrag$ = mousedown$.pipe(switchMap(function (md) {
            // Set the observable to false on mousedown event
            // Set the observable to false on mousedown event
            _this.isSliding$.next(false);
            /** @type {?} */
            var prevX = md.clientX;
            return mousemove$.pipe(map(function (mm) {
                mm.preventDefault();
                // Set the observable to true when the user starts sliding the carousel
                // Set the observable to true when the user starts sliding the carousel
                _this.isSliding$.next(true);
                /** @type {?} */
                var newPos = {
                    dx: mm.clientX - prevX
                };
                prevX = mm.clientX;
                return newPos;
            }), takeUntil(mouseup$));
        }));
        /** @type {?} */
        var touchdrag$ = touchstart$.pipe(switchMap(function (ts) {
            /** @type {?} */
            var prevX = ts.touches[0].clientX;
            return touchmove$.pipe(map(function (tm) {
                /** @type {?} */
                var newPos = {
                    dx: tm.touches[0].clientX - prevX
                };
                prevX = tm.touches[0].clientX;
                return newPos;
            }), takeUntil(touchend$));
        }));
        touchend$.subscribe(function (evt) {
            _this.finishMobileSliding();
        });
        /** @type {?} */
        var mouseTouch$ = merge(mousedrag$, touchdrag$);
        mouseTouch$.pipe(filter(function (newPos) { return newPos.dx !== 0; }))
            .subscribe(function (newPos) {
            _this.slideCarousel(newPos.dx);
        });
    };
    /**
     * @param {?} direction
     * @param {?} lArrowDis
     * @param {?} rArrowDis
     * @return {?}
     */
    CarouselService.prototype.moveCarousel = /**
     * @param {?} direction
     * @param {?} lArrowDis
     * @param {?} rArrowDis
     * @return {?}
     */
    function (direction, lArrowDis, rArrowDis) {
        /** @type {?} */
        var newPosition;
        /** @type {?} */
        var carouselPanelWidth = parseInt(this.carousel.nativeElement.style.width, 10);
        if (direction === 'right') {
            if (!rArrowDis) {
                newPosition = this.currentPosition - this.itemWidthWithMargin;
                if (newPosition < (this.outterCarouselWidth - carouselPanelWidth)) {
                    newPosition = +(this.outterCarouselWidth - carouselPanelWidth).toFixed(2);
                }
                this.carousel.nativeElement.style.transform = "translateX(" + newPosition + "px)";
                this.currentPosition = newPosition;
            }
            this.setArrows();
        }
        if (direction === 'left') {
            if (!lArrowDis) {
                newPosition = this.currentPosition + this.itemWidthWithMargin;
                if (newPosition < 0) {
                    this.carousel.nativeElement.style.transform = "translateX(" + newPosition + "px)";
                    this.currentPosition = newPosition;
                }
                else {
                    this.carousel.nativeElement.style.transform = "translateX(0px)";
                    this.currentPosition = 0;
                }
                this.setArrows();
            }
        }
    };
    /**
     * @param {?} newPos
     * @return {?}
     */
    CarouselService.prototype.slideCarousel = /**
     * @param {?} newPos
     * @return {?}
     */
    function (newPos) {
        /** @type {?} */
        var newPosition = this.currentPosition + newPos;
        /** @type {?} */
        var carouselPanelWidth = parseInt(this.carousel.nativeElement.style.width, 10);
        if (newPosition > 0)
            newPosition = 0;
        if ((carouselPanelWidth + newPosition) < this.outterCarouselWidth)
            newPosition += (this.outterCarouselWidth - (carouselPanelWidth + newPosition));
        if (newPosition <= 0 && ((carouselPanelWidth + newPosition) >= this.outterCarouselWidth)) {
            this.carousel.nativeElement.style.transform = "translateX(" + newPosition + "px)";
            this.currentPosition = newPosition;
        }
        this.setArrows();
    };
    /**
     * @return {?}
     */
    CarouselService.prototype.finishMobileSliding = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var slideToItem = (Math.round(Math.abs(this.currentPosition) / this.itemWidthWithMargin));
        if (slideToItem < (this.numOfItems - 1)) {
            this.carousel.nativeElement.style.transitionDuration = '0.4s';
            this.carousel.nativeElement.style.transform = "translateX(" + -(slideToItem * this.itemWidthWithMargin) + "px)";
            this.currentPosition = -(slideToItem * this.itemWidthWithMargin);
        }
    };
    CarouselService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CarouselService.ctorParameters = function () { return [
        { type: BrowserService },
        { type: WindowRefService },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    return CarouselService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CarouselSharedComponent = /** @class */ (function () {
    function CarouselSharedComponent(browserService, carService) {
        this.browserService = browserService;
        this.carService = carService;
        this.lArrowDisabled = true;
        this.rArrowDisabled = true;
    }
    /**
     * @return {?}
     */
    CarouselSharedComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.browserService.isBrowser) {
            this.carService.setCarouselInitialConfig(this.el, this.elContainer);
            setTimeout(function () {
                _this.carService.leftArrowDisabled$.subscribe(function (isDisabled) {
                    _this.lArrowDisabled = isDisabled;
                });
                _this.carService.rightArrowDisabled$.subscribe(function (isDisabled) {
                    _this.rArrowDisabled = isDisabled;
                });
                _this.carService.setArrows();
            }, 0);
        }
    };
    /**
     * @param {?} direction
     * @return {?}
     */
    CarouselSharedComponent.prototype.moveCarousel = /**
     * @param {?} direction
     * @return {?}
     */
    function (direction) {
        this.carService.moveCarousel(direction, this.lArrowDisabled, this.rArrowDisabled);
    };
    CarouselSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-carousel',
                    template: "<section class=\"wrapper\" [ngStyle]=\"{width: width}\">\n    <div #carouselOutterContainer class=\"js-carousel\">\n        <div #carouselPanel class=\"js-carousel -panes\" [ngClass]=\"config\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n\n    <div class=\"sg-chevron sg-rounded -left\" [class.-disabled]=\"carService.leftArrowDisabled$ | async\" (click)=\"moveCarousel('left')\">\n        <mlp-ng-icon name=\"arrow-left-1\"></mlp-ng-icon>\n    </div>\n\n    <div class=\"sg-chevron sg-rounded -right\" [class.-disabled]=\"carService.rightArrowDisabled$ | async\" (click)=\"moveCarousel('right')\">\n        <mlp-ng-icon name=\"arrow-right-1\"></mlp-ng-icon>\n    </div>\n</section>\n",
                    // tslint:disable-next-line:use-view-encapsulation
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{display:block}.wrapper{position:relative;width:100%;height:auto;padding:0 .25rem;box-sizing:border-box;margin-left:auto;margin-right:auto}.js-carousel{position:relative;overflow:hidden;width:100%;margin:auto}.js-carousel.-panes{position:relative}.js-carousel.-panes>*{display:inline-block}.sg-chevron{display:none}@media (min-width:768px){.js-carousel{width:90%}.sg-chevron{position:absolute;display:inline-block;width:2.5rem;height:4rem;padding-top:1.25rem;text-align:center;background-color:#464a4c;color:#fff;top:calc(50% - 2rem);cursor:pointer}.sg-chevron.-left{left:-.5rem}.sg-chevron.-right{right:-.5rem}}.sg-chevron.-disabled{opacity:.7}"]
                }] }
    ];
    /** @nocollapse */
    CarouselSharedComponent.ctorParameters = function () { return [
        { type: BrowserService },
        { type: CarouselService }
    ]; };
    CarouselSharedComponent.propDecorators = {
        config: [{ type: Input }],
        width: [{ type: Input }],
        elContainer: [{ type: ViewChild, args: ['carouselOutterContainer',] }],
        el: [{ type: ViewChild, args: ['carouselPanel',] }]
    };
    return CarouselSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CarouselSharedModule = /** @class */ (function () {
    function CarouselSharedModule() {
    }
    CarouselSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CarouselSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule
                    ],
                    exports: [
                        CarouselSharedComponent
                    ],
                    providers: [
                        CarouselService,
                        WindowRefService,
                        BrowserService
                    ]
                },] }
    ];
    return CarouselSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function customSelectRequiredValidator() {
    return function (control) {
        /** @type {?} */
        var isValid = false;
        /** @type {?} */
        var data = /** @type {?} */ (control.value);
        if (data && data.data) {
            isValid = true;
        }
        return isValid ? undefined : { invalidSelectRequired: { value: data } };
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CitySelectSharedComponent = /** @class */ (function () {
    function CitySelectSharedComponent(formBuilder) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.options = [];
        this.submitted = new EventEmitter();
        this.changed = new EventEmitter();
        this.form = this.formBuilder.group({
            city: [{
                    description: 'Select City',
                    data: null
                }, customSelectRequiredValidator()]
        });
        this.form.controls['city'].valueChanges.subscribe(function (value) {
            _this.changed.emit(value);
        });
    }
    Object.defineProperty(CitySelectSharedComponent.prototype, "city", {
        get: /**
         * @return {?}
         */
        function () { return this.form.get('city'); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CitySelectSharedComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        this.submitted.emit(this.form.controls['city'].value);
    };
    CitySelectSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-city-select',
                    template: "<form [formGroup]=\"form\" (submit)=\"submit()\">\n\n    <div class=\"mb-2\">\n        <mlp-ng-select formControlName=\"city\" [options]=\"options\" shadow=\"1\" noBorder=\"1\" [errors]=\"city.touched && !city.valid ? [{title: 'Please select city'}] : []\"></mlp-ng-select>\n    </div>\n\n    <mlp-ng-button-atom label=\"Go\" fullWidth=\"1\" btnShadow=\"1\" btnType=\"submit\"></mlp-ng-button-atom>\n\n</form>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CitySelectSharedComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    CitySelectSharedComponent.propDecorators = {
        options: [{ type: Input }],
        submitted: [{ type: Output }],
        changed: [{ type: Output }]
    };
    return CitySelectSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CitySelectSharedModule = /** @class */ (function () {
    function CitySelectSharedModule() {
    }
    CitySelectSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CitySelectSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        SelectSharedModule,
                        ButtonSharedModule,
                        JumbotronSharedModule
                    ],
                    exports: [
                        CitySelectSharedComponent
                    ],
                },] }
    ];
    return CitySelectSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MegaFooterSharedComponent = /** @class */ (function () {
    function MegaFooterSharedComponent(cookieService) {
        this.cookieService = cookieService;
        this.currentYear = new Date().getFullYear();
    }
    /**
     * @return {?}
     */
    MegaFooterSharedComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        if (this.city) {
            /** @type {?} */
            var cityHolder = this.city;
            if (!this.cityUppercase) {
                this.cityUppercase = cityHolder.charAt(0).toUpperCase() + cityHolder.substr(1);
            }
        }
    };
    /**
     * @param {?} url
     * @return {?}
     */
    MegaFooterSharedComponent.prototype.clearCityCookie = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (url === '/') {
            this.cookieService.remove('city');
            window.location.href = '/';
        }
    };
    MegaFooterSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-mega-footer',
                    template: "<footer class=\"sg-mega-footer sg-pt-1 sg-pt-md-2\" *ngIf=\"data\">\n    <section class=\"container\">\n        <section class=\"row\">\n            <div class=\"col-12 col-md-6\">\n                <section class=\"row\">\n                    <div class=\"col-12 col-sm-6 mb-4\">\n                        <div class=\"mx-3 mx-md-0 mt-md-3\" *ngIf=\"data.links1\">\n                            <h3 class=\"sg-heading__h4 text-uppercase mb-2\">{{ data.links1.title }}</h3>\n                            <p class=\"sg-subheading__h4 mb-2 min-paragraph-fix\">{{ data.links1.description }}</p>\n                            <hr class=\"sg-divider mt-0\" />\n                            <a [href]=\"link.href\" *ngFor=\"let link of data.links1.links\" (click)=\"clearCityCookie(link.href)\" class=\"py-2 py-lg-0\">{{ link.name }}</a>\n                        </div>\n                    </div>\n\n                    <div class=\"col-12 col-sm-6 mb-4\">\n                        <div class=\"mx-3 mx-md-0 mt-md-3\">\n                            <h3 class=\"sg-heading__h4 text-uppercase mb-2\">{{ data.links2.title }}</h3>\n                            <p class=\"sg-subheading__h4 mb-2 min-paragraph-fix\">{{ (sports) ? data.links2.sports.description : data.links2.city.description }} {{ (sports) ? cityUppercase : '' }}</p>\n                            <hr class=\"sg-divider mt-0\" />\n                            <div class=\"row\">\n                                <ng-container *ngIf=\"sports && sports.data && sports.data.length\">\n                                    <a [href]=\"city + '/' + sport.id\" *ngFor=\"let sport of sports?.data\" class=\"col-6 py-2 py-lg-0\">{{ sport.attributes.name }}</a>\n                                </ng-container>\n\n                                <ng-container *ngIf=\"!sports\">\n                                    <a [href]=\"cityData.attributes.slug\" *ngFor=\"let cityData of cities?.data\" class=\"col-12 py-2 py-lg-0\">{{ cityData.attributes.name }}</a>\n                                </ng-container>\n                            </div>\n                        </div>\n                    </div>\n                </section>\n            </div>\n\n            <div class=\"col-12 col-md-6 mb-4\">\n                <div class=\"sg-mega-footer__container\" *ngIf=\"data.links3\">\n                    <h3 class=\"sg-heading__h4 text-uppercase mb-2\">{{ data.links3.title }}</h3>\n\n                    <a [href]=\"data.links3.links[0].href\">{{ data.links3.links[0].name }}</a>\n                    <p class=\"sg-subheading__h4 mb-2\">{{ data.links3.links[0].description }}</p>\n\n                    <a [href]=\"data.links3.links[0].href\">{{ data.links3.links[1].name }}</a>\n                    <p class=\"sg-subheading__h4 mb-2\">{{ data.links3.links[1].description }}</p>\n\n                    <!-- <div class=\"row\">\n                        <div class=\"col-12 col-sm-6\">\n                            <a [href]=\"data.links3.links[1].href\">{{ data.links3.links[1].name }}</a>\n                            <p class=\"sg-subheading__h4 mb-2\">{{ data.links3.links[1].description }}</p>\n                        </div>\n\n                        <div class=\"col-12 col-sm-6\">\n                            <a [href]=\"data.links3.links[2].href\">{{ data.links3.links[2].name }}</a>\n                            <p class=\"sg-subheading__h4 mb-2\">{{ data.links3.links[2].description }}</p>\n                        </div>\n                    </div> -->\n                </div>\n            </div>\n        </section>\n\n        <section class=\"row\">\n            <div class=\"col-12 col-md-6\">\n                <section class=\"row\">\n                    <div class=\"col-12 col-sm-6 mb-4\">\n                        <div class=\"mx-3 mx-md-0\" *ngIf=\"data.links4\">\n                            <h3 class=\"sg-heading__h4 text-uppercase mb-2\">{{ data.links4.title }}</h3>\n                            <p class=\"sg-subheading__h4 mb-2 min-paragraph-fix\">{{ data.links4.description }}</p>\n                            <hr class=\"sg-divider mt-0\" />\n                            <a [href]=\"link.href\" *ngFor=\"let link of data.links4.links\" class=\"py-2 py-lg-0\">{{ link.name }}</a>\n                        </div>\n                    </div>\n\n                    <div class=\"col-12 col-sm-6 mb-4\">\n                        <div class=\"mx-3 mx-md-0\">\n                            <h3 class=\"sg-heading__h4 text-uppercase mb-2\">{{ data.links5.title }}</h3>\n                            <p class=\"sg-subheading__h4 mb-2 min-paragraph-fix\">{{ data.links5.description }}</p>\n                            <hr class=\"sg-divider mt-0\" />\n                            <a [href]=\"link.href\" *ngFor=\"let link of data.links5.links\" class=\"py-2 py-lg-0\">{{ link.name }}</a>\n                        </div>\n                    </div>\n                </section>\n            </div>\n\n            <div class=\"col-12 col-md-6 mb-4\">\n                <div class=\"mx-3 mx-md-0\">\n                    <div class=\"row\">\n                        <div class=\"col-12 col-sm-6 mb-4\">\n                            <h3 class=\"sg-heading__h4 text-uppercase mb-4\">\n                                <mlp-ng-icon name=\"lock-1\" class=\"pt-1\"></mlp-ng-icon> Secure Payments\n                            </h3>\n\n                            <p class=\"sg-subheading__h4 mb-2\">All payments are processed securely through Stripe</p>\n\n                            <ng-container *ngFor=\"let icon of data.payments\">\n                                <mlp-ng-icon [name]=\"icon\" size=\"medium\"></mlp-ng-icon>&nbsp;\n                            </ng-container>\n                        </div>\n\n                        <div class=\"col-12 col-sm-6\">\n                            <h3 class=\"sg-heading__h4 text-uppercase mb-4\">{{ data.app.title }}</h3>\n\n                            <a [href]=\"image.href\" class=\"mb-1 py-2 py-lg-0\" target=\"_blank\" *ngFor=\"let image of data.app.images\">\n                                <img [attr.alt]=\"image.name\" [attr.data-src]=\"image.src\" width=\"150\" class=\"mb-1 lazyload\" loading=\"lazy\">\n                            </a>\n\n                            <div class=\"d-block d-md-none sg-mb-1\">\n                                <img [attr.alt]=\"data.gdprLogo.alt\" [attr.data-src]=\"data.gdprLogo.src\" [width]=\"data.gdprLogo?.width\" class=\"lazyload\" loading=\"lazy\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </section>\n\n        <section class=\"row\">\n            <div class=\"col-12 col-md-6 mb-4 text-center text-md-left d-flex flex-column gdpr-section\">\n                <div class=\"flex-grow-1\"></div>\n\n                <div class=\"sg-mb-1 d-none d-md-block\">\n                    <img [attr.alt]=\"data.gdprLogo.alt\" [attr.data-src]=\"data.gdprLogo.src\" [width]=\"data.gdprLogo?.width\" class=\"mb-1 lazyload\" loading=\"lazy\">\n                </div>\n\n                <div class=\"mb-md-0 py-2 py-lg-0\">\n                    <img [src]=\"data.logoPin\" [attr.alt]=\"data.logoPinAlt\" class=\"logo-pin\" loading=\"lazy\">\n                    {{ data.somewhere }} &copy; All Rights Reserved {{ currentYear }}\n                </div>\n            </div>\n\n            <div class=\"col-12 col-md-6 text-center text-md-right\">\n                <a href=\"https://www.bookteq.com/\">\n                    <img alt=\"Bookteq is a certified B Corp\" [attr.data-src]=\"data.bcorpLogo\" class=\"lazyload mr-4\" loading=\"lazy\" width=\"90\" >\n                    <img alt=\"Bookteq Powered by Playfinder\" width=\"200\" [attr.data-src]=\"data.logo\" class=\"lazyload\" loading=\"lazy\">\n                </a>\n            </div>\n        </section>\n    </section>\n</footer>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";.sg-mega-footer{background-color:#ececec;color:#313436;padding:2rem 0}.sg-mega-footer__icon{color:#aeadad}.sg-mega-footer__container{border-radius:.25rem;background-color:#c8c8c8;padding:1rem}.sg-mega-footer a{color:#188155;display:block}.sg-mega-footer a .sg-mega-footer__icon{color:#188155;transition:color 250ms ease-in-out}.sg-mega-footer a .sg-mega-footer__icon:hover,.sg-mega-footer a:hover{color:#5da788}.sg-mega-footer .logo-pin{width:22px}@media (min-width:768px){.sg-mega-footer .min-paragraph-fix{min-height:3em}.sg-mega-footer .gdpr-section{height:114px}}"]
                }] }
    ];
    /** @nocollapse */
    MegaFooterSharedComponent.ctorParameters = function () { return [
        { type: CookieService }
    ]; };
    MegaFooterSharedComponent.propDecorators = {
        data: [{ type: Input }],
        city: [{ type: Input }],
        cities: [{ type: Input }],
        sports: [{ type: Input }],
        cityUppercase: [{ type: Input }]
    };
    return MegaFooterSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FooterSharedModule = /** @class */ (function () {
    function FooterSharedModule() {
    }
    FooterSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        MegaFooterSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        FooterNavSharedModule,
                        CookieModule.forRoot()
                    ],
                    exports: [
                        MegaFooterSharedComponent
                    ]
                },] }
    ];
    return FooterSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var GRAPHCOLOURS = [
    {
        backgroundColor: 'rgba(163,188,0,0.6)'
    },
    {
        backgroundColor: 'rgba(163,188,0,0.5)'
    },
    {
        backgroundColor: 'rgba(163,188,0,0.4)'
    },
    {
        backgroundColor: 'rgba(207,239,0,0.3)'
    },
    {
        backgroundColor: 'rgba(163,188,0,0.9)'
    }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GraphSharedComponent = /** @class */ (function () {
    function GraphSharedComponent() {
    }
    /**
     * @return {?}
     */
    GraphSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.graph.chartOptions = {
            responsive: true
        };
        this.graph.chartColors = (!this.graph.chartColors) ? GRAPHCOLOURS : this.graph.chartColors;
        Object.assign(this.graph.chartColors, GRAPHCOLOURS);
    };
    GraphSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-graph',
                    template: "<div style=\"display: block;\">\n    <canvas baseChart \n        [datasets]=\"graph.chartData\"\n        [labels]=\"graph.chartLabels\"\n        [options]=\"graph.chartOptions\"\n        [colors]=\"graph.chartColors\"\n        [legend]=\"graph.chartLegend\"\n        [chartType]=\"graph.chartType\"\n        (chartHover)=\"graph.chartHovered($event)\"\n        (chartClick)=\"graph.chartClicked($event)\">\n    </canvas>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    GraphSharedComponent.propDecorators = {
        graph: [{ type: Input }]
    };
    return GraphSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GraphSharedModule = /** @class */ (function () {
    function GraphSharedModule() {
    }
    GraphSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        GraphSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ChartsModule
                    ],
                    exports: [
                        GraphSharedComponent
                    ]
                },] }
    ];
    return GraphSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var HeaderSharedComponent = /** @class */ (function () {
    function HeaderSharedComponent(formBuilder, router, browserService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.router = router;
        this.browserService = browserService;
        this.hideSearch = false;
        this.loggedIn = false;
        this.login = new EventEmitter();
        this.logout = new EventEmitter();
        this.signUp = new EventEmitter();
        this.logoUrl = '/assets/logo/pf_logo.svg';
        this.logoAlt = 'Playfinder';
        this.homeUrl = '/';
        this.mobileNav = false;
        this.search = false;
        this.faderHeight = 0;
        this.form = this.formBuilder.group({ city: '' });
        this.city.valueChanges.pipe(filter(function (val) { return !!val; })).subscribe(function (val) {
            if (val.data) {
                _this.router.navigate(['/', val.data]);
            }
        });
    }
    Object.defineProperty(HeaderSharedComponent.prototype, "city", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ (this.form.get('city')); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.cities) {
            this.cities.subscribe(function (cities) {
                _this.citySelectOptions = [{
                        description: cities.currentCity,
                        data: null
                    }];
                cities.cities.forEach(function (city) {
                    if (city.name !== cities.currentCity) {
                        _this.citySelectOptions.push(/** @type {?} */ ({
                            description: city.name,
                            data: city.slug
                        }));
                    }
                });
                _this.city.setValue(_this.citySelectOptions[0]);
            });
        }
    };
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.closeSearchMobileNav();
    };
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.loginClick = /**
     * @return {?}
     */
    function () {
        this.login.emit();
    };
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.logoutClick = /**
     * @return {?}
     */
    function () {
        this.logout.emit();
    };
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.signUpClick = /**
     * @return {?}
     */
    function () {
        this.signUp.emit();
    };
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.mobileNavToggle = /**
     * @return {?}
     */
    function () {
        this.search = false;
        this.mobileNav = !this.mobileNav;
        if (this.browserService.isBrowser) {
            this.faderHeight = document.body.scrollHeight;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HeaderSharedComponent.prototype.searchToggle = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.mobileNav = false;
        this.search = !this.search;
        if (this.browserService.isBrowser) {
            this.faderHeight = document.body.scrollHeight;
        }
    };
    /**
     * @return {?}
     */
    HeaderSharedComponent.prototype.closeSearchMobileNav = /**
     * @return {?}
     */
    function () {
        this.mobileNav = false;
        this.search = false;
    };
    HeaderSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-header',
                    template: "<div class=\"sg-header\">\n    <div class=\"container-fluid\">\n        <div class=\"row\">\n            <div class=\"d-flex sg-header__segment sg-header__segment--heading align-items-center\">\n                <a [routerLink]=\"homeUrl\" class=\"d-flex px-3\">\n                    <img [src]=\"logoUrl\" [alt]=\"logoAlt\" />\n                </a>\n            </div>\n\n            <div class=\"d-flex px-0\">\n                <div class=\"triangle-top-left\"></div>\n            </div>\n\n            <div class=\"d-flex flex-grow-1 sg-header__segment sg-header__segment--body align-items-center pr-xl-3\">\n                <div *ngIf=\"cities | async\" ngbDropdown class=\"d-none d-sm-flex mx-3\">\n                    <a class=\"text-button-default -medium\" href=\"\" (click)=\"$event.preventDefault();$event.stopPropagation();\" ngbDropdownToggle>{{ (cities | async)?.currentCity }}</a>\n\n                    <div class=\"dropdown-menu\" ngbDropdownMenu>\n                      <a class=\"dropdown-item sg-link\" *ngFor=\"let city of (cities | async)?.cities\" [routerLink]=\"['/', city.slug]\">{{ city.name }}</a>\n                    </div>\n                </div>\n\n                <div *ngIf=\"!hideSearch\" class=\"d-none d-lg-flex align-items-center justy-content-start ml-3\">\n                    <a class=\"text-button-default -medium\" href=\"\" (click)=\"searchToggle($event);$event.preventDefault();$event.stopPropagation();\">\n                        <mlp-ng-icon name=\"search\" class=\"mr-1\"></mlp-ng-icon> search\n                    </a>\n                </div>\n\n                <div class=\"d-flex d-lg-none align-items-center justify-content-end h-100 w-100\">\n                    <a *ngIf=\"!hideSearch\" href=\"\" (click)=\"searchToggle($event);\">\n                        <mlp-ng-icon name=\"search\" size=\"medium\" weight=\"normal\" class=\"mr-4\" [class.sg-color__white]=\"search\"></mlp-ng-icon>\n                    </a>\n\n                    <a *ngIf=\"phoneNumber\" href=\"tel:{{phoneNumber}}\">\n                        <mlp-ng-icon name=\"phone\" size=\"medium\" weight=\"normal\" class=\"mr-2\"></mlp-ng-icon>\n                    </a>\n\n                    <a href=\"\" (click)=\"mobileNavToggle(); false\">\n                        <mlp-ng-icon name=\"custom-navigation-menu\" [class.sg-color__white]=\"mobileNav\" size=\"medium\" weight=\"normal\" class=\"ml-3 mr-3\"></mlp-ng-icon>\n                    </a>\n                </div>\n\n                <div class=\"d-none d-lg-flex align-items-center justify-content-end h-100 w-100 pr-lg-3 pr-xl-0\">\n                    <mlp-ng-text-button-external *ngIf=\"phoneNumber\" url=\"tel:{{phoneNumber}}\" [label]=\"phoneNumber\" weight=\"medium\" iconName=\"phone-circle\" class=\"mr-4\"></mlp-ng-text-button-external>\n\n                    <div *ngIf=\"!loggedIn\" class=\"d-flex flex-row\">\n                        <a class=\"text-button-default -medium\" href=\"\" (click)=\"signUpClick();$event.preventDefault();$event.stopPropagation();\">\n                            <mlp-ng-icon name=\"single-neutral-circle\" class=\"mr-1\"></mlp-ng-icon> Sign up\n                        </a>\n                        <div class=\"mx-3\">|</div>\n                        <a class=\"text-button-default -medium\" href=\"\" (click)=\"loginClick();$event.preventDefault();$event.stopPropagation();\">\n                            Login\n                        </a>\n                    </div>\n\n                    <div *ngIf=\"loggedIn\" class=\"d-flex flex-row\" ngbDropdown>\n                        <a class=\"text-button-default -medium\" href=\"\" (click)=\"$event.preventDefault();$event.stopPropagation();\" ngbDropdownToggle>\n                            <mlp-ng-icon name=\"single-neutral-circle\" class=\"mr-1\"></mlp-ng-icon> My Account\n                        </a>\n\n                        <div class=\"dropdown-menu\" ngbDropdownMenu>\n                            <a class=\"dropdown-item sg-link\" *ngFor=\"let link of links\" [routerLink]=\"['/user/', link.link]\">{{ link.label }}</a>\n                            <a class=\"dropdown-item sg-link\" href=\"\" (click)=\"logoutClick()\">Log Out</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div *ngIf=\"trailing\" class=\"d-none d-xl-flex px-0\">\n                <div class=\"triangle-top-right\"></div>\n            </div>\n\n            <div *ngIf=\"trailing\" class=\"d-none d-xl-flex align-items-center sg-header__segment sg-header__segment--trailing px-3\">\n              <mlp-ng-text-button-internal [queryParamsHandling]=\"''\" *ngIf=\"trailing.label && !trailing.href\" [label]=\"trailing.label\" [url]=\"trailing.routerLink\" weight=\"medium\"></mlp-ng-text-button-internal>\n              <mlp-ng-text-button-external *ngIf=\"trailing.label && trailing.href\" [label]=\"trailing.label\" [url]=\"trailing.href\" weight=\"medium\"></mlp-ng-text-button-external>\n\n              <a *ngIf=\"trailing.imgUrl\" [routerLink]=\"trailing.routerLink\" class=\"d-flex\">\n                <img [src]=\"trailing.imgUrl\" [alt]=\"trailing.imgAlt\" />\n              </a>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"sg-header__fader\"\n        *ngIf=\"search || mobileNav\"\n        [@fadeInFadeOutAnimation]\n        [style.height.px]=\"faderHeight\"\n        (click)=\"closeSearchMobileNav()\"\n    ></div>\n\n    <div class=\"sg-header__dropdown mobileNav\" [@ngForAnimationFold]=\"mobileNav ? 'opened' : 'closed'\">\n        <div class=\"px-3 my-3 col-12\">\n            <mlp-ng-text-button-internal [queryParamsHandling]=\"''\" [url]=\"homeUrl\" iconName=\"house-2\" label=\"Home\"></mlp-ng-text-button-internal>\n        </div>\n\n        <div *ngIf=\"!hideSearch && cities | async\" class=\"px-3 mb-3 col-12\">\n            <mlp-ng-text-button-internal [queryParamsHandling]=\"''\" (click)=\"searchToggle($event)\" label=\"Search\" iconName=\"search\"></mlp-ng-text-button-internal>\n        </div>\n\n        <div *ngIf=\"citySelectOptions && loggedIn\" class=\"d-block d-sm-none px-3 my-3 col-12\">\n            <p class=\"mb-1 font size14 sg-header__location\">Search Location</p>\n            <form [formGroup]=\"form\">\n                <mlp-ng-select formControlName=\"city\" [options]=\"citySelectOptions\"></mlp-ng-select>\n            </form>\n        </div>\n\n        <div *ngIf=\"!loggedIn\">\n            <div class=\"px-3 mb-3 col-12\">\n                <mlp-ng-text-button-internal [queryParamsHandling]=\"''\" (click)=\"loginClick()\" iconName=\"login-1\" label=\"Login\"></mlp-ng-text-button-internal>\n            </div>\n\n            <div class=\"px-3 my-3 col-12\">\n                <mlp-ng-text-button-internal [queryParamsHandling]=\"''\" (click)=\"signUpClick()\" iconName=\"single-neutral-actions-add\" label=\"Sign up\"></mlp-ng-text-button-internal>\n            </div>\n        </div>\n\n        <div *ngIf=\"loggedIn\" class=\"px-3 my-3 col-12\">\n            <ng-content select=\"[mobile]\"></ng-content>\n        </div>\n\n        <div *ngIf=\"phoneNumber\" class=\"px-3 my-3 col-12\">\n            <mlp-ng-text-button-external url=\"tel:{{phoneNumber}}\" [label]=\"phoneNumber\" weight=\"normal\" iconName=\"phone-circle\" class=\"mr-4\"></mlp-ng-text-button-external>\n        </div>\n\n        <div *ngIf=\"trailing\" class=\"px-3 my-3 col-12\">\n            <mlp-ng-text-button-internal [queryParamsHandling]=\"''\" [url]=\"trailing.routerLink\" label=\"Become a venue partner\" weight=\"normal\" iconName=\"check-circle-1\" class=\"mr-4\"></mlp-ng-text-button-internal>\n        </div>\n\n        <div *ngIf=\"citySelectOptions && !loggedIn\" class=\"d-block d-sm-none px-3 my-3 col-12\">\n            <p class=\"mb-1 font size14 sg-header__dropdown__location\">Search Location</p>\n            <form [formGroup]=\"form\">\n                <mlp-ng-select formControlName=\"city\" [options]=\"citySelectOptions\"></mlp-ng-select>\n            </form>\n        </div>\n    </div>\n\n    <div class=\"sg-header__dropdown search\" [@ngForAnimationFold]=\"search ? 'opened' : 'closed'\">\n        <ng-content select=\"[search]\"></ng-content>\n    </div>\n</div>\n",
                    animations: [
                        foldDownUpAnimation,
                        fadeInFadeOutAnimation
                    ],
                    styles: ["@charset \"UTF-8\";.sg-header img{height:26px}.sg-header__segment{color:#2f285a;height:50px}.sg-header__segment--heading{background-color:#2f285a}.sg-header__segment--body{background-color:#56e07b}.sg-header__segment--body /deep/ mlp-ng-icon i{font-weight:700!important}.sg-header__segment--body /deep/ mlp-ng-icon[size=medium] i{font-size:1rem}.sg-header__segment--trailing{background-color:#fff}.sg-header__fader{position:absolute;width:100%;background-color:rgba(55,55,55,.7);z-index:6}.sg-header__dropdown{background-color:#fff;position:absolute;width:100%;z-index:6}.sg-header__location{color:#6c757d}.sg-header .mobileNav{background-color:#ececec}.sg-header .triangle-top-left{background-color:#2f285a;width:100%;height:0;border-bottom:50px solid #56e07b;border-left:29px solid transparent}@media (min-width:576px){.sg-header img{width:172.13px;height:35px}.sg-header__segment{height:55px}.sg-header__segment--body /deep/ mlp-ng-icon[size=medium] i{font-size:1.5rem}.sg-header .triangle-top-left{width:100%;height:0;border-bottom:55px solid #56e07b;border-left:32px solid transparent}}.sg-header .triangle-top-right{background-color:#56e07b;width:100%;height:0;border-bottom:55px solid #fff;border-left:32px solid transparent}"]
                }] }
    ];
    /** @nocollapse */
    HeaderSharedComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: Router },
        { type: BrowserService }
    ]; };
    HeaderSharedComponent.propDecorators = {
        hideSearch: [{ type: Input }],
        loggedIn: [{ type: Input }],
        login: [{ type: Output }],
        logout: [{ type: Output }],
        signUp: [{ type: Output }],
        logoUrl: [{ type: Input }],
        logoAlt: [{ type: Input }],
        phoneNumber: [{ type: Input }],
        homeUrl: [{ type: Input }],
        trailing: [{ type: Input }],
        cities: [{ type: Input }],
        links: [{ type: Input }]
    };
    return HeaderSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var HeaderSharedModule = /** @class */ (function () {
    function HeaderSharedModule() {
    }
    HeaderSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        HeaderSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        RouterModule.forChild([]),
                        NgbDropdownModule,
                        TextButtonExternalSharedModule,
                        TextButtonInternalSharedModule,
                        SelectSharedModule,
                        IconSharedModule
                    ],
                    providers: [
                        BrowserService
                    ],
                    exports: [
                        HeaderSharedComponent
                    ]
                },] }
    ];
    return HeaderSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PostcodeLookUpServiceConfig = /** @class */ (function () {
    function PostcodeLookUpServiceConfig() {
        this.autoCompleteDomain = '';
        this.geoCodeDomain = '';
        this.apiKey = '';
    }
    return PostcodeLookUpServiceConfig;
}());
var InputPostcodeLookUpService = /** @class */ (function () {
    function InputPostcodeLookUpService(http, config) {
        this.http = http;
        this.autoCompleteDomain = '';
        this.geoCodeDomain = '';
        this.apiKey = '';
        if (config) {
            this.autoCompleteDomain = config.autoCompleteDomain;
            this.geoCodeDomain = config.geoCodeDomain;
            this.apiKey = config.apiKey;
        }
    }
    /**
     * @param {?} input
     * @param {?} types
     * @param {?} countries
     * @return {?}
     */
    InputPostcodeLookUpService.prototype.getAutoComplete = /**
     * @param {?} input
     * @param {?} types
     * @param {?} countries
     * @return {?}
     */
    function (input, types, countries) {
        var _this = this;
        return input.pipe(debounceTime(250), distinctUntilChanged(), filter(function (addData) { return addData !== ''; }), switchMap(function (add) {
            return _this.http.get(
            // tslint:disable-next-line:max-line-length
            _this.autoCompleteDomain + "/maps/api/place/autocomplete/json?input=" + add + "&types=" + types + "&components=" + countries + "&key=" + _this.apiKey);
        }), map(function (results) { return _this.getAllPredictions(results); }));
    };
    /**
     * @param {?} input
     * @param {?} types
     * @param {?} countries
     * @return {?}
     */
    InputPostcodeLookUpService.prototype.getFirstAutoComplete = /**
     * @param {?} input
     * @param {?} types
     * @param {?} countries
     * @return {?}
     */
    function (input, types, countries) {
        var _this = this;
        return this.http.get(
        // tslint:disable-next-line:max-line-length
        this.autoCompleteDomain + "/maps/api/place/autocomplete/json?input=" + input + "&types=" + types + "&components=" + countries + "&key=" + this.apiKey)
            .pipe(map(function (results) { return _this.getFirstResultFromPredictions(results); }), switchMap(function (data) { return data ? _this.getLatLongFromPlaceId(data.place_id) : of(undefined); }));
    };
    /**
     * @param {?} placeId
     * @return {?}
     */
    InputPostcodeLookUpService.prototype.getLatLongFromPlaceId = /**
     * @param {?} placeId
     * @return {?}
     */
    function (placeId) {
        var _this = this;
        return this.http.get(this.geoCodeDomain + "/maps/api/geocode/json?place_id=" + placeId + "&key=" + this.apiKey)
            .pipe(map(function (results) { return _this.returnLatLong(results); }));
    };
    /**
     * @param {?} results
     * @return {?}
     */
    InputPostcodeLookUpService.prototype.getAllPredictions = /**
     * @param {?} results
     * @return {?}
     */
    function (results) {
        /** @type {?} */
        var suggestions = [];
        results.predictions.forEach(function (item) {
            if (item.types.indexOf('postal_code') !== -1) {
                suggestions.push(item);
            }
        });
        return suggestions;
    };
    /**
     * @param {?} results
     * @return {?}
     */
    InputPostcodeLookUpService.prototype.getFirstResultFromPredictions = /**
     * @param {?} results
     * @return {?}
     */
    function (results) {
        /** @type {?} */
        var suggestion;
        results.predictions.forEach(function (item) {
            if (item.types.indexOf('postal_code') !== -1 && !suggestion) {
                suggestion = item;
            }
        });
        return suggestion;
    };
    /**
     * @param {?} results
     * @return {?}
     */
    InputPostcodeLookUpService.prototype.returnLatLong = /**
     * @param {?} results
     * @return {?}
     */
    function (results) {
        /** @type {?} */
        var result;
        results.results.forEach(function (item) {
            if (item.types.indexOf('postal_code') !== -1 && !result) {
                result = { latitude: item.geometry.location.lat, longitude: item.geometry.location.lng };
            }
        });
        return result;
    };
    InputPostcodeLookUpService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    InputPostcodeLookUpService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: PostcodeLookUpServiceConfig, decorators: [{ type: Optional }] }
    ]; };
    return InputPostcodeLookUpService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$4 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return InputPostcodeLookupSharedComponent; }),
    multi: true
};
var InputPostcodeLookupSharedComponent = /** @class */ (function () {
    function InputPostcodeLookupSharedComponent(InputAddLookUpService) {
        this.InputAddLookUpService = InputAddLookUpService;
        this.inputSetup = { id: 'address', placeholder: 'Type postcode', icon: 'compass-direction' };
        this.errors = [];
        this.types = '(regions)';
        this.countries = 'country:UK|country:IE';
        this.selectedIndex = 0;
        this.predictions = [];
        this.searchTerm$ = new Subject();
        this.reverseAddress = '';
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(InputPostcodeLookupSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.searchTerm$.subscribe(function (text) {
            if (text === '') {
                _this.closeDropDown();
                // tslint:disable-next-line:no-null-keyword
                // tslint:disable-next-line:no-null-keyword
                _this.value = null;
            }
            if (text !== '') {
                _this.value = text;
            }
        });
        this.InputAddLookUpService.getAutoComplete(this.searchTerm$, this.types, this.countries)
            .subscribe(function (results) { return _this.predictions = results; });
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value && value.input) {
            this.reverseAddress = value.input;
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.setFromSuggestion = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        this.reverseAddress = value.structured_formatting.main_text;
        this.selectedIndex = 0;
        this.InputAddLookUpService.getLatLongFromPlaceId(value.place_id).subscribe(function (data) {
            _this.value = __assign({}, data, { input: _this.reverseAddress });
            _this.resetErrors();
        });
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.closeDropDown = /**
     * @return {?}
     */
    function () {
        this.predictions = [];
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.onEnter = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.resetErrors();
        // if arrow keys are not used
        if (this.selectedIndex === 0) {
            if (this.reverseAddress) {
                this.InputAddLookUpService.getFirstAutoComplete(this.reverseAddress, this.types, this.countries).subscribe(function (data) {
                    data ? _this.value = __assign({}, data, { input: _this.reverseAddress }) : _this.showError();
                });
            }
            else {
                // tslint:disable-next-line:no-null-keyword
                this.value = null;
            }
        }
        else {
            this.predictions.forEach(function (item, index) {
                if (_this.selectedIndex === index + 1) {
                    _this.setFromSuggestion(item);
                }
            });
        }
        this.closeDropDown();
        this.selectedIndex = 0;
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.arrowUp = /**
     * @return {?}
     */
    function () {
        if (this.predictions.length > 0 && this.selectedIndex > 0) {
            this.selectedIndex--;
        }
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.arrowDown = /**
     * @return {?}
     */
    function () {
        if (this.predictions.length > 0) {
            this.selectedIndex++;
        }
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.onBlurMethod = /**
     * @return {?}
     */
    function () {
        console.log('blur');
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.resetErrors = /**
     * @return {?}
     */
    function () {
        this.errors = [];
    };
    /**
     * @return {?}
     */
    InputPostcodeLookupSharedComponent.prototype.showError = /**
     * @return {?}
     */
    function () {
        this.errors = [({ title: 'Invalid Postcode' })];
    };
    InputPostcodeLookupSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input-postcode-lookup',
                    template: "<mlp-ng-input [(ngModel)]=\"reverseAddress\"\n    (input)=\"searchTerm$.next(reverseAddress)\"\n    [inputId]=\"inputSetup.id\"\n    icon=\"compass-direction\"\n    [placeholder]=\"inputSetup.placeholder\"\n    [errors]=\"errors\"\n    (keydown.enter)=\"onEnter();false\"\n    (keydown.escape)=\"closeDropDown();false\"\n    (keydown.ArrowDown)=\"arrowDown();false\"\n    (keydown.ArrowUp)=\"arrowUp();false\"></mlp-ng-input>\n\n<ul class=\"autocomplete\" *ngIf=\"predictions.length > 0\">\n\n    <li class=\"autocomplete__item\" (click)=\"setFromSuggestion(item);closeDropDown()\" *ngFor=\"let item of predictions; let i = index\" [class.selected]=\"selectedIndex == i+1\">\n        <mlp-ng-icon class=\"autocomplete__icon pr-2\" name=\"style-two-pin-marker\" size=\"small\"></mlp-ng-icon>\n        {{ item.structured_formatting.main_text }}\n    </li>\n\n    <li class=\"autocomplete__item autocomplete__item--close\" (click)=\"closeDropDown()\">\n        Close\n    </li>\n\n</ul>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$4,
                        InputPostcodeLookUpService
                    ],
                    styles: ["@charset \"UTF-8\";:host{position:relative;display:block;width:100%}.autocomplete{width:100%;background-color:#fff;border:1px solid #eceeef;margin:0;padding:0;list-style-type:none;border-radius:.25rem;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);position:absolute;top:40px;left:0;z-index:4}.autocomplete__item{cursor:pointer;border-bottom:1px solid #eceeef;padding:.5rem .75rem;transition:background-color 250ms ease-in-out;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.autocomplete__item:hover{background-color:#eceeef}.autocomplete__item--close{padding:.25rem .75rem}.autocomplete__item.selected{background-color:#deee86}.autocomplete__icon{color:#439fc2}"]
                }] }
    ];
    /** @nocollapse */
    InputPostcodeLookupSharedComponent.ctorParameters = function () { return [
        { type: InputPostcodeLookUpService }
    ]; };
    InputPostcodeLookupSharedComponent.propDecorators = {
        inputSetup: [{ type: Input }],
        errors: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }],
        types: [{ type: Input }],
        countries: [{ type: Input }]
    };
    return InputPostcodeLookupSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputPostcodeLookupSharedModule = /** @class */ (function () {
    function InputPostcodeLookupSharedModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    InputPostcodeLookupSharedModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: InputPostcodeLookupSharedModule,
            providers: [
                {
                    provide: PostcodeLookUpServiceConfig,
                    useValue: config
                }
            ]
        };
    };
    InputPostcodeLookupSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputPostcodeLookupSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        HttpClientModule,
                        AlertSharedModule,
                        InputSharedModule,
                        IconSharedModule
                    ],
                    exports: [
                        InputPostcodeLookupSharedComponent
                    ]
                },] }
    ];
    return InputPostcodeLookupSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var GOOGLEAPI = 'https://maps.googleapis.com/maps/api/geocode/json?';
/** @type {?} */
var GOOGLEMAPS = "" + GOOGLEAPI;
/** @type {?} */
var GOOGLEREVERSE = "" + GOOGLEAPI;
var AddressLookUpServiceConfig = /** @class */ (function () {
    function AddressLookUpServiceConfig() {
        this.apiKey = '';
    }
    return AddressLookUpServiceConfig;
}());
var InputAddressLookUpService = /** @class */ (function () {
    function InputAddressLookUpService(http, config) {
        this.http = http;
        this.apiKey = '';
        this.country = '';
        if (config) {
            this.apiKey = config.apiKey;
        }
    }
    /**
     * @param {?} address
     * @param {?=} country
     * @return {?}
     */
    InputAddressLookUpService.prototype.getAddresses = /**
     * @param {?} address
     * @param {?=} country
     * @return {?}
     */
    function (address, country) {
        var _this = this;
        if (country === void 0) { country = ''; }
        this.country = country;
        return address.pipe(debounceTime(250), distinctUntilChanged(), filter(function (addData) { return addData !== ''; }), switchMap(function (add) {
            return _this.http.get(GOOGLEMAPS + "&key=" + _this.apiKey + "&address=" + add + "&components=country:" + _this.country);
        }));
    };
    /**
     * @param {?} latLng
     * @return {?}
     */
    InputAddressLookUpService.prototype.reverseAddressLookUp = /**
     * @param {?} latLng
     * @return {?}
     */
    function (latLng) {
        return this.http.get(GOOGLEREVERSE + "key=" + this.apiKey + "&latlng=" + latLng.latitude + "," + latLng.longitude);
    };
    InputAddressLookUpService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    InputAddressLookUpService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AddressLookUpServiceConfig, decorators: [{ type: Optional }] }
    ]; };
    return InputAddressLookUpService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$5 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return InputAddressLookupSharedComponent; }),
    multi: true
};
var InputAddressLookupSharedComponent = /** @class */ (function () {
    function InputAddressLookupSharedComponent(InputAddLookUpService) {
        this.InputAddLookUpService = InputAddLookUpService;
        this.inputData = { icon: 'location-arrow' };
        this.errors = [];
        this.country = '';
        this._value = '';
        this.addresses = undefined;
        this.reverseAddress = '';
        this.searchTerm$ = new Subject();
        this.alerts = [];
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(InputAddressLookupSharedComponent.prototype, "input", {
        get: /**
         * @return {?}
         */
        function () {
            return this.inputData;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            if (val) {
                this.inputData = val;
                this.inputData.icon = 'location-arrow';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputAddressLookupSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    InputAddressLookupSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.searchTerm$.subscribe(function (text) {
            _this.setAddress({ formatted_address: text });
            if (text === '')
                _this.closeDropDown();
        });
        this.InputAddLookUpService.getAddresses(this.searchTerm$, this.country)
            .subscribe(function (addresses) { return _this.addresses = addresses; }, function (errors) { return _this.alerts.push({ message: errors.statusText, status: 'danger' }); });
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputAddressLookupSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        if (this.value && typeof this.value === 'object') {
            this.InputAddLookUpService.reverseAddressLookUp(this.value)
                .subscribe(function (addressess) { return _this.reverseAddress = addressess.results[0].formatted_address; }, function (errors) { return _this.alerts.push({ message: errors.statusText, status: 'danger' }); });
        }
        this.onChange = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputAddressLookupSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputAddressLookupSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} address
     * @return {?}
     */
    InputAddressLookupSharedComponent.prototype.setAddress = /**
     * @param {?} address
     * @return {?}
     */
    function (address) {
        this.value = address.formatted_address;
        this.reverseAddress = this.value;
    };
    /**
     * @return {?}
     */
    InputAddressLookupSharedComponent.prototype.closeDropDown = /**
     * @return {?}
     */
    function () {
        this.addresses = undefined;
    };
    InputAddressLookupSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input-address-lookup',
                    template: "<mlp-ng-input [(ngModel)]=\"reverseAddress\"\n    (input)=\"searchTerm$.next(reverseAddress)\"\n    [input]=\"input\" [errors]=\"errors\"></mlp-ng-input>\n\n<ul class=\"autocomplete\" *ngIf=\"addresses && addresses.results.length\">\n    <li class=\"autocomplete__item\" (click)=\"setAddress(address);closeDropDown()\" *ngFor=\"let address of addresses.results\">\n        <mlp-ng-icon class=\"autocomplete__icon pr-2\" name=\"style-two-pin-marker\"></mlp-ng-icon>\n        {{ address.formatted_address }}\n    </li>\n\n    <li class=\"autocomplete__item autocomplete__item--close\" (click)=\"closeDropDown()\">\n        Close\n    </li>\n</ul>\n\n<mlp-ng-alerts [alerts]=\"alerts\" *ngIf=\"alerts\"></mlp-ng-alerts>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$5,
                        InputAddressLookUpService
                    ],
                    styles: ["@charset \"UTF-8\";:host{position:relative;display:block;width:100%}.autocomplete{width:100%;background-color:#fff;border:1px solid #eceeef;margin:0;padding:0;list-style-type:none;border-radius:.25rem;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);position:absolute;top:40px;left:0;z-index:4}.autocomplete__item{cursor:pointer;border-bottom:1px solid #eceeef;padding:.5rem .75rem;transition:background-color 250ms ease-in-out;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.autocomplete__item:hover{background-color:#eceeef}.autocomplete__item--close{padding:.25rem .75rem}.autocomplete__icon{color:#439fc2}"]
                }] }
    ];
    /** @nocollapse */
    InputAddressLookupSharedComponent.ctorParameters = function () { return [
        { type: InputAddressLookUpService }
    ]; };
    InputAddressLookupSharedComponent.propDecorators = {
        input: [{ type: Input }],
        errors: [{ type: Input }],
        country: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }]
    };
    return InputAddressLookupSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputAddressLookupSharedModule = /** @class */ (function () {
    function InputAddressLookupSharedModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    InputAddressLookupSharedModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: InputAddressLookupSharedModule,
            providers: [
                {
                    provide: AddressLookUpServiceConfig,
                    useValue: config
                }
            ]
        };
    };
    InputAddressLookupSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputAddressLookupSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        HttpClientModule,
                        AlertSharedModule,
                        InputSharedModule,
                        IconSharedModule
                    ],
                    exports: [
                        InputAddressLookupSharedComponent
                    ]
                },] }
    ];
    return InputAddressLookupSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$6 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(function () { return InputTimepickerSharedComponent; }),
    multi: true
};
var InputTimepickerSharedComponent = /** @class */ (function () {
    function InputTimepickerSharedComponent(config) {
        this.config = config;
        this.errors = [];
        this.time = { hour: 0, minute: 0, second: 0 };
        this.loaded = false;
        this.readonlyInputs = false;
        this.spinners = true;
        // tslint:disable-next-line:no-input-rename
        this._value = '';
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(InputTimepickerSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            for (var property in val) {
                if (val.hasOwnProperty(property) && typeof val[property] === 'string') {
                    val[property] = parseInt(val[property], 10);
                }
            }
            this.time = val;
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        /** @type {?} */
        var cal = changes['timerPicker'];
        if (cal && !cal.firstChange) {
            this.setConfiguration();
        }
    };
    /**
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setConfiguration();
        this.loaded = true;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.timeChanged = /**
     * @return {?}
     */
    function () {
        this.value = this.time;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @return {?}
     */
    InputTimepickerSharedComponent.prototype.setConfiguration = /**
     * @return {?}
     */
    function () {
        if (this.timerPicker && this.timerPicker.config) {
            Object.assign(this.config, this.timerPicker.config);
            if (typeof this.timerPicker.config.readonlyInputs !== 'undefined')
                this.readonlyInputs = this.timerPicker.config.readonlyInputs;
            if (typeof this.timerPicker.config.spinners !== 'undefined')
                this.spinners = this.timerPicker.config.spinners;
        }
    };
    InputTimepickerSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-input-timepicker',
                    template: "<ngb-timepicker *ngIf=\"loaded\" [(ngModel)]=\"time\" (ngModelChange)=\"timeChanged()\" [readonlyInputs]=\"readonlyInputs\" [spinners]=\"spinners\"></ngb-timepicker>\n<small class=\"form-text\" [ngClass]=\"{'sg-timepicker__error': errors.length }\" *ngFor=\"let error of errors\">{{ error.title }}</small>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$6,
                        NgbTimepickerConfig
                    ],
                    styles: ["@charset \"UTF-8\";ngb-timepicker ::ng-deep button{cursor:pointer}@media (max-width:767.98px){ngb-timepicker ::ng-deep input{width:3rem}}ngb-timepicker ::ng-deep .btn-link{color:#a3bc00}ngb-timepicker ::ng-deep .btn-outline-primary{color:#a3bc00;border-color:#a3bc00}ngb-timepicker ::ng-deep .btn-outline-primary:hover{background-color:#a3bc00;color:#fff}ngb-timepicker ::ng-deep .btn-outline-primary:focus{background-color:inherit;color:#cfef00}ngb-timepicker ::ng-deep td{vertical-align:middle}.sg-timepicker__error{color:#c80a0a}"]
                }] }
    ];
    /** @nocollapse */
    InputTimepickerSharedComponent.ctorParameters = function () { return [
        { type: NgbTimepickerConfig }
    ]; };
    InputTimepickerSharedComponent.propDecorators = {
        timerPicker: [{ type: Input }],
        errors: [{ type: Input }],
        _value: [{ type: Input, args: ['value',] }]
    };
    return InputTimepickerSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputTimepickerSharedModule = /** @class */ (function () {
    function InputTimepickerSharedModule() {
    }
    InputTimepickerSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InputTimepickerSharedComponent
                    ],
                    imports: [
                        FormsModule,
                        CommonModule,
                        NgbTimepickerModule.forRoot()
                    ],
                    exports: [
                        InputTimepickerSharedComponent
                    ]
                },] }
    ];
    return InputTimepickerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LocationSelectSharedComponent = /** @class */ (function () {
    function LocationSelectSharedComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.backgroundImage = '/assets/img/background1.jpg';
        this.options = [];
        this.logoSrc = '/assets/logo/pf_formerly_mlp.svg';
        this.logoAlt = 'logo';
        this.submitted = new EventEmitter();
        this.form = this.formBuilder.group({
            sport: [{
                    description: 'Select Sport',
                    icon: 'custom-sports',
                    data: null
                }, customSelectRequiredValidator()],
            location: ['', Validators.required]
        });
    }
    Object.defineProperty(LocationSelectSharedComponent.prototype, "sport", {
        get: /**
         * @return {?}
         */
        function () { return this.form.get('sport'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocationSelectSharedComponent.prototype, "location", {
        get: /**
         * @return {?}
         */
        function () { return this.form.get('location'); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    LocationSelectSharedComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        this.markFormControlsAsTouched(this.form);
        this.submitted.emit(this.form);
    };
    /**
     * In some cases form does not behave like it was submitted. We need to touch all form elements
     *
     * @param formGroup FormGroup
     */
    /**
     * In some cases form does not behave like it was submitted. We need to touch all form elements
     *
     * @param {?} formGroup FormGroup
     * @return {?}
     */
    LocationSelectSharedComponent.prototype.markFormControlsAsTouched = /**
     * In some cases form does not behave like it was submitted. We need to touch all form elements
     *
     * @param {?} formGroup FormGroup
     * @return {?}
     */
    function (formGroup) {
        Object.keys(formGroup.controls).forEach(function (field) {
            /** @type {?} */
            var control = formGroup.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    };
    LocationSelectSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-location-select',
                    template: "<div class=\"location-select position-relative\" [style.background-image]=\"'url(' + backgroundImage + ')'\">\n    <div class=\"container-fluid sg-py-1\">\n        <div class=\"row\">\n            <div class=\"col-12 col-md-6\"></div>\n            <div class=\"col-12\">\n\n                <div class=\"d-flex justify-content-center justify-content-md-end text-center\">\n                    <mlp-ng-jumbotron>\n                        <h1 class=\"sg-heading__h1 mb-0\">FIND YOUR PLAY</h1>\n                        <h1 class=\"sg-subheading__h1 mb-4 sg-mb-sm-1\">Book and play at over 7000 pitches and courts</h1>\n\n                        <form [formGroup]=\"form\" (submit)=\"submit()\">\n                            <div class=\"d-flex flex-column justify-content-center text-left sg-mb-1 px-3 sg-px-sm-1\">\n\n                                    <div class=\"mb-2\">\n                                        <mlp-ng-select formControlName=\"sport\" [options]=\"options\" shadow=\"1\" noBorder=\"1\" [errors]=\"sport.touched && !sport.valid ? [{title: 'Please select sport'}] : []\"></mlp-ng-select>\n                                    </div>\n\n                                    <div class=\"mb-2\">\n                                        <mlp-ng-input formControlName=\"location\" placeholder=\"Location\" inputStyle=\"secondary\" inputId=\"location\" icon=\"style-two-pin-marker\" iconSecondary=\"compass-direction\"\n                                                      [errors]=\"location.touched && !location.valid ? [{title: 'Please select location'}] : []\"></mlp-ng-input>\n                                    </div>\n\n                                    <mlp-ng-button-atom label=\"Find a \" labelSecondary=\"Venue\" fullWidth=\"1\" btnShadow=\"1\" btnType=\"submit\"></mlp-ng-button-atom>\n                            </div>\n                        </form>\n\n                        <img [src]=\"logoSrc\" [alt]=\"logoAlt\" class=\"d-none d-sm-inline\" />\n\n                    </mlp-ng-jumbotron>\n                </div>\n\n            </div>\n        </div>\n    </div>\n\n</div>\n",
                    styles: ["@charset \"UTF-8\";:host .location-select{background-size:cover;background-position:center}"]
                }] }
    ];
    /** @nocollapse */
    LocationSelectSharedComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    LocationSelectSharedComponent.propDecorators = {
        backgroundImage: [{ type: Input }],
        options: [{ type: Input }],
        logoSrc: [{ type: Input }],
        logoAlt: [{ type: Input }],
        submitted: [{ type: Output }]
    };
    return LocationSelectSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LocationSelectSharedModule = /** @class */ (function () {
    function LocationSelectSharedModule() {
    }
    LocationSelectSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LocationSelectSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        ButtonSharedModule,
                        InputSharedModule,
                        JumbotronSharedModule,
                        SelectSharedModule,
                    ],
                    exports: [
                        LocationSelectSharedComponent
                    ],
                },] }
    ];
    return LocationSelectSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NotificationListSharedComponent = /** @class */ (function () {
    function NotificationListSharedComponent() {
        this.event = new EventEmitter();
    }
    Object.defineProperty(NotificationListSharedComponent.prototype, "icon", {
        get: /**
         * @return {?}
         */
        function () {
            return this.typeData.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationListSharedComponent.prototype, "button", {
        get: /**
         * @return {?}
         */
        function () {
            return {
                label: this.typeData.label
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NotificationListSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.typeData = this.getType();
    };
    /**
     * @return {?}
     */
    NotificationListSharedComponent.prototype.getType = /**
     * @return {?}
     */
    function () {
        switch (this.data.status) {
            case 'info':
                return this.setInfo('info', this.data.icon);
            case 'warning':
                return this.setInfo('warning');
            default:
                return this.setInfo();
        }
    };
    /**
     * @param {?=} status
     * @param {?=} icon
     * @return {?}
     */
    NotificationListSharedComponent.prototype.setInfo = /**
     * @param {?=} status
     * @param {?=} icon
     * @return {?}
     */
    function (status, icon) {
        if (status === void 0) { status = ''; }
        if (icon === void 0) { icon = ''; }
        /** @type {?} */
        var name = 'check-circle';
        /** @type {?} */
        var color = '';
        if (status === 'warning') {
            name = 'exclamation-triangle';
            color = '-warning';
        }
        if (status === 'info') {
            name = icon;
            color = '-info';
        }
        return {
            name: name,
            color: color
        };
    };
    NotificationListSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-notification-list',
                    template: "<article class=\"sg-noti-list media\" [ngClass]=\"typeData.color\">\n    <mlp-ng-icon\n        class=\"d-flex align-self-center mr-3 sg-noti-list__icon\"\n        [ngClass]=\"typeData.color\"\n        [name]=\"icon\"></mlp-ng-icon>\n\n    <section class=\"media-body align-self-center\">\n        <p class=\"sg-noti-list__description mb-0\">{{ data.description }}</p>\n        <p class=\"sg-noti-list__description mb-0\"><small>{{ data.loggedAt | ngxAgo }} ago</small></p>\n    </section>\n</article>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{display:block}.sg-noti-list{border:1px solid #a3bc00;background-color:#f3f9d2;padding:.5rem .75rem;border-radius:.25rem}.sg-noti-list.-info,.sg-noti-list.-warning{background-color:#eceeef;border-color:#dfdfdf}.sg-noti-list__icon{color:#439fc2;width:30px}@media (min-width:768px){.sg-noti-list__icon{font-size:1.25rem}}.sg-noti-list__icon.-warning{color:#ffbf00}.sg-noti-list__description{line-height:1}"]
                }] }
    ];
    NotificationListSharedComponent.propDecorators = {
        data: [{ type: Input }],
        event: [{ type: Output }]
    };
    return NotificationListSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$4 = momentNs;
/** @type {?} */
var ZONE = 'Europe/London';
/**
 * Converts time string to how long ago
 *
 * __Usage :__
 *   time | ngxAgo: endTime
 *
 * __Example :__
 *   {{ '2017-01-01T15:00:00+00:00' | ngxAgo: '2017-01-02T15:00:00+00:00' }}
 *   formats to: 1 day
 *   {{ '2018-01-01T15:00:00+00:00' | ngxAgo }}
 *   formats to: 30 minutes
 *
 * Module {\@link TransformAgoModule}
 */
var TransformAgoPipe = /** @class */ (function () {
    function TransformAgoPipe() {
    }
    /**
     * @param {?} date
     * @param {?=} end
     * @return {?}
     */
    TransformAgoPipe.prototype.transform = /**
     * @param {?} date
     * @param {?=} end
     * @return {?}
     */
    function (date, end) {
        /** @type {?} */
        var endTime = (end) ? moment$4.tz(end, ZONE) : moment$4.tz(ZONE);
        /** @type {?} */
        var start = moment$4.tz(date, ZONE);
        /** @type {?} */
        var diffs = moment$4.duration(endTime.diff(start));
        return diffs.humanize();
    };
    TransformAgoPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ngxAgo'
                },] }
    ];
    return TransformAgoPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The TransformAgoModule module
 *
 * import { TransformAgoModule } from 'styleguide/src/shared/pipe/ago/pipe.ago.module';
 */
var TransformAgoModule = /** @class */ (function () {
    function TransformAgoModule() {
    }
    TransformAgoModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformAgoPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformAgoPipe
                    ]
                },] }
    ];
    return TransformAgoModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NotificationListSharedModule = /** @class */ (function () {
    function NotificationListSharedModule() {
    }
    NotificationListSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        NotificationListSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ButtonSharedModule,
                        IconSharedModule,
                        TransformAgoModule
                    ],
                    exports: [
                        NotificationListSharedComponent
                    ]
                },] }
    ];
    return NotificationListSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SocialBannerSharedComponent = /** @class */ (function () {
    function SocialBannerSharedComponent() {
        this.action = '//mylocalpitch.us7.list-manage.com/subscribe/post?u=a8becbd3c11bcdb30e3ca06cb&amp;id=c2e0463071';
        this.clickEvent = new EventEmitter();
    }
    /**
     * @param {?} item
     * @return {?}
     */
    SocialBannerSharedComponent.prototype.sendClickEvent = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.clickEvent.emit(item);
    };
    SocialBannerSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-social-banner',
                    template: "<div class=\"sg-social\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-12 col-lg-6 sg-social-links\">\n                <div class=\"row mx-2 mx-md-5 pt-1\">\n                    <div class=\"text-center mt-4 text-center\" *ngFor=\"let item of icons; let last = last;\" [ngClass]=\"item.className\">\n                        <a href=\"\" [href]=\"item.iconLink\" target=\"_blank\" [class.mr-5]=\"!last\" (click)=\"sendClickEvent(item)\">\n                            <mlp-ng-icon [name]=\"item.iconName\" size=\"large\"></mlp-ng-icon>\n                        </a>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-1 px-0 d-none d-lg-flex flex-row sg-social-links\">\n                <div class=\"w-100\"></div>\n                <div class=\"triangle-top-left\"></div>\n            </div>\n            <div class=\"col-12 col-lg-5 sg-social-newsletter\">\n                <form ngNoForm [action]=\"action\" method=\"POST\" target=\"_blank\">\n\n                <div class=\"text-center text-sm-left\">\n                    <div class=\"sg-heading__h4 my-2\">THE BEST EMAILS IN THE GAME</div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-8 col-lg-7 col-xl-8 mb-2 pb-1\">\n                        <mlp-ng-input placeholder=\"Email\" inputName=\"EMAIL\" inputId=\"newsletter\"></mlp-ng-input>\n                    </div>\n                    <div class=\"col-12 col-sm-4 col-lg-5 col-xl-4 mb-2 pb-1 text-nowrap\">\n                        <div class=\"d-none d-sm-flex\">\n                            <mlp-ng-button-atom label=\"Sign up\" btnType=\"submit\" btnStyle=\"secondary\"></mlp-ng-button-atom>\n                        </div>\n                        <div class=\"d-sm-none\">\n                            <mlp-ng-button-atom label=\"Sign up\" btnType=\"submit\" fullWidth=\"1\" btnStyle=\"secondary\"></mlp-ng-button-atom>\n                        </div>\n                    </div>\n                </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";@media (max-width:991.98px){.sg-social .container{width:100%;max-width:none}}.sg-social .sg-social-links{background-color:#56e07b;height:102px}.sg-social .sg-social-newsletter{color:#fff;background-color:#2f285a}@media (min-width:992px){.sg-social{background:linear-gradient(90deg,#56e07b 50%,#2f285a 50%)}.sg-social .sg-social-newsletter{height:102px}}.sg-social .triangle-top-left{width:100%;height:0;border-bottom:102px solid #2f285a;border-left:59px solid transparent}"]
                }] }
    ];
    SocialBannerSharedComponent.propDecorators = {
        icons: [{ type: Input }],
        action: [{ type: Input }],
        clickEvent: [{ type: Output }]
    };
    return SocialBannerSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SocialBannerSharedModule = /** @class */ (function () {
    function SocialBannerSharedModule() {
    }
    SocialBannerSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SocialBannerSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ButtonSharedModule,
                        IconSharedModule,
                        InputSharedModule,
                    ],
                    exports: [
                        SocialBannerSharedComponent
                    ]
                },] }
    ];
    return SocialBannerSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubHeaderSharedComponent = /** @class */ (function () {
    function SubHeaderSharedComponent() {
        this.dropdownStatus = new EventEmitter();
        this.nav$ = new BehaviorSubject(undefined);
        this.showDropdown = false;
    }
    /**
     * @return {?}
     */
    SubHeaderSharedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.nav$.next(this.section.nav);
    };
    /**
     * @param {?} status
     * @return {?}
     */
    SubHeaderSharedComponent.prototype.toggleDropdown = /**
     * @param {?} status
     * @return {?}
     */
    function (status) {
        this.showDropdown = status;
        this.dropdownStatus.emit(status);
    };
    /**
     * @return {?}
     */
    SubHeaderSharedComponent.prototype.closeAll = /**
     * @return {?}
     */
    function () {
        this.toggleDropdown(false);
        this.section.nav.showMenu = false;
        this.nav$.next(__assign({}, this.section.nav));
    };
    SubHeaderSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-sub-section',
                    template: "<section class=\"sub-section\">\n\n    <div class=\"container\">\n\n        <h3 class=\"sub-section__title\" *ngIf=\"section?.title\">{{ section?.title }}</h3>\n\n        <mlp-ng-sub-nav \n            [links]=\"nav$ | async\" \n            class=\"d-md-inline-block text-right text-md-left\" \n            (toggleDropdown)=\"toggleDropdown($event)\"></mlp-ng-sub-nav>\n\n    </div>\n\n    <mlp-ng-nav-dropdown\n        (linkClicked)=\"closeAll()\"\n        [ngClass]=\"{ 'd-md-none': !section.subNavLinks }\"\n        class=\"sub-section__dropdown\" \n        [links]=\"(section.subNavLinks) ? section.subNavLinks : section.nav.mainLinks\" \n        *ngIf=\"showDropdown\"></mlp-ng-nav-dropdown>\n\n</section>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@charset \"UTF-8\";:host{position:relative;display:block}.sub-section__title{font-family:\"Frank New\",sans-serif;font-weight:700;font-style:italic;color:#56e07b;font-size:1.25rem;float:left;text-transform:lowercase}@media (min-width:768px){.sub-section__title{float:none;display:inline-block;margin-right:1.5rem}.sub-section__dropdown{top:60px}}@media (min-width:992px){.sub-section__title{margin-right:2.5rem}}"]
                }] }
    ];
    SubHeaderSharedComponent.propDecorators = {
        section: [{ type: Input }],
        dropdownStatus: [{ type: Output }]
    };
    return SubHeaderSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SubSectionSharedModule = /** @class */ (function () {
    function SubSectionSharedModule() {
    }
    SubSectionSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SubHeaderSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        IconSharedModule,
                        SubNavSharedModule,
                        NavDropdownSharedModule
                    ],
                    exports: [
                        SubHeaderSharedComponent
                    ]
                },] }
    ];
    return SubSectionSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PasswordStrength = /** @class */ (function () {
    function PasswordStrength() {
    }
    /**
     * @param {?} password
     * @return {?}
     */
    PasswordStrength.prototype.calculate = /**
     * @param {?} password
     * @return {?}
     */
    function (password) {
        /** @type {?} */
        var strength = 0;
        if (!password) {
            return 0;
        }
        if (password.length > 8) { // check if more than 8 characters
            // check if more than 8 characters
            strength += 25;
        }
        if (password.match(/(?=.*[0-9])/g)) { // check if contains numbers
            // check if contains numbers
            strength += 25;
        }
        if (password.match(/(?=.*[a-z])(?=.*[A-Z])/g)) { // check if contains lower and uppercase
            // check if contains lower and uppercase
            strength += 25;
        }
        if (password.match(/(?=.*[-+_!@#$%^&*.,?])/g)) { // check if contains special characters
            // check if contains special characters
            strength += 25;
        }
        return strength;
    };
    return PasswordStrength;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var INPUT_CUSTOM_INPUT_ACCESSOR$7 = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(function () { return PasswordStrengthSharedComponent; }),
    multi: true
};
var PasswordStrengthSharedComponent = /** @class */ (function (_super) {
    __extends(PasswordStrengthSharedComponent, _super);
    function PasswordStrengthSharedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line:no-input-rename
        _this._value = '';
        _this.showStrengthBar = false;
        _this.passwordStrength = new PasswordStrength();
        _this.strength = 0;
        _this.onChange = function () { };
        _this.onTouched = function () { };
        return _this;
    }
    Object.defineProperty(PasswordStrengthSharedComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.strength = this.passwordStrength.calculate(val);
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    PasswordStrengthSharedComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PasswordStrengthSharedComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PasswordStrengthSharedComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    // articulate: articulate a value using expressions in array
    // 0 - 25: use first word
    // 25 - 75: use second word
    // 75 - 100: use third word
    /**
     * @param {?} value
     * @param {?} expressions
     * @return {?}
     */
    PasswordStrengthSharedComponent.prototype.articulate = /**
     * @param {?} value
     * @param {?} expressions
     * @return {?}
     */
    function (value, expressions) {
        if (value > 25 && value <= 75) {
            return expressions[1];
        }
        if (value > 75) {
            return expressions[2];
        }
        return expressions[0];
    };
    PasswordStrengthSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-password-strength',
                    template: "<mlp-ng-password\n    [inputId]=\"inputId\"\n    [inputName]=\"inputName\"\n    [inputStyle]=\"inputStyle\"\n    [inputDisabled]=\"inputDisabled\"\n    [placeholder]=\"placeholder\"\n    [icon]=\"icon\"\n    [loading]=\"loading\"\n    [input]=\"input\"\n    [errors]=\"errors\"\n    (blur)=\"blur.emit()\"\n    (focus)=\"focus.emit()\"\n    [(ngModel)]=\"value\"\n></mlp-ng-password>\n\n<div class=\"d-flex justify-items-center mt-1 password-strength\" *ngIf=\"value || showStrengthBar\">\n    <mlp-ng-progress-bar\n        class=\"w-100 mr-2 mt-2\"\n        [progress]=\"strength\"\n        [barStyle]=\"\n            articulate(strength, [\n                'danger',\n                'warn',\n                'secondary'\n            ])\n        \"\n    ></mlp-ng-progress-bar>\n\n    <div class=\"d-flex text-uppercase password-strength__label\">\n        {{ articulate(strength, [\"weak\", \"medium\", \"strong\"]) }}\n        <mlp-ng-icon\n            class=\"ml-2\"\n            name=\"custom-question-circle\"\n            placement=\"left\"\n            ngbPopover=\"Password should contain at least 8 characters, at least one lower case and upper case letter, a digit and special character.\"\n        ></mlp-ng-icon>\n    </div>\n</div>\n",
                    providers: [
                        INPUT_CUSTOM_INPUT_ACCESSOR$7
                    ],
                    styles: ["@charset \"UTF-8\";:host .progress-bar__label{margin-top:.1875rem;font-weight:500;font-size:.75rem}"]
                }] }
    ];
    PasswordStrengthSharedComponent.propDecorators = {
        _value: [{ type: Input, args: ['value',] }],
        showStrengthBar: [{ type: Input }]
    };
    return PasswordStrengthSharedComponent;
}(PasswordSharedComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PasswordStrengthSharedModule = /** @class */ (function () {
    function PasswordStrengthSharedModule() {
    }
    PasswordStrengthSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PasswordStrengthSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgbPopoverModule,
                        IconSharedModule,
                        PasswordSharedModule,
                        ProgressBarSharedModule
                    ],
                    exports: [
                        PasswordStrengthSharedComponent
                    ]
                },] }
    ];
    return PasswordStrengthSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} control
 * @return {?}
 */
function pfCreditCardValidator(control) {
    /** @type {?} */
    var valid = number(control.value);
    return valid.isValid || valid.isPotentiallyValid ? null : { cardNumber: { valid: false } };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CreditCardFormSharedComponent = /** @class */ (function () {
    function CreditCardFormSharedComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.description = [
            'Please choose your payment method and add your card information.',
            'Playfinder accepts all major credit and debit cards'
        ];
        this.inputStyle = 'primary';
        this.path = '/assets/img/';
        this.add = new EventEmitter();
        this.cancel = new EventEmitter();
        this.errors = {
            cc: [{ title: 'Wrong card number' }],
            expiry: [{ title: 'Wrong expiry date' }],
        };
        this.form = this.formBuilder.group({
            cc: ['', pfCreditCardValidator],
            name: [''],
            expiry: ['', Validators.pattern(/\d{2}\/\d{2}/)],
            security: [''],
            zip: [''],
            save: [true],
            default: [false]
        });
    }
    /**
     * @return {?}
     */
    CreditCardFormSharedComponent.prototype.submitCard = /**
     * @return {?}
     */
    function () {
        if (this.form.valid && this.form.value.cc && this.form.value.name && this.form.value.expiry && this.form.value.security) {
            this.add.emit(this.form.value);
        }
    };
    CreditCardFormSharedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mlp-ng-credit-card-form',
                    template: "<form [formGroup]=\"form\" (ngSubmit)=\"submitCard()\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col px-0\">\n                <h3 class=\"sg-heading__h3 text-uppercase mb-3\">Add new card</h3>\n                <p *ngFor=\"let paragraph of description\" class=\"mb-1\">{{ paragraph }}</p>\n            </div>\n        </div>\n\n        <div class=\"row my-4\">\n            <div class=\"col px-0\">\n                <mlp-ng-credit-card formControlName=\"cc\" [inputStyle]=\"inputStyle\" placeholder=\"Card Number\"\n                    [errors]=\"form.controls['cc'].valid ? [] : errors.cc\"\n                ></mlp-ng-credit-card>\n            </div>\n        </div>\n\n        <div class=\"row my-4\">\n            <div class=\"col pl-0\">\n                <mlp-ng-expiry formControlName=\"expiry\" [inputStyle]=\"inputStyle\" placeholder=\"Expiry date   MM/YY\"\n                    [errors]=\"form.controls['expiry'].valid ? [] : errors.expiry\"\n                ></mlp-ng-expiry>\n            </div>\n\n            <div class=\"col\">\n                <mlp-ng-input-tooltip formControlName=\"security\" [inputStyle]=\"inputStyle\" placeholder=\"Security Code\"\n                    inputType=\"tel\" [tooltipTemplate]=\"security\"\n                ></mlp-ng-input-tooltip>\n            </div>\n\n            <div class=\"col pr-0\">\n                <mlp-ng-input-tooltip formControlName=\"zip\" [inputStyle]=\"inputStyle\" placeholder=\"ZIP/Post Code\"\n                    [tooltipTemplate]=\"zip\"\n                ></mlp-ng-input-tooltip>\n            </div>\n        </div>\n\n        <div class=\"row my-4\">\n            <div class=\"col px-0\">\n                <mlp-ng-input formControlName=\"name\" [inputStyle]=\"inputStyle\" placeholder=\"Name on Card\"></mlp-ng-input>\n            </div>\n        </div>\n\n        <div class=\"row my-4\">\n            <div class=\"col pl-0\">\n                <mlp-ng-shared-checkbox size=\"small\" formControlName=\"save\">Save card for faster checkout</mlp-ng-shared-checkbox>\n            </div>\n\n            <div class=\"col pr-0\">\n                <mlp-ng-shared-checkbox size=\"small\" formControlName=\"default\">Set as default card</mlp-ng-shared-checkbox>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col px-0 text-right\">\n                <a class=\"mr-4\" (click)=\"cancel.emit()\">\n                    <mlp-ng-button-atom label=\"Cancel\" btnStyle=\"tertiary\"></mlp-ng-button-atom>\n                </a>\n\n                <mlp-ng-button-atom btnType=\"submit\" labelSecondary=\"Add Card\" [disabled]=\"!(this.form.valid && this.form.value.cc && this.form.value.name && this.form.value.expiry && this.form.value.security)\"></mlp-ng-button-atom>\n            </div>\n        </div>\n    </div>\n</form>\n\n<ng-template #security>\n    <h6 class=\"sg-heading__h6 text-left mb-0 mt-1 sg-color -secondary\">Visa, MasterCard, Digits</h6>\n    <p class=\"small mb-1 text-left\">The last <strong>3 digits</strong> on the back of your card.</p>\n\n    <h6 class=\"sg-heading__h6 text-left mb-0 sg-color -secondary\">American Express</h6>\n    <p class=\"small mb-1 text-left\">The <strong>4 digits</strong> above your card number.</p>\n\n    <div class=\"tooltip-cards text-left mb-2\">\n        <img [src]=\"path + 'tootip-visa-back.svg'\" class=\"mr-2\" alt=\"Visa\" />\n\n        <img [src]=\"path + 'tootip-american-front.svg'\" class=\"\" alt=\"American Express\" />\n    </div>\n</ng-template>\n\n<ng-template #zip>\n    <p class=\"small my-1 text-left\">Enter the ZIP/Postcode for your credit card\u2019s billing address</p>\n</ng-template>\n",
                    styles: [":host .tooltip-cards{height:40px}"]
                }] }
    ];
    /** @nocollapse */
    CreditCardFormSharedComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    CreditCardFormSharedComponent.propDecorators = {
        description: [{ type: Input }],
        inputStyle: [{ type: Input }],
        path: [{ type: Input }],
        add: [{ type: Output }],
        cancel: [{ type: Output }]
    };
    return CreditCardFormSharedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var CreditCardFormSharedModule = /** @class */ (function () {
    function CreditCardFormSharedModule() {
    }
    CreditCardFormSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        CreditCardFormSharedComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        NgbDropdownModule,
                        ButtonSharedModule,
                        CheckBoxSharedModule,
                        IconSharedModule,
                        InputSharedModule,
                        InputTooltipSharedModule,
                        CreditCardSharedModule,
                        ExpirySharedModule
                    ],
                    exports: [
                        CreditCardFormSharedComponent
                    ]
                },] }
    ];
    return CreditCardFormSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Animates show/hide router
 *
 * \@example
 * [\@fadeInAnimation]="true"
 *
  @type {?} */
var fadeInAnimation = trigger('fadeInAnimation', [
    transition(':enter', [
        // styles at start of transition
        style({ opacity: 0 }),
        // animation and styles at end of transition
        animate(ANIMATIONS.speed.default, style({ opacity: 1 }))
    ])
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Animates the :enter event of ngFor
 *
 * \@example
 * [\@ngForAnimation]="data.length"
 *
  @type {?} */
var enterSlideUpAnimation = trigger('ngForAnimation', [
    transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger(ANIMATIONS.speed.default, [
            animate(ANIMATIONS.speed.slow + " " + ANIMATIONS.bezierCurve.default, keyframes([
                style({ opacity: 0, transform: 'translateY(10%)' }),
                style({ opacity: .5, transform: 'translateY(35px)' }),
                style({ opacity: 1, transform: 'translateY(0)' })
            ]))
        ]), { optional: true })
    ])
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function uniqueId() {
    /** @type {?} */
    var text = '';
    /** @type {?} */
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
var ConfigureService = /** @class */ (function () {
    function ConfigureService(http) {
        this.http = http;
        this.configFile = 'config.json';
        this.paramsLoaded = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ConfigureService.prototype.load = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return this.http.get(this.configFile + "?t=" + uniqueId())
            .toPromise()
            .then(function (params) {
            _this.params = params;
            _this.paramsLoaded.emit(params);
        }, function () {
            throw new Error(_this.configFile + " could not be loaded / found");
        });
    };
    ConfigureService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ConfigureService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return ConfigureService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ConfigureModule = /** @class */ (function () {
    function ConfigureModule() {
    }
    /**
     * @return {?}
     */
    ConfigureModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: ConfigureModule,
            providers: [ConfigureService]
        };
    };
    ConfigureModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        HttpClientModule
                    ],
                    declarations: [],
                    providers: [
                        ConfigureService,
                        {
                            provide: APP_INITIALIZER,
                            useFactory: init,
                            multi: true,
                            deps: [ConfigureService]
                        }
                    ]
                },] }
    ];
    return ConfigureModule;
}());
/**
 * @param {?} configService
 * @return {?}
 */
function init(configService) {
    return function () { return configService.load(); };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InfiniteScrollService = /** @class */ (function () {
    function InfiniteScrollService(windowRef, document) {
        this.windowRef = windowRef;
        this.document = document;
        this.loadMore = new Subject();
        this.loadMore$ = this.loadMore;
    }
    /**
     * @param {?} offset
     * @param {?} offsetElements
     * @return {?}
     */
    InfiniteScrollService.prototype.createScrollWatcher = /**
     * @param {?} offset
     * @param {?} offsetElements
     * @return {?}
     */
    function (offset, offsetElements) {
        var _this = this;
        /** @type {?} */
        var scroll$ = fromEvent(this.windowRef.nativeWindow, 'scroll', { passive: true }).pipe(map(function () {
            /** @type {?} */
            var removeHeight = offset;
            offsetElements.map(function (el) {
                /** @type {?} */
                var element = _this.document.querySelector(el);
                if (element)
                    removeHeight = removeHeight + element.offsetHeight;
            });
            /** @type {?} */
            var toBottom = _this.getDistFromBottom(removeHeight);
            return toBottom;
        }), pairwise(), filter(function (data) { return data[1] < data[0]; }), filter(function (data) { return data[1] === 0; }), distinctUntilChanged(), debounceTime(100));
        this.scrollSub$ = scroll$.subscribe(function (data) {
            _this.loadMore.next(true);
        });
    };
    /**
     * @return {?}
     */
    InfiniteScrollService.prototype.destroyScrollWatcher = /**
     * @return {?}
     */
    function () {
        this.scrollSub$.unsubscribe();
    };
    /**
     * @param {?} deduct
     * @return {?}
     */
    InfiniteScrollService.prototype.getDistFromBottom = /**
     * @param {?} deduct
     * @return {?}
     */
    function (deduct) {
        /** @type {?} */
        var scrollPosition = this.windowRef.nativeWindow.pageYOffset;
        /** @type {?} */
        var windowSize = this.windowRef.nativeWindow.innerHeight;
        /** @type {?} */
        var bodyHeight = this.document.body.offsetHeight;
        return Math.max((bodyHeight - deduct) - (scrollPosition + windowSize), 0);
    };
    InfiniteScrollService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    InfiniteScrollService.ctorParameters = function () { return [
        { type: WindowRefService },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    return InfiniteScrollService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InfiniteScrollDirective = /** @class */ (function () {
    function InfiniteScrollDirective(infinScrService) {
        this.infinScrService = infinScrService;
        this.infiniteScrOffset = 0;
    }
    /**
     * @return {?}
     */
    InfiniteScrollDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.infinScrService.createScrollWatcher(this.infiniteScrOffset, this.infiniteScrOffsetElements);
    };
    InfiniteScrollDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ngxInfiniteScroll]'
                },] }
    ];
    /** @nocollapse */
    InfiniteScrollDirective.ctorParameters = function () { return [
        { type: InfiniteScrollService }
    ]; };
    InfiniteScrollDirective.propDecorators = {
        infiniteScrOffsetElements: [{ type: Input }],
        infiniteScrOffset: [{ type: Input }]
    };
    return InfiniteScrollDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InfiniteScrollSharedDirectiveModule = /** @class */ (function () {
    function InfiniteScrollSharedDirectiveModule() {
    }
    InfiniteScrollSharedDirectiveModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        InfiniteScrollDirective
                    ],
                    imports: [],
                    exports: [
                        InfiniteScrollDirective
                    ],
                    providers: [
                        WindowRefService,
                        InfiniteScrollService
                    ]
                },] }
    ];
    return InfiniteScrollSharedDirectiveModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} arr
 * @param {?} depth
 * @return {?}
 */
function sortAlphanumericArray(arr, depth) {
    return arr.sort(function (a, b) {
        /** @type {?} */
        var valueA = a;
        /** @type {?} */
        var valueB = b;
        depth.forEach(function (val) {
            valueA = valueA[val];
            valueB = valueB[val];
            if (typeof (valueA) === 'undefined') {
                throw new Error("cannot find object with depth \"" + val + "\"");
            }
        });
        /** @type {?} */
        var nameA = isNumeric(valueA) ? valueA.toLocaleString() : valueA.toLowerCase();
        /** @type {?} */
        var nameB = isNumeric(valueB) ? valueB.toLocaleString() : valueB.toLowerCase();
        if (nameA < nameB) {
            return -1; // sort string ascending
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/*
 * https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 * This is MLP email address Regular Expression.
 *
 * Usage:
 *    import { EMAIL } from './validators.expressions';
 *
 * Example:
 *    const TEST = new RegExp(EMAIL)
*/
/** @type {?} */
var EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/** @type {?} */
var DOUBLEAT = /^@$/g;
/** @type {?} */
var PHONENUMBER = /^[(]?(\+[\d]{1,3}\s?)?[\d ()]{7,}$/g;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function mlpEmailValidator() {
    return function (control) {
        /** @type {?} */
        var hasRegExp;
        /** @type {?} */
        var EMAILMATCH = (control.value) ? control.value.match(EMAIL) : undefined;
        /** @type {?} */
        var DOUBLEATMATCH = (control.value) ? control.value.match(DOUBLEAT) : undefined;
        if (EMAILMATCH)
            hasRegExp = true;
        if (EMAILMATCH && DOUBLEATMATCH && DOUBLEATMATCH.length) {
            hasRegExp = (DOUBLEATMATCH.length >= 2) ? true : false;
        }
        return hasRegExp ? undefined : { invalidEmail: { value: control.value } };
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function mlpPhoneNumberValidator() {
    return function (control) {
        /** @type {?} */
        var isValid = false;
        /** @type {?} */
        var data = control.value;
        if (data && data.match(PHONENUMBER)) {
            isValid = true;
        }
        return isValid ? undefined : { invalidPhoneNumber: { value: data } };
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * @return {?}
 */
function customNotEmptySpaceValidator() {
    return function (control) {
        if (isEmptyInputValue(control.value)) {
            return null; // don't validate empty values to allow optional controls
        }
        if (control.value.replace(/ +(?= )/g, '') === ' ') {
            return { notEmptySpace: true };
        }
        return null;
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var V_EMAIL = {
    requirements: [Validators.required, mlpEmailValidator()],
    errorMessage: ['the field must contain a valid email address']
};
/** @type {?} */
var V_PHONE_NUMBER = {
    requirements: [Validators.required, mlpPhoneNumberValidator()],
    errorMessage: ['A phone number can only contain 0-9 + ( ) and minimum 7 characters']
};
/** @type {?} */
var V_FULL_NAME = {
    requirements: [Validators.required],
    errorMessage: ['This field is required']
};
/** @type {?} */
var V_PASSWORD = {
    requirements: [Validators.required],
    errorMessage: ['This field is required']
};
/** @type {?} */
var V_PASSWORD_REPEAT = {
    requirements: [Validators.required],
    errorMessage: ['This field needs to be the same as your password field']
};
/** @type {?} */
var V_GUEST_CHECKOUT = {
    requirements: [],
    errorMessage: ['We need your details for your account and any bookings you make.']
};
/** @type {?} */
var V_GUEST_CHECKOUT_FULL_NAME = {
    requirements: [],
    errorMessage: ['This field is required']
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Pitch = /** @class */ (function () {
    function Pitch() {
        this.type = 'pitches';
    }
    return Pitch;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Venue = /** @class */ (function () {
    function Venue() {
        this.type = 'venues';
    }
    return Venue;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Converts and interger(minutes) to text time
 *
 * __Usage :__
 *   value | durationToText
 *
 * __Example :__
 *   {{ 90 |  durationToText }}
 *   formats to: 1 hour 30 minutes
 *   {{ 90 |  durationToText:true }}
 *   formats to: 1h 30m
 *
 * Module {\@link TransformDurationToTextModule}
 */
var TransformDurationToTextPipe = /** @class */ (function () {
    function TransformDurationToTextPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} short
     * @return {?}
     */
    TransformDurationToTextPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} short
     * @return {?}
     */
    function (value, short) {
        if (short === void 0) { short = false; }
        /** @type {?} */
        var returnText = '';
        if (value) {
            /** @type {?} */
            var hours = Math.floor(value / 60);
            /** @type {?} */
            var minutes = value % 60;
            if (hours > 0) {
                /** @type {?} */
                var hoursSyntax = short ? 'h ' : (hours === 1 ? ' hour ' : ' hours ');
                returnText = hours + hoursSyntax;
            }
            if (minutes > 0) {
                /** @type {?} */
                var minutesSyntax = short ? 'm' : (minutes === 1 ? ' minute' : ' minutes');
                returnText = returnText + minutes + minutesSyntax;
            }
        }
        return returnText.trim();
    };
    TransformDurationToTextPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'durationToText'
                },] }
    ];
    return TransformDurationToTextPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The TransformDurationToText module
 *
 * import { TransformDurationToTextModule } from 'styleguide/src/shared/pipe/transform-duration-to-text.module';
 */
var TransformDurationToTextModule = /** @class */ (function () {
    function TransformDurationToTextModule() {
    }
    TransformDurationToTextModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformDurationToTextPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformDurationToTextPipe
                    ]
                },] }
    ];
    return TransformDurationToTextModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TransformCamelCaseEsportsPipe = /** @class */ (function () {
    function TransformCamelCaseEsportsPipe() {
    }
    /**
     * @param {?} str
     * @return {?}
     */
    TransformCamelCaseEsportsPipe.prototype.transform = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        if (str === null)
            return '';
        if (str.toLowerCase() === 'esports')
            return 'eSports';
        if (str.toLowerCase() === 'esport')
            return 'eSport';
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    TransformCamelCaseEsportsPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ngxCamelCaseEsports'
                },] }
    ];
    return TransformCamelCaseEsportsPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TransformCamelCaseEsportsModule = /** @class */ (function () {
    function TransformCamelCaseEsportsModule() {
    }
    TransformCamelCaseEsportsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformCamelCaseEsportsPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformCamelCaseEsportsPipe
                    ]
                },] }
    ];
    return TransformCamelCaseEsportsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TransformCapitalizeFirstPipe = /** @class */ (function () {
    function TransformCapitalizeFirstPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    TransformCapitalizeFirstPipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value === null)
            return 'Not assigned';
        return value.charAt(0).toUpperCase() + value.slice(1);
    };
    TransformCapitalizeFirstPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'ngxCapitalizeFirst'
                },] }
    ];
    return TransformCapitalizeFirstPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * The TransformAgoModule module
 *
 * import { TransformAgoModule } from 'styleguide/src/shared/pipe/capitalizeFirstLetter/pipe.capitalize.first.letter.module';
 */
var TransformCapitalizeFirstModule = /** @class */ (function () {
    function TransformCapitalizeFirstModule() {
    }
    TransformCapitalizeFirstModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformCapitalizeFirstPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        TransformCapitalizeFirstPipe
                    ]
                },] }
    ];
    return TransformCapitalizeFirstModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TransformSportIconModule = /** @class */ (function () {
    function TransformSportIconModule() {
    }
    TransformSportIconModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TransformSportToIconNamePipe
                    ],
                    exports: [
                        TransformSportToIconNamePipe
                    ]
                },] }
    ];
    return TransformSportIconModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Transforms api data into relationships from includes
 *
 * __Example :__
 *   this.http.get('/endpoint?&include=pitch,staffMember')
 *   .map(data => this.transformer.mapOneInCollection(data, [{ pitch: 'pitches' }, { staffMember: 'staff-members' }]))
 *
 */
var  /**
 * Transforms api data into relationships from includes
 *
 * __Example :__
 *   this.http.get('/endpoint?&include=pitch,staffMember')
 *   .map(data => this.transformer.mapOneInCollection(data, [{ pitch: 'pitches' }, { staffMember: 'staff-members' }]))
 *
 */
TransformApiData = /** @class */ (function () {
    function TransformApiData() {
    }
    /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    TransformApiData.prototype.mapOne = /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    function (apiData, relationshipToType) {
        relationshipToType.forEach(function (relationshipKeyValue) {
            Object.keys(relationshipKeyValue).forEach(function (relKeyName) {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.included.forEach(function (includedData) {
                        if (apiData.data.relationships[relKeyName].data &&
                            apiData.data.relationships[relKeyName].data.id === includedData.id &&
                            includedData.type === relationshipKeyValue[relKeyName]) {
                            apiData.data.relationships[relKeyName].data = includedData;
                        }
                    });
                }
            });
        });
        return apiData;
    };
    /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    TransformApiData.prototype.mapArray = /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    function (apiData, relationshipToType) {
        relationshipToType.forEach(function (relationshipKeyValue) {
            Object.keys(relationshipKeyValue).forEach(function (relKeyName) {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.data.relationships[relKeyName].data.forEach(function (relationshipKey, key) {
                        apiData.included.forEach(function (includedData) {
                            if (apiData.data.relationships[relKeyName].data[key] &&
                                apiData.data.relationships[relKeyName].data[key].id === includedData.id &&
                                includedData.type === relationshipKeyValue[relKeyName]) {
                                apiData.data.relationships[relKeyName].data[key] = includedData;
                            }
                        });
                    });
                }
            });
        });
        return apiData;
    };
    /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    TransformApiData.prototype.mapOneInCollection = /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    function (apiData, relationshipToType) {
        relationshipToType.forEach(function (relationshipKeyValue) {
            Object.keys(relationshipKeyValue).forEach(function (relKeyName) {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.data.forEach(function (entity) {
                        apiData.included.forEach(function (includedData) {
                            if (entity.relationships[relKeyName].data &&
                                entity.relationships[relKeyName].data.id === includedData.id &&
                                includedData.type === relationshipKeyValue[relKeyName]) {
                                entity.relationships[relKeyName].data = includedData;
                            }
                        });
                    });
                }
            });
        });
        return apiData;
    };
    /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    TransformApiData.prototype.mapArrayInCollection = /**
     * @param {?} apiData
     * @param {?} relationshipToType
     * @return {?}
     */
    function (apiData, relationshipToType) {
        relationshipToType.forEach(function (relationshipKeyValue) {
            Object.keys(relationshipKeyValue).forEach(function (relKeyName) {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.data.forEach(function (entity) {
                        entity.relationships[relKeyName].data.forEach(function (relationshipKey, key) {
                            apiData.included.forEach(function (includedData) {
                                if (entity.relationships[relKeyName].data[key] &&
                                    entity.relationships[relKeyName].data[key].id === includedData.id &&
                                    includedData.type === relationshipKeyValue[relKeyName]) {
                                    entity.relationships[relKeyName].data[key] = includedData;
                                }
                            });
                        });
                    });
                }
            });
        });
        return apiData;
    };
    return TransformApiData;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { BadgeSharedModule, BadgeSharedComponent, ButtonSharedModule, ButtonSharedComponent, ButtonAtomSharedComponent, CheckBoxSharedComponent, CheckBoxSharedModule, DaySharedModule, DaySharedComponent, IconSharedModule, IconSharedComponent, ImageSharedModule, ImageSharedComponent, InputAtomSharedModule, InputAtomSharedComponent, LabelSharedModule, LabelSharedComponent, ListSharedModule, ListSharedComponent, RadioSharedModule, RadioSharedComponent, SelectAtomSharedModule, SelectAtomSharedComponent, TextButtonInternalAtomSharedModule, TextButtonExternalAtomSharedModule, TextButtonInternalAtomSharedComponent, TextButtonExternalAtomSharedComponent, SpinnerSharedModule, SpinnerSharedComponent, ProgressBarSharedModule, ProgressBarSharedComponent, ButtonSocialSharedModule, ButtonSocialSharedComponent, AccordionSharedModule, AccordionComponent, AccordionContainerSharedModule, AccordionContainerComponent, AddToCalendarSharedModule, AddToCalendarSharedComponent, AlertService, AlertSharedModule, AlertsSharedComponent, AlertSharedComponent, ButtonNavSharedModule, ButtonNavSharedComponent, ChipSharedModule, ChipSharedComponent, FooterNavSharedModule, FooterNavSharedComponent, GridNavService, GridNavSharedModule, GridNavSharedComponent, IconNavSharedModule, IconNavSharedComponent, InputSharedModule, InputSharedComponent, InputTooltipSharedModule, InputTooltipSharedComponent, JumbotronSharedModule, JumbotronSharedComponent, LoadingSharedModule, LoadingSharedComponent, ModalService, ModalSharedModule, ModalSharedComponent, ModalSecondarySharedComponent, NavDropdownSharedModule, NavDropdownSharedComponent, SelectSharedModule, SelectSharedComponent, SearchFiltersSharedModule, SearchFiltersSharedComponent, SlotService, SlotSharedModule, SlotSharedComponent, SportSharedModule, SportSharedComponent, StatusSharedModule, StatusSharedComponent, SubNavSharedModule, SubNavSharedComponent, SubNavHorizontalSharedModule, SubNavHorizontalSharedComponent, SubNavVerticalSharedModule, SubNavVerticalSharedComponent, TabsSharedModule, TabsSharedComponent, TextButtonExternalSharedModule, TextButtonInternalSharedModule, TextButtonExternalSharedComponent, TextButtonInternalSharedComponent, TextNavSharedModule, TextNavSharedComponent, TextSliderSharedModule, TextSliderSharedComponent, TileSharedModule, TileSharedComponent, TooltipSharedModule, HeadlineSharedModule, HeadlineSharedComponent, PasswordSharedModule, PasswordSharedComponent, CreditCardSharedModule, CreditCardSharedComponent, CreditCardListElementSharedModule, CreditCardListElementSharedComponent, ExpirySharedModule, ExpirySharedComponent, PromptSharedModule, PromptSharedComponent, PromptService, AppBannerSharedModule, AppBannerSharedComponent, CalendarSharedModule, CalendarDataService, CalendarSharedComponent, CalendarSlideService, CalendarEventService, CalendarProcessService, CardSimpleSharedModule, CardSimpleSharedComponent, CardSharedModule, CardSharedComponent, CardPlainSharedComponent, CarouselService, CarouselSharedModule, CarouselSharedComponent, CitySelectSharedModule, CitySelectSharedComponent, FooterSharedModule, GraphSharedModule, GraphSharedComponent, HeaderSharedModule, HeaderSharedComponent, InputCalendarSharedModule, InputCalendarSharedComponent, InputPostcodeLookupSharedModule, InputPostcodeLookupSharedComponent, InputPostcodeLookUpService, PostcodeLookUpServiceConfig, InputAddressLookupSharedModule, InputAddressLookupSharedComponent, InputAddressLookUpService, AddressLookUpServiceConfig, InputTimepickerSharedModule, InputTimepickerSharedComponent, LocationSelectSharedModule, LocationSelectSharedComponent, NotificationListSharedModule, NotificationListSharedComponent, SocialBannerSharedModule, SocialBannerSharedComponent, SubSectionSharedModule, SubHeaderSharedComponent, PasswordStrengthSharedModule, PasswordStrengthSharedComponent, CreditCardFormSharedModule, CreditCardFormSharedComponent, ANIMATIONS, fadeAnimation, fadeInAnimation, enterSlideUpAnimation, foldDownUpAnimation, fadeInFadeOutAnimation, ConfigureService, ConfigureModule, init, ClickOutsideDirective, ClickOutsideSharedDirectiveModule, InfiniteScrollService, InfiniteScrollDirective, InfiniteScrollSharedDirectiveModule, ImgServiceDirective, ImgServiceDirectiveModule, sortAlphanumericArray, EMAIL, DOUBLEAT, PHONENUMBER, V_PHONE_NUMBER, V_EMAIL, V_FULL_NAME, V_PASSWORD, V_PASSWORD_REPEAT, V_GUEST_CHECKOUT, V_GUEST_CHECKOUT_FULL_NAME, mlpEmailValidator, mlpPhoneNumberValidator, customNotEmptySpaceValidator, customSelectRequiredValidator, pfCreditCardValidator, PasswordStrength, Pitch, Venue, TransformDurationToTextPipe, TransformDurationToTextModule, TransformAgoPipe, TransformAgoModule, TransformCamelCaseEsportsPipe, TransformCamelCaseEsportsModule, TransformCapitalizeFirstPipe, TransformCapitalizeFirstModule, TransformDateNthPipe, TransformDateNthModule, TransformDurationPipe, TransformDurationModule, TransformSportToIconNamePipe, TransformSportIconModule, TransformTimePipe, TransformTimeModule, TransformApiData, ArrayService, BrowserService, WindowRefService, ButtonIconSharedComponent as ɵn, CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR as ɵa, INPUT_CUSTOM_INPUT_ACCESSOR as ɵb, RADIO_CUSTOM_INPUT_ACCESSOR as ɵc, AccordionContentComponent as ɵq, CC_CUSTOM_INPUT_ACCESSOR as ɵg, DatepickerSharedComponent as ɵs, DatepickerSharedModule as ɵr, EXPIRY_CUSTOM_INPUT_ACCESSOR$1 as ɵh, EXPIRY_CUSTOM_INPUT_ACCESSOR as ɵe, INPUT_CUSTOM_INPUT_ACCESSOR$1 as ɵd, INPUT_CUSTOM_INPUT_ACCESSOR$3 as ɵf, ModNgbTooltip as ɵt, MegaFooterSharedComponent as ɵu, INPUT_CUSTOM_INPUT_ACCESSOR$5 as ɵk, INPUT_CUSTOM_INPUT_ACCESSOR$2 as ɵi, INPUT_CUSTOM_INPUT_ACCESSOR$4 as ɵj, INPUT_CUSTOM_INPUT_ACCESSOR$6 as ɵl, INPUT_CUSTOM_INPUT_ACCESSOR$7 as ɵm, FnsFormatPipe as ɵp, FnsFormatPipeModule as ɵo };

//# sourceMappingURL=pf_styleguide.js.map